import * as React from 'react';
import React__default, { useState, useEffect, useMemo, Fragment, useRef, useCallback, createContext, useContext, isValidElement, cloneElement } from 'react';
import classNames from 'classnames';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation as Navigation$1, Pagination, Autoplay } from 'swiper/core';
import _ from 'lodash';
import $$1 from 'jquery';
import PropTypes from 'prop-types';
import IntlTelInput from 'react-intl-tel-input';
import { QRCodeSVG } from 'qrcode.react';
import { useSelector } from 'react-redux';

function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function () {
    return !!t;
  })();
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function (t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function (t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw new Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(typeof e + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function (e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function () {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function (e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw new Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function (t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function (t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    catch: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function (e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : String(i);
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/** defineGlobal just makes sure that nodeJS apps using toyota-common don't run
 * into a reference error when trying to safely access window properties(for
 * instance inside CONSTANTS file we have some non scope code trying to "safely"
 * access some properties of window but it's not safe if window isn't at least
 * defined as undefined... yes defined as undefined ;-)...) */
(function () {
  var _a;
  var isServer = (typeof global === "undefined" ? "undefined" : _typeof(global)) !== "undefined" && (typeof process === "undefined" ? "undefined" : _typeof(process)) !== "undefined" && Boolean((_a = process === null || process === void 0 ? void 0 : process.versions) === null || _a === void 0 ? void 0 : _a.node) &&
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  //@ts-ignore
  !(process === null || process === void 0 ? void 0 : process.browser); //this can be added by react and webpack
  if (isServer) {
    global.window = global.window || undefined;
  }
})();

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$D = ":root{--cp-disabled-arrow-opacity:0}.carouselNav .carousel-control.toyCo_CarouselNavigation-next-14215042,.carouselNav .carousel-control.toyCo_CarouselNavigation-prev-14315042{cursor:pointer;transition:opacity .3s linear}.carouselNav .carousel-control.toyCo_CarouselNavigation-disabled-14415042{opacity:var(--cp-disabled-arrow-opacity);pointer-events:none}.carouselNav .carousel-control.toyCo_CarouselNavigation-focus-14515042{border-radius:3px;outline:3px solid var(--cp-blue,#0072f0)}.carouselNav.toyCo_CarouselNavigation-outsideArrows-14615042{--outsideArrowsPosition:-74px}.carouselNav.toyCo_CarouselNavigation-outsideArrows-14615042 .carousel-control.toyCo_CarouselNavigation-prev-14315042{left:var(--outsideArrowsPosition)}.carouselNav.toyCo_CarouselNavigation-outsideArrows-14615042 .carousel-control.toyCo_CarouselNavigation-next-14215042{right:var(--outsideArrowsPosition)}.carouselNav.toyCo_CarouselNavigation-insideArrows-14715042{--insideArrowPosition:24px}.carouselNav.toyCo_CarouselNavigation-insideArrows-14715042 .carousel-control.toyCo_CarouselNavigation-prev-14315042{left:var(--insideArrowPosition)}.carouselNav.toyCo_CarouselNavigation-insideArrows-14715042 .carousel-control.toyCo_CarouselNavigation-next-14215042{right:var(--insideArrowPosition)}.carouselNav.toyCo_CarouselNavigation-firstSlideActive-14815042 .toyCo_CarouselNavigation-prev-14315042,.carouselNav.toyCo_CarouselNavigation-lastSlideActive-14915042 .toyCo_CarouselNavigation-next-14215042{opacity:var(--cp-disabled-arrow-opacity);pointer-events:none}@media (min-width:768px){.toyCo_CarouselNavigation-topArrowNavigation-15015042{--cp-arrow-control-w:20px;--cp-arrow-control-before-w:6px;--cp-disabled-arrow-opacity:0.5;--cp-arrow-control-left:calc(100% - 5px - var(--cp-arrow-control-w)*2);--cp-arrow-control-right:0;--cp-arrow-control-top:4px}.toyCo_CarouselNavigation-topArrowNavigation-15015042.toyCo_CarouselNavigation-arrowsBothUseless-15115042{--cp-disabled-arrow-opacity:0}}";
var styles$D = {"next":"toyCo_CarouselNavigation-next-14215042","prev":"toyCo_CarouselNavigation-prev-14315042","disabled":"toyCo_CarouselNavigation-disabled-14415042","focus":"toyCo_CarouselNavigation-focus-14515042","outsideArrows":"toyCo_CarouselNavigation-outsideArrows-14615042","insideArrows":"toyCo_CarouselNavigation-insideArrows-14715042","firstSlideActive":"toyCo_CarouselNavigation-firstSlideActive-14815042","lastSlideActive":"toyCo_CarouselNavigation-lastSlideActive-14915042","topArrowNavigation":"toyCo_CarouselNavigation-topArrowNavigation-15015042","arrowsBothUseless":"toyCo_CarouselNavigation-arrowsBothUseless-15115042"};
styleInject(css_248z$D);

var T1_CAROUSEL_SELECTORS = {
  T1_WRAPPER: "carouselNav",
  T1_ARROWS: {
    PREV: "left t1-arrow-control carousel-control",
    NEXT: "right t1-arrow-control carousel-control"
  }
};
var CarouselNavigation = function CarouselNavigation(_ref) {
  var prevUniqueSelector = _ref.prevUniqueSelector,
    nextUniqueSelector = _ref.nextUniqueSelector,
    shouldShowArrows = _ref.shouldShowArrows,
    shouldShowPagination = _ref.shouldShowPagination,
    shouldShowArrowsOutside = _ref.shouldShowArrowsOutside,
    isAtFirstPosition = _ref.isAtFirstPosition,
    isAtLastPosition = _ref.isAtLastPosition,
    shouldLoop = _ref.shouldLoop,
    currentPage = _ref.currentPage,
    totalPages = _ref.totalPages,
    testId = _ref.testId,
    disableArrows = _ref.disableArrows,
    _ref$onClickPrev = _ref.onClickPrev,
    onClickPrev = _ref$onClickPrev === void 0 ? function () {
      return undefined;
    } : _ref$onClickPrev,
    _ref$onClickNext = _ref.onClickNext,
    onClickNext = _ref$onClickNext === void 0 ? function () {
      return undefined;
    } : _ref$onClickNext,
    enableTopArrowNavigation = _ref.enableTopArrowNavigation;
  var T1_WRAPPER = T1_CAROUSEL_SELECTORS.T1_WRAPPER,
    T1_ARROWS = T1_CAROUSEL_SELECTORS.T1_ARROWS;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isPrevFocused = _useState2[0],
    setIsPrevFocused = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isNextFocused = _useState4[0],
    setIsNextFocused = _useState4[1];
  var isFirstSlideActive = isAtFirstPosition && !shouldLoop;
  var isLastSlideActive = isAtLastPosition && !shouldLoop;
  //@ts-expect-error will fix in CPBL-31212
  var renderPagination = shouldShowPagination && totalPages > 1;
  var renderArrows = shouldShowArrows;
  var renderNavigation = renderArrows || renderPagination;
  var arrowClassNames = enableTopArrowNavigation ? styles$D.topArrowNavigation : shouldShowArrowsOutside ? styles$D.outsideArrows : styles$D.insideArrows;
  return renderNavigation ? ( /*#__PURE__*/React__default.createElement("nav", {
    className: classNames(T1_WRAPPER, arrowClassNames, _defineProperty(_defineProperty(_defineProperty({}, styles$D.firstSlideActive, isFirstSlideActive), styles$D.lastSlideActive, isLastSlideActive), styles$D.arrowsBothUseless, isFirstSlideActive && isLastSlideActive))
  }, renderArrows && ( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("button", {
    "data-test-id": "".concat(testId, "-prev"),
    onClick: onClickPrev,
    className: classNames(T1_ARROWS.PREV, styles$D.prev, prevUniqueSelector, _defineProperty({}, styles$D.disabled, disableArrows), isPrevFocused && styles$D.focus),
    onFocus: function onFocus() {
      return setIsPrevFocused(true);
    },
    onBlur: function onBlur() {
      return setIsPrevFocused(false);
    },
    tabIndex: isFirstSlideActive ? -1 : 0,
    "aria-label": "previous"
  }), /*#__PURE__*/React__default.createElement("button", {
    "data-test-id": "".concat(testId, "-next"),
    onClick: onClickNext,
    className: classNames(T1_ARROWS.NEXT, styles$D.next, nextUniqueSelector, _defineProperty({}, styles$D.disabled, disableArrows), isNextFocused && styles$D.focus),
    onFocus: function onFocus() {
      return setIsNextFocused(true);
    },
    onBlur: function onBlur() {
      return setIsNextFocused(false);
    },
    tabIndex: isLastSlideActive ? -1 : 0,
    "aria-label": "next"
  }))), renderPagination && ( /*#__PURE__*/React__default.createElement("div", {
    className: "slide-counter"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "counter-bg"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "current-index"
  }, currentPage), "\xA0/\xA0", totalPages))))) : null;
};

var css_248z$C = ":root{--toyCo-carousel-pagination-outside-top:35px}.toyCo_Carousel-progressPagination-115042:is(.dxp-toyota *){--cp-progressbar-fill-color:var(--cp-red)}.toyCo_Carousel-progressPagination-115042:is(.dxp-lexus *){--cp-progressbar-fill-color:var(--cp-blue-dark)}.toyCo_Carousel-progressPagination-115042 .swiper-container>.swiper-pagination-progressbar{background-color:var(--cp-progressbar-bg-color-override,var(--cp-grey-light));bottom:auto;left:auto;max-width:200px;right:0;width:20%}@media (min-width:1200px){.toyCo_Carousel-progressPagination-115042 .swiper-container>.swiper-pagination-progressbar{margin-right:10%}}.toyCo_Carousel-progressPagination-115042 .swiper-wrapper{padding-top:var(--toyCo-carousel-pagination-outside-top)}.toyCo_Carousel-progressPagination-115042 .swiper-container>.swiper-pagination-progressbar>.swiper-pagination-progressbar-fill{background:var(--cp-progressbar-fill-color)}.toyCo_Carousel-paginationNumberBelow-215042{margin-bottom:8px;padding-bottom:70px}.toyCo_Carousel-paginationNumberBelow-215042 .t1-arrow-control{top:calc(50% - 60px)}.toyCo_Carousel-paginationDotAbove-315042 .swiper-container{padding-top:var(--toyCo-carousel-pagination-outside-top)}.toyCo_Carousel-paginationDotAbove-315042 .swiper-pagination{bottom:auto;top:0}.toyCo_Carousel-spaceForNavAbove-415042 .swiper-container{margin-top:calc(var(--toyCo-carousel-pagination-outside-top)*-1);padding-top:var(--toyCo-carousel-pagination-outside-top)}.toyCo_Carousel-paginationDotBelow-515042 .swiper-container{padding-bottom:var(--toyCo-carousel-pagination-outside-top)}.toyCo_Carousel-paginationDotBelow-515042 .swiper-pagination{bottom:var(--cp-dots-below-bottom,0)}@media only screen and (min-width:768px){.toyCo_Carousel-arrowsOutside-615042{margin-left:78px;margin-right:78px}}.toyCo_Carousel-swiperCarousel-715042{--cp-swiper-pagination-bullet-bg:var(--cp-grey-dark,#282830);position:relative}.toyCo_Carousel-swiperCarousel-715042 .swiper-pagination-bullet,.toyCo_Carousel-swiperCarousel-715042 .swiper-pagination-bullet-active{background-color:var(--cp-swiper-pagination-bullet-bg)}.swiper-slide.toyCo_Carousel-equalizeSlideHeights-815042{height:auto}.swiper-slide.toyCo_Carousel-equalizeSlideHeights-815042>*{height:100%}@media (min-width:768px){.toyCo_Carousel-leftFade-915042{background:linear-gradient(-90deg,hsla(0,0%,100%,0),#fff 65%);left:-5px}.toyCo_Carousel-rightFade-1015042{background:linear-gradient(90deg,hsla(0,0%,100%,0),#fff 65%);right:-5px}}.toyCo_Carousel-fade-1115042{display:none}@media (min-width:768px){.toyCo_Carousel-fade-1115042{display:block;height:100%;position:absolute;width:50px;z-index:2}}";
var styles$C = {"progressPagination":"toyCo_Carousel-progressPagination-115042","paginationNumberBelow":"toyCo_Carousel-paginationNumberBelow-215042","paginationDotAbove":"toyCo_Carousel-paginationDotAbove-315042","spaceForNavAbove":"toyCo_Carousel-spaceForNavAbove-415042","paginationDotBelow":"toyCo_Carousel-paginationDotBelow-515042","arrowsOutside":"toyCo_Carousel-arrowsOutside-615042","swiperCarousel":"toyCo_Carousel-swiperCarousel-715042","equalizeSlideHeights":"toyCo_Carousel-equalizeSlideHeights-815042","leftFade":"toyCo_Carousel-leftFade-915042","rightFade":"toyCo_Carousel-rightFade-1015042","fade":"toyCo_Carousel-fade-1115042"};
styleInject(css_248z$C);

var ALLIANCE_BRANDS = {
  SUBARU: "SUBARU"
};
var BRAND = {
  TOYOTA: "TOYOTA",
  LEXUS: "LEXUS"
};
var BOOTSTRAP = {
  BREAKPOINTS: {
    EXTRA_SMALL: {
      NAME: "XS",
      MIN_SIZE: 0
    },
    SMALL: {
      NAME: "SM",
      MIN_SIZE: 768
    },
    MEDIUM: {
      NAME: "MD",
      MIN_SIZE: 992
    },
    LARGE: {
      NAME: "LG",
      MIN_SIZE: 1200
    }
  }
};
var BOOTSTRAP_V5 = {
  BREAKPOINTS: {
    EXTRA_SMALL: {
      NAME: "XS",
      MIN_SIZE: 0
    },
    SMALL: {
      NAME: "SM",
      MIN_SIZE: 576
    },
    MEDIUM: {
      NAME: "MD",
      MIN_SIZE: 768
    },
    LARGE: {
      NAME: "LG",
      MIN_SIZE: 992
    },
    EXTRA_LARGE: {
      NAME: "XL",
      MIN_SIZE: 1200
    },
    EXTRA_EXTRA_LARGE: {
      NAME: "XXL",
      MIN_SIZE: 1400
    }
  }
};
var CAROUSEL_CONSTANTS = {
  DEFAULT_SPEED_MS: 600,
  PAGINATION_TYPES: {
    DOT: "dot",
    NUMBER: "number",
    PROGRESS: "progressbar"
  }
};
var CHECKOUT_CONSTANTS = {
  BUILD_STEPS: {
    CUSTOMIZE: "customize",
    SUMMARY: "summary"
  },
  CAR_TYPE_QUERY_STRING_PARAM: 'carType',
  CAR_TYPES: {
    NEW_CARS: 'newCars',
    USED_CARS: 'usedCars',
    STOCK_CARS: 'stockCars',
    ACTIVE_BASKET_CARS: 'activeBasketCars',
    PURCHASED_CARS: 'purchasedCars',
    USED_ORDERED_CARS: "usedOrderedCars",
    STOCK_ORDERED_CARS: "stockOrderedCars"
  },
  COOKIES: {
    RESERVE_TO_BUY_KEY: "reserveToBuy"
  },
  FINANCE_PROVIDER: {
    MAKOLAB: "makolab"
  },
  FINANCE_STATUS: {
    PRE_APPROVED: "financing.preapproved",
    REFERRED: "financing.referred"
  },
  PAYMENT_METHOD: {
    CASH: 'cash',
    MONTHLY: 'monthly',
    LEASING: 'leasing'
  },
  RESERVATION_FEE_KEY: 'ReservationFee',
  RESERVE_QUERY_STRING_PARAM: 'reserve',
  PURCHASE_TYPE: {
    BUY: 'buy',
    RESERVE: 'reserve',
    ONLINE_RETAIL: 'onlineRetail'
  },
  SERVICES: ["NONFIN-SERVICE", "NONFIN-SERVICE-ONLINE", "FIN-SERVICE", "FIN-SERVICE-ONLINE"],
  LOCAL_STORAGE: {
    KEYS: {
      TOKEN: 'com.toyota.tme.user.token'
    }
  }
};
var CONSENT_TYPES = {
  PAN_E: ["reminders", "offers", "surveys", "events", "eventsSurveys", "offersSurveys", "offersEvents", "remindersSurveys", "remindersEvents", "remindersOffers", "offersEventsSurveys", "remindersEventsSurveys", "remindersOffersSurveys", "remindersOffersEvents", "remindersOffersEventsSurveys"],
  LOCAL_LEGAL_CONSENT: ["profiling"],
  PREFERRED_CHANNEL: ["mail", "email", "sms", "phone"],
  ERRORS: {
    NOT_AVAILABLE: 404
  }
};
var ENVIRONMENTS = {
  L1: 'L1',
  T1: 'T1',
  DXPLEXUS: 'dxpLexus',
  DXPTOYOTA: 'dxpToyota',
  ALL: 'all'
};
var HTTP_METHOD = {
  GET: "GET",
  PUT: "PUT",
  POST: "POST",
  DELETE: "DELETE"
};
var LOCALE = typeof window !== 'undefined' && _.get(window, "dxp.settings.language") + "-" + _.get(window, "dxp.settings.country");
var LOCAL_STORAGE_KEYS = {
  TOKEN: "com.toyota.tme.user.token",
  CUSTOMER_PROFILE: 'com.toyota.tme.user.customerProfile',
  MARKETING: 'com.toyota.tme.user.marketing',
  TOKEN_EXPIRES_AT: 'com.toyota.tme.user.token_expires_at'
};
var STORAGE_LABELS = {
  TTL_MILLISECONDS: 300000,
  // 5 minutes
  KEYS: {
    get CONFIGURATION() {
      return "com.".concat(_.toLower(_.get(window, "dxp.settings.brand") || BRAND.TOYOTA), ".tme.cp.labels.configuration.").concat(LOCALE);
    },
    get CP_UI_MENU() {
      return "com.".concat(_.toLower(_.get(window, "dxp.settings.brand") || BRAND.TOYOTA), ".tme.cp.labels.cp-ui-menu.").concat(LOCALE);
    },
    get CP_UI_LEAD_AND_ORDERED_VEHICLE_DETAILS() {
      return "com.".concat(_.toLower(_.get(window, "dxp.settings.brand") || BRAND.TOYOTA), ".tme.cp.labels.cp-lead-and-ordered-vehicle-details-ui-content.").concat(LOCALE);
    },
    get CP_UI_OWNED_VEHICLE_DETAILS() {
      return "com.".concat(_.toLower(_.get(window, "dxp.settings.brand") || BRAND.TOYOTA), ".tme.cp.labels.cp-ownedvehicledetails-ui-content.").concat(LOCALE);
    },
    get CP_UI_COMMON() {
      return "com.".concat(_.toLower(_.get(window, "dxp.settings.brand") || BRAND.TOYOTA), ".tme.cp.labels.cp-common-content.").concat(LOCALE);
    },
    get CP_UI_VEHICLES_OVERVIEW() {
      return "com.".concat(_.toLower(_.get(window, "dxp.settings.brand") || BRAND.TOYOTA), ".tme.cp.labels.cp-vehiclesoverview-ui-content.").concat(LOCALE);
    },
    get CP_UI_GUEST_DASHBOARD() {
      return "com.".concat(_.toLower(_.get(window, "dxp.settings.brand") || BRAND.TOYOTA), ".tme.cp.labels.cp-guestdashboard-ui-content.").concat(LOCALE);
    },
    get CP_NMSC_CONFIGURATION() {
      return "com.".concat(_.toLower(_.get(window, "dxp.settings.brand") || BRAND.TOYOTA), ".tme.cp.labels.cp-nmsc-configuration-content.").concat(LOCALE);
    },
    get CP_ONE_TRUST() {
      return "com.".concat(_.toLower(_.get(window, "dxp.settings.brand") || BRAND.TOYOTA), ".tme.cp.labels.cp-consentcenterot-content.").concat(LOCALE);
    }
  }
};
var MODELS = {
  BZ_4X: {
    NAME: 'bz4x'
  }
};
var PROGRESS_STATUS = {
  IDLE: "idle",
  STARTED: "started",
  SUCCESS: "success",
  FAILED: "failed"
};
var SSO = {
  HASH_PARAMETERS: {
    APP_ID: 'appID',
    HIDE_LOGIN_OPTION: 'hideLoginOption',
    MODEL: 'model',
    ORDER_ID: 'orderId',
    DISABLE_EMAIL: 'disableEmail',
    REDIRECTION_PATH: 'redirectionPath',
    RESERVATION_CODE: 'reservationCode',
    CONTEXT_NAME: 'contextName'
  }
};
var TRIDION_LABEL_MISSING = "Translation missing";
var ASSETS = {
  MY_T_APP_ANDROID: '/cp-client/images/cp/mobileStores/PlayStore.png',
  MY_T_APP_APPLE: '/cp-client/images/cp/mobileStores/AppStore.png'
};
var ONE_APP_CONSTANTS = {
  FALLBACK_NEW_APPLE: "https://apps.apple.com/app/toyota-myt/id1617623127",
  FALLBACK_NEW_PLAY: "https://play.google.com/store/apps/details?id=com.toyota.oneapp.eu",
  FALLBACK_LEXUS_NEW_APPLE: "https://apps.apple.com/app/lexus-link/id1618744308",
  FALLBACK_LEXUS_NEW_PLAY: "https://play.google.com/store/apps/details?id=com.lexus.oneapp.eu"
};

var _COMMON_CONSTANTS = /*#__PURE__*/Object.freeze({
  __proto__: null,
  ALLIANCE_BRANDS: ALLIANCE_BRANDS,
  BRAND: BRAND,
  BOOTSTRAP: BOOTSTRAP,
  BOOTSTRAP_V5: BOOTSTRAP_V5,
  CAROUSEL_CONSTANTS: CAROUSEL_CONSTANTS,
  CHECKOUT_CONSTANTS: CHECKOUT_CONSTANTS,
  CONSENT_TYPES: CONSENT_TYPES,
  ENVIRONMENTS: ENVIRONMENTS,
  HTTP_METHOD: HTTP_METHOD,
  LOCALE: LOCALE,
  LOCAL_STORAGE_KEYS: LOCAL_STORAGE_KEYS,
  STORAGE_LABELS: STORAGE_LABELS,
  MODELS: MODELS,
  PROGRESS_STATUS: PROGRESS_STATUS,
  SSO: SSO,
  TRIDION_LABEL_MISSING: TRIDION_LABEL_MISSING,
  ASSETS: ASSETS,
  ONE_APP_CONSTANTS: ONE_APP_CONSTANTS
});

var _BOOTSTRAP$BREAKPOINT$1 = BOOTSTRAP.BREAKPOINTS,
  XS = _BOOTSTRAP$BREAKPOINT$1.EXTRA_SMALL.NAME,
  _BOOTSTRAP$BREAKPOINT2 = _BOOTSTRAP$BREAKPOINT$1.SMALL,
  SM_RESOLUTION_V3 = _BOOTSTRAP$BREAKPOINT2.MIN_SIZE,
  SM = _BOOTSTRAP$BREAKPOINT2.NAME,
  _BOOTSTRAP$BREAKPOINT3 = _BOOTSTRAP$BREAKPOINT$1.MEDIUM,
  MD_RESOLUTION_V3 = _BOOTSTRAP$BREAKPOINT3.MIN_SIZE,
  MD = _BOOTSTRAP$BREAKPOINT3.NAME,
  _BOOTSTRAP$BREAKPOINT4 = _BOOTSTRAP$BREAKPOINT$1.LARGE,
  LG_RESOLUTION_V3 = _BOOTSTRAP$BREAKPOINT4.MIN_SIZE,
  LG = _BOOTSTRAP$BREAKPOINT4.NAME;
var _BOOTSTRAP_V5$BREAKPO$1 = BOOTSTRAP_V5.BREAKPOINTS,
  SM_RESOLUTION_V5 = _BOOTSTRAP_V5$BREAKPO$1.SMALL.MIN_SIZE,
  MD_RESOLUTION_V5 = _BOOTSTRAP_V5$BREAKPO$1.MEDIUM.MIN_SIZE,
  LG_RESOLUTION_V5 = _BOOTSTRAP_V5$BREAKPO$1.LARGE.MIN_SIZE,
  _BOOTSTRAP_V5$BREAKPO2 = _BOOTSTRAP_V5$BREAKPO$1.EXTRA_LARGE,
  XL_RESOLUTION_V5 = _BOOTSTRAP_V5$BREAKPO2.MIN_SIZE,
  XL = _BOOTSTRAP_V5$BREAKPO2.NAME,
  _BOOTSTRAP_V5$BREAKPO3 = _BOOTSTRAP_V5$BREAKPO$1.EXTRA_EXTRA_LARGE,
  XXL_RESOLUTION_V5 = _BOOTSTRAP_V5$BREAKPO3.MIN_SIZE,
  XXL = _BOOTSTRAP_V5$BREAKPO3.NAME;
/**
 * @function isMobileBreakpoint
 * @description returns true if the breakpoint is considered as mobile(xs for bootstrap3, xs and
 *  sm if bootstrap 5... so anything under 768px)
 * @returns {boolean}
 */
var isMobileBreakpoint = function isMobileBreakpoint() {
  return window.innerWidth < SM_RESOLUTION_V3;
};
var isXsBreakpoint = function isXsBreakpoint(useBootstrap5) {
  return useBootstrap5 ? window.innerWidth < SM_RESOLUTION_V5 : window.innerWidth < SM_RESOLUTION_V3;
};
var isSmBreakpoint = function isSmBreakpoint(useBootstrap5) {
  var SM_RESOLUTION = useBootstrap5 ? SM_RESOLUTION_V5 : SM_RESOLUTION_V3;
  var MD_RESOLUTION = useBootstrap5 ? MD_RESOLUTION_V5 : MD_RESOLUTION_V3;
  return window.innerWidth >= SM_RESOLUTION && window.innerWidth < MD_RESOLUTION;
};
var isMdBreakpoint = function isMdBreakpoint(useBootstrap5) {
  var MD_RESOLUTION = useBootstrap5 ? MD_RESOLUTION_V5 : MD_RESOLUTION_V3;
  var LG_RESOLUTION = useBootstrap5 ? LG_RESOLUTION_V5 : LG_RESOLUTION_V3;
  return window.innerWidth >= MD_RESOLUTION && window.innerWidth < LG_RESOLUTION;
};
var isLgBreakpoint = function isLgBreakpoint(useBootstrap5) {
  return useBootstrap5 ? window.innerWidth >= LG_RESOLUTION_V5 && window.innerWidth < XL_RESOLUTION_V5 : window.innerWidth >= LG_RESOLUTION_V3;
};
var isXlBreakpoint = function isXlBreakpoint() {
  return window.innerWidth >= XL_RESOLUTION_V5 && window.innerWidth < XXL_RESOLUTION_V5;
};
var isXxlBreakpoint = function isXxlBreakpoint() {
  return window.innerWidth >= XXL_RESOLUTION_V5;
};
/**
 * @function getBreakpointInfo
 * @description This function returns bootstrap 3 related data such as the breakpointName and
 * if the breakpoint isXs, isSm, ... You can also pass an option useBootstrap5 if you need the breakpoints
 * to match version 5
 */
var getBreakpointInfo = function getBreakpointInfo(options) {
  var breakpointInfo = Object.assign(Object.assign({
    isMobileBreakpoint: isMobileBreakpoint(),
    isXs: isXsBreakpoint(options === null || options === void 0 ? void 0 : options.useBootstrap5),
    isSm: isSmBreakpoint(options === null || options === void 0 ? void 0 : options.useBootstrap5),
    isMd: isMdBreakpoint(options === null || options === void 0 ? void 0 : options.useBootstrap5),
    isLg: isLgBreakpoint(options === null || options === void 0 ? void 0 : options.useBootstrap5)
  }, (options === null || options === void 0 ? void 0 : options.useBootstrap5) ? {
    isXl: isXlBreakpoint()
  } : {}), (options === null || options === void 0 ? void 0 : options.useBootstrap5) ? {
    isXxl: isXxlBreakpoint()
  } : {});
  return Object.assign(Object.assign({}, breakpointInfo), {
    breakpointName: getBreakpointName(breakpointInfo)
  });
};
var getBreakpointName = function getBreakpointName(breakpointInfo) {
  var isXs = breakpointInfo.isXs,
    isSm = breakpointInfo.isSm,
    isMd = breakpointInfo.isMd,
    isLg = breakpointInfo.isLg,
    isXl = breakpointInfo.isXl;
  return isXs ? XS : isSm ? SM : isMd ? MD : isLg ? LG : isXl ? XL : XXL;
};

var _BOOTSTRAP$BREAKPOINT = BOOTSTRAP.BREAKPOINTS,
  SMALL_V3 = _BOOTSTRAP$BREAKPOINT.SMALL,
  MEDIUM_V3 = _BOOTSTRAP$BREAKPOINT.MEDIUM,
  LARGE_V3 = _BOOTSTRAP$BREAKPOINT.LARGE;
var _BOOTSTRAP_V5$BREAKPO = BOOTSTRAP_V5.BREAKPOINTS,
  SMALL_V5 = _BOOTSTRAP_V5$BREAKPO.SMALL,
  MEDIUM_V5 = _BOOTSTRAP_V5$BREAKPO.MEDIUM,
  LARGE_V5 = _BOOTSTRAP_V5$BREAKPO.LARGE,
  EXTRA_LARGE = _BOOTSTRAP_V5$BREAKPO.EXTRA_LARGE,
  EXTRA_EXTRA_LARGE = _BOOTSTRAP_V5$BREAKPO.EXTRA_EXTRA_LARGE;
var _CAROUSEL_CONSTANTS$P = CAROUSEL_CONSTANTS.PAGINATION_TYPES,
  DOT = _CAROUSEL_CONSTANTS$P.DOT,
  NUMBER = _CAROUSEL_CONSTANTS$P.NUMBER,
  PROGRESS$1 = _CAROUSEL_CONSTANTS$P.PROGRESS;
var breakpointsMap = function breakpointsMap(carouselOptions) {
  return _objectSpread2({
    SM: carouselOptions !== null && carouselOptions !== void 0 && carouselOptions.useBootstrap5 ? SMALL_V5 : SMALL_V3,
    MD: carouselOptions !== null && carouselOptions !== void 0 && carouselOptions.useBootstrap5 ? MEDIUM_V5 : MEDIUM_V3,
    LG: carouselOptions !== null && carouselOptions !== void 0 && carouselOptions.useBootstrap5 ? LARGE_V5 : LARGE_V3
  }, carouselOptions !== null && carouselOptions !== void 0 && carouselOptions.useBootstrap5 ? {
    XL: EXTRA_LARGE,
    XXL: EXTRA_EXTRA_LARGE
  } : {});
};
var mapBreakpointOption = function mapBreakpointOption(_ref, mobileFirstOptions) {
  var breakpointOption = _ref.breakpointOption,
    scrollPerPage = _ref.scrollPerPage;
  if (!breakpointOption || _typeof(breakpointOption) !== "object") {
    return;
  }
  return _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, _.omit(breakpointOption, ["numberOfSlidesInView", "spacingBetweenItems", "renderChildrenOnly", "shouldCenterActiveSlide"])), _typeof(breakpointOption === null || breakpointOption === void 0 ? void 0 : breakpointOption.spacingBetweenItems) === "number" ? {
    spaceBetween: breakpointOption.spacingBetweenItems
  } : {}), breakpointOption !== null && breakpointOption !== void 0 && breakpointOption.shouldCenterActiveSlide ? {
    centeredSlides: breakpointOption === null || breakpointOption === void 0 ? void 0 : breakpointOption.shouldCenterActiveSlide
  } : {}), {}, {
    slidesPerView: (breakpointOption === null || breakpointOption === void 0 ? void 0 : breakpointOption.numberOfSlidesInView) || (mobileFirstOptions === null || mobileFirstOptions === void 0 ? void 0 : mobileFirstOptions.numberOfSlidesInView) || 1,
    slidesPerGroup: scrollPerPage && (breakpointOption === null || breakpointOption === void 0 ? void 0 : breakpointOption.numberOfSlidesInView) || 1
  });
};
var mapBreakpointOptions = function mapBreakpointOptions(_ref2) {
  var breakpointOptions = _ref2.breakpointOptions,
    scrollPerPage = _ref2.scrollPerPage,
    mobileFirstOptions = _ref2.mobileFirstOptions;
  if (!breakpointOptions || _.isEmpty(breakpointOptions)) {
    return {};
  }
  return _.reduce(breakpointsMap(mobileFirstOptions), function (result, breakpoint, option) {
    var breakpointOption = breakpointOptions[option];
    if (breakpointOption) {
      result[breakpoint.MIN_SIZE] = mapBreakpointOption({
        breakpointOption: breakpointOption,
        scrollPerPage: scrollPerPage
      }, mobileFirstOptions);
    }
    return result;
  }, {});
};
var makeLastPageOfSlidesFullPage = function makeLastPageOfSlidesFullPage(_ref3) {
  var swiperInstance = _ref3.swiperInstance,
    numberOfSlidesInViewForBreakpoint = _ref3.numberOfSlidesInViewForBreakpoint,
    originalNumberOfSlides = _ref3.originalNumberOfSlides;
  if (!swiperInstance || !!(swiperInstance !== null && swiperInstance !== void 0 && swiperInstance.destroyed)) {
    return false;
  }

  // "swiperInstance.slides" is inconsistent in Lexus environment for some reason.
  // Perhaps a problem with a mutual dependency?
  //
  // The following line is a workaround. In the original library (v.6.7.1) they use a utility function "extend":
  // https://github.com/nolimits4web/swiper/blob/97ac631cc444ffa72448de19e22cd0eaf1b42605/src/components/core/update/updateSlides.js#L318
  //
  // For some reason, however, the swiper instance we use here is unaffected in Lexus and the length remains 0 even
  // when there are children (slides). On Toyota these values are always the same and, if you take a look at the code, they
  // should:
  // https://github.com/nolimits4web/swiper/blob/97ac631cc444ffa72448de19e22cd0eaf1b42605/src/components/core/update/updateSlides.js#L30
  //
  // That line was later changed to use Object.assign in a newer version (v7.0.2). Perhaps it solves our problem too?
  // https://github.com/nolimits4web/swiper/commit/71dc7d85a60de440a8f90bf78a6904d522fbad20#diff-b07f5bb3d3704550e950186dbcc72c3ae47c43bc62ec2201334ac3c497217c10R313
  swiperInstance.slides = swiperInstance.$wrapperEl.children(".swiper-slide");
  var highestSlideIndex = swiperInstance.slides.length - 1;
  var blankSlideClass = "swiper-slide-invisible-blank";
  for (var index = highestSlideIndex; index >= 0; index--) {
    var swiperSlide = swiperInstance.slides[index];
    if (swiperSlide.classList.contains(blankSlideClass)) {
      swiperInstance.removeSlide(index);
    }
  }
  var slidesOnLastPage = originalNumberOfSlides % numberOfSlidesInViewForBreakpoint;
  var slidesToAdd = slidesOnLastPage > 0 ? numberOfSlidesInViewForBreakpoint - slidesOnLastPage : 0;
  while (slidesToAdd > 0) {
    swiperInstance.appendSlide("<div class=\"swiper-slide ".concat(blankSlideClass, "\"></div>"));
    slidesToAdd--;
  }
  return true;
};
var getCarouselPaginationClassNames = function getCarouselPaginationClassNames(navigationOptions, styles) {
  var _ref4 = navigationOptions || {},
    shouldShowPagination = _ref4.shouldShowPagination,
    shouldShowPaginationBelow = _ref4.shouldShowPaginationBelow,
    shouldShowPaginationAbove = _ref4.shouldShowPaginationAbove,
    paginationType = _ref4.paginationType;
  var shouldUseDotPagination = !!(shouldShowPagination && paginationType === DOT);
  var shouldUseProgressPagination = !!(shouldShowPagination && paginationType === PROGRESS$1);
  var paginationBelowClassName = (shouldShowPaginationBelow ? shouldUseDotPagination ? styles.paginationDotBelow : styles.paginationNumberBelow : "") || "";
  var paginationAboveClassName = (shouldShowPaginationAbove ? shouldUseDotPagination ? styles.paginationDotAbove : "" : "") || "";
  var progressPaginationClassName = shouldUseProgressPagination ? styles.progressPagination : "";
  return "".concat(paginationBelowClassName, " ").concat(paginationAboveClassName, " ").concat(progressPaginationClassName);
};
var getPaginationOptions = function getPaginationOptions(paginationType, navigationOptions) {
  var shouldShowPagination = Boolean(navigationOptions === null || navigationOptions === void 0 ? void 0 : navigationOptions.shouldShowPagination);
  if (!shouldShowPagination) {
    return false;
  }
  var options;
  switch (paginationType) {
    case NUMBER:
      options = false;
      break;
    case DOT:
      options = _.get(navigationOptions, "dotPaginationOptions", shouldShowPagination);
      break;
    case PROGRESS$1:
      options = _.get(navigationOptions, "progressPaginationOptions", false);
      break;
    default:
      options = false;
      break;
  }
  return options;
};
var getInitialSlidesAndSpacing = function getInitialSlidesAndSpacing() {
  var breakpointsOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var numberOfSlides = arguments.length > 1 ? arguments[1] : undefined;
  var spacingBetweenItems = arguments.length > 2 ? arguments[2] : undefined;
  var useBootstrap5 = arguments.length > 3 ? arguments[3] : undefined;
  var currentBreakpoint = getBreakpointInfo({
    useBootstrap5: useBootstrap5
  }).breakpointName;
  return {
    slides: _.get(breakpointsOptions, "".concat(currentBreakpoint, ".numberOfSlidesInView"), numberOfSlides),
    spacing: _.get(breakpointsOptions, "".concat(currentBreakpoint, ".spacingBetweenItems"), spacingBetweenItems)
  };
};

var useTotalPages = function useTotalPages(_ref) {
  var _ref$children = _ref.children,
    children = _ref$children === void 0 ? [] : _ref$children,
    _ref$numberOfSlidesIn = _ref.numberOfSlidesInViewForBreakpoint,
    numberOfSlidesInViewForBreakpoint = _ref$numberOfSlidesIn === void 0 ? 1 : _ref$numberOfSlidesIn,
    _ref$scrollPerPage = _ref.scrollPerPage,
    scrollPerPage = _ref$scrollPerPage === void 0 ? false : _ref$scrollPerPage;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    totalPages = _useState2[0],
    setTotalPages = _useState2[1];
  useEffect(function () {
    var totalPages;
    if ((children === null || children === void 0 ? void 0 : children.length) <= numberOfSlidesInViewForBreakpoint) {
      totalPages = 1;
    } else if (scrollPerPage) {
      totalPages = Math.ceil((children === null || children === void 0 ? void 0 : children.length) / numberOfSlidesInViewForBreakpoint);
    } else {
      totalPages = children === null || children === void 0 ? void 0 : children.length;
    }
    setTotalPages(totalPages);
  }, [children, numberOfSlidesInViewForBreakpoint, scrollPerPage]);
  return totalPages;
};
var useCurrentPage = function useCurrentPage(_ref2) {
  var _ref2$activeSlide = _ref2.activeSlide,
    activeSlide = _ref2$activeSlide === void 0 ? 1 : _ref2$activeSlide,
    _ref2$numberOfSlidesI = _ref2.numberOfSlidesInViewForBreakpoint,
    numberOfSlidesInViewForBreakpoint = _ref2$numberOfSlidesI === void 0 ? 1 : _ref2$numberOfSlidesI,
    _ref2$shouldShowPagin = _ref2.shouldShowPagination,
    shouldShowPagination = _ref2$shouldShowPagin === void 0 ? false : _ref2$shouldShowPagin,
    _ref2$scrollPerPage = _ref2.scrollPerPage,
    scrollPerPage = _ref2$scrollPerPage === void 0 ? false : _ref2$scrollPerPage;
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    currentPage = _useState4[0],
    setCurrentPage = _useState4[1];
  useEffect(function () {
    if (!shouldShowPagination) {
      return;
    }
    var currentPage;
    if (scrollPerPage) {
      currentPage = Math.ceil(activeSlide / numberOfSlidesInViewForBreakpoint);
    } else {
      currentPage = activeSlide;
    }
    setCurrentPage(currentPage);
  }, [activeSlide, numberOfSlidesInViewForBreakpoint, shouldShowPagination, scrollPerPage]);
  return currentPage;
};
var useIsFirstIsLastPosition = function useIsFirstIsLastPosition(numberOfSlidesInViewForBreakpoint, children, swiperInstance, activeSlide) {
  var _useState5 = useState(true),
    _useState6 = _slicedToArray(_useState5, 2),
    isAtFirstPosition = _useState6[0],
    setIsAtFirstPosition = _useState6[1];
  var _useState7 = useState(true),
    _useState8 = _slicedToArray(_useState7, 2),
    isAtLastPosition = _useState8[0],
    setIsAtLastPosition = _useState8[1];
  useEffect(function () {
    if (numberOfSlidesInViewForBreakpoint >= (children === null || children === void 0 ? void 0 : children.length) && numberOfSlidesInViewForBreakpoint !== "auto") {
      setIsAtFirstPosition(true);
      setIsAtLastPosition(true);
    } else {
      setIsAtFirstPosition(!!(swiperInstance !== null && swiperInstance !== void 0 && swiperInstance.isBeginning) || (swiperInstance === null || swiperInstance === void 0 ? void 0 : swiperInstance.realIndex) === 0);
      setIsAtLastPosition(!!(swiperInstance !== null && swiperInstance !== void 0 && swiperInstance.isEnd));
    }
  }, [numberOfSlidesInViewForBreakpoint, children, swiperInstance, activeSlide]);
  return {
    isAtFirstPosition: isAtFirstPosition,
    isAtLastPosition: isAtLastPosition
  };
};
var useScrollPerPage = function useScrollPerPage(scrollPerPage, shouldLoop, numberOfSlidesInViewForBreakpoint, originalNumberOfSlides, swiperInstance) {
  useEffect(function () {
    if (!scrollPerPage || shouldLoop) {
      return;
    }

    //adding or removing dummy slides to make the last page a full page of slides
    makeLastPageOfSlidesFullPage({
      numberOfSlidesInViewForBreakpoint: numberOfSlidesInViewForBreakpoint,
      originalNumberOfSlides: originalNumberOfSlides,
      swiperInstance: swiperInstance
    });
  }, [swiperInstance, scrollPerPage, numberOfSlidesInViewForBreakpoint, shouldLoop, originalNumberOfSlides]);
};
var useInitialSlidesAndSpacing = function useInitialSlidesAndSpacing() {
  var initialSlidesAndSpacing = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _useState9 = useState(initialSlidesAndSpacing.slides || 1),
    _useState10 = _slicedToArray(_useState9, 2),
    numberOfSlidesInViewForBreakpoint = _useState10[0],
    setNumberOfSlidesInViewForBreakpoint = _useState10[1];
  var _useState11 = useState(initialSlidesAndSpacing.spacing || 0),
    _useState12 = _slicedToArray(_useState11, 2),
    spacingSizeBetweenSlidesForBreakpoint = _useState12[0],
    setSpacingBetweenSlidesForBreakpoint = _useState12[1];
  useEffect(function () {
    var slides = initialSlidesAndSpacing.slides;
    var spacing = initialSlidesAndSpacing.spacing;
    if (slides && spacing) {
      setNumberOfSlidesInViewForBreakpoint(slides);
      setSpacingBetweenSlidesForBreakpoint(spacing);
    }
  }, [initialSlidesAndSpacing]);
  return {
    numberOfSlidesInViewForBreakpoint: numberOfSlidesInViewForBreakpoint,
    spacingSizeBetweenSlidesForBreakpoint: spacingSizeBetweenSlidesForBreakpoint,
    setNumberOfSlidesInViewForBreakpoint: setNumberOfSlidesInViewForBreakpoint,
    setSpacingBetweenSlidesForBreakpoint: setSpacingBetweenSlidesForBreakpoint
  };
};

/* eslint-disable @typescript-eslint/ban-ts-comment */
/**
 * @function getElementPositionOnDocument
 * @description returns top, bottom and left position of an element in the DOM
 * @param element - either a string selector OR a dom element OR jquery element
 */
var getElementPositionOnDocument = function getElementPositionOnDocument(element) {
  var $element = $$1(element);
  var elementPosition = $element.offset();
  var elementHeight = $element.outerHeight();
  return elementPosition ? Object.assign(Object.assign({}, elementPosition), {
    bottom: _.get(elementPosition, "top") + elementHeight
  }) : {
    top: 0,
    left: 0
  };
};
/**
 * @function getViewPortBottomPosition
 * @description returns the scrolling position of the bottom of the viewport screen
 */
var getViewPortBottomPosition = function getViewPortBottomPosition() {
  var scrollPosition = $$1(window).scrollTop();
  var documentHeight = $$1(window).height();
  return scrollPosition + documentHeight;
};
/**
 * @function convertLineHeightToNumber
 * @description returns a line height css string value into a number(strips out rem, px, etc...)
 * @param value
 */
var convertLineHeightToNumber = function convertLineHeightToNumber(value) {
  if (value === "") {
    return undefined;
  } else if (value) {
    var numberString = value.replace(/\D/g, "");
    return numberString * 1;
  }
};
/**
 * @function getFixedElementsHeightSum
 * @description from a list of element ids on the dom, this helper returns the sum of their heights if they are fixed
 * positioned
 */
var getFixedElementsHeightSum = function getFixedElementsHeightSum(listOfIds) {
  return _.flow([_.partialRight(_.map, function (id) {
    return $$1("#".concat(id));
  }), _.partialRight(_.filter, function ($element) {
    return $element.css("position") === "fixed";
  }), _.partialRight(_.map, function ($element) {
    return $element.height() || 0;
  }), _.partialRight(_.sum)])(listOfIds);
};
/**
 * @function goToTopOfMaterialBox
 * @description Go to the top position of the materialbox: this is useful when navigating within a materialbox so that
 * the new "page" opens at the top instead of the previous materialbox vertical position.
 */
var goToTopOfMaterialBox = function goToTopOfMaterialBox() {
  $$1(".material-box.active").scrollTop(0);
};
/**
 * @function getViewportData
 * @description returns viewport data
 */
/* istanbul ignore next */
var getViewportData = function getViewportData() {
  var _a, _b;
  var widthWithScrollBar = window === null || window === void 0 ? void 0 : window.innerWidth;
  var widthWithoutScrollBar = (_a = document === null || document === void 0 ? void 0 : document.documentElement) === null || _a === void 0 ? void 0 : _a.clientWidth;
  var scrollBarWidth = widthWithScrollBar - widthWithoutScrollBar;
  return {
    scrollableHeight: (_b = document === null || document === void 0 ? void 0 : document.documentElement) === null || _b === void 0 ? void 0 : _b.scrollHeight,
    widthWithScrollBar: widthWithScrollBar,
    widthWithoutScrollBar: widthWithoutScrollBar,
    scrollBarWidth: scrollBarWidth
  };
};
/**
 * @function debounce
 * @description debouncing the execution of a function / limits the amount of execution.
 * @param fn {Function}
 * @param debounceTimer {number} - delay before executing the function, if set to 0 the function will trigger
 * synchronously
 * @returns {Function}
 */
var debounce = function debounce(fn, debounceTimer) {
  //@ts-ignore
  var timer = null;
  return function () {
    //@ts-ignore
    clearTimeout(timer);
    if (debounceTimer > 0) {
      timer = setTimeout(fn, debounceTimer);
    } else {
      fn();
    }
  };
};

/**
 * @function useBreakpointChange
 * @description returns breakpoint info(bootstrap 3 by default and 5 if the flag is passed to the options)
 */
var useBreakpointChange = function useBreakpointChange() {
  var debounceTimer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 250;
  var options = arguments.length > 1 ? arguments[1] : undefined;
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    breakpointInfo = _useState2[0],
    setBreakpointInfo = _useState2[1];
  useEffect(function () {
    var updateBreakpointInfo = function updateBreakpointInfo() {
      var currentBreakpointInfo = getBreakpointInfo(options);
      if (!_.isEqual(currentBreakpointInfo, breakpointInfo)) {
        setBreakpointInfo(currentBreakpointInfo);
      }
    };
    var handleWindowResize = debounce(updateBreakpointInfo, debounceTimer);
    updateBreakpointInfo();
    window.addEventListener("resize", handleWindowResize);
    return function () {
      return window.removeEventListener("resize", handleWindowResize);
    };
  }, [debounceTimer, breakpointInfo]);
  return breakpointInfo;
};

/**
 * @module userHelper
 * @description User related helpers such as getting user data directly from local storage once a user is logged
 * in(no need to pass any params to get the data)...
 */
/**
 * @function getUserProfile
 * @description returns profile data or an empty object: this should normally always be available the moment the user
 * logged in
 */
var getUserProfile = function getUserProfile() {
  try {
    return JSON.parse(window.localStorage.getItem(LOCAL_STORAGE_KEYS.CUSTOMER_PROFILE) || "{}");
  } catch (e) {
    return {};
  }
};
var getUserUUID = function getUserUUID() {
  return getUserProfile().uuid;
};
/** Common user ID generated by informatica and shared across various TME services */
var getUserMdmId = function getUserMdmId() {
  return getUserProfile().mdmId;
};
var getUserEmail = function getUserEmail() {
  return getUserProfile().email;
};
var getUserCountryCode = function getUserCountryCode() {
  return getUserProfile().countryCode;
};
var getUserLanguageCode = function getUserLanguageCode() {
  return getUserProfile().languageCode;
};
var getUserToken = function getUserToken() {
  return window.localStorage.getItem(LOCAL_STORAGE_KEYS.TOKEN);
};
/**
 * @function getUserTokenExpiration
 * @description returns Token expiration date
 * @returns string
 */
var getUserTokenExpiration = function getUserTokenExpiration() {
  return _.toNumber(localStorage.getItem(LOCAL_STORAGE_KEYS.TOKEN_EXPIRES_AT));
};
var getPreferredDealerFromStorage = function getPreferredDealerFromStorage() {
  try {
    return _.get(JSON.parse(window.localStorage.getItem(LOCAL_STORAGE_KEYS.MARKETING) || "{}"), "data.mytoyota.dealers[0]");
  } catch (e) {
    return undefined;
  }
};
/**
 * @function isLoggedIn
 * @description returns true/false if there is a user token in the local storage
 * @returns {boolean}
 */
var isLoggedIn = function isLoggedIn() {
  return Boolean(getUserToken());
};
/** returns true if the token in localstorage is not or no longer valid */
var isUserTokenExpired = function isUserTokenExpired() {
  return getUserTokenExpiration() <= new Date().getTime();
};

/**
 * @function logMessageOnDebugMode
 * @description: Prevents polluting the debugger console when DEVs are logging things in it and allows to show a lot
 * of info when cp-debug is enabled through the URL(example.com?cp-debug=true): this can simplify debugging(especially
 * for testers who don't know the debugger as well as DEVs) and identifying racing conditions by having a sequence of
 * outstanding logs when needed...
 */
var logMessageOnDebugMode = function logMessageOnDebugMode(message) {
  var logLevel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "INFO";
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  if (window.cpDebug) {
    var color = logLevel === "ERROR" ? "red" : logLevel === "WARN" ? "orange" : "black";
    console.log("%cCP-".concat(logLevel, "%c ").concat(message), "background-color: ".concat(color, "; color: white; padding: 5px;font-size: 15px;"), "color: ".concat(color, "; font-size: 14px;"));
  }
  sendSomeInfoToDatadog(message, logLevel, options);
  return Boolean(window.cpDebug);
};
/** Sends some info to datadog when  that when sendToDatadog is true: we can then filter the info based on some params
 * we send to datadog such as the type/subtype of info, environment, ... */
var sendSomeInfoToDatadog = function sendSomeInfoToDatadog(message) {
  var logLevel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "INFO";
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  if (options.sendToDatadog && window.DD_RUM) {
    var logMessage = "CP-".concat(logLevel, " ").concat(message);
    var params = Object.assign(Object.assign({}, options.datadogParameters), {
      environment: _.get(window, "dxp.settings.environment"),
      page: window.location.pathname,
      userId: getUserUUID()
    });
    if (window.DD_RUM) {
      if (logLevel === "ERROR") {
        var error = new Error(logMessage);
        error.name = "CustomerPortalError";
        _typeof(window.DD_RUM.addError) === "function" && window.DD_RUM.addError(error, params);
      } else {
        _typeof(window.DD_RUM.addAction) === "function" && window.DD_RUM.addAction(logMessage, params);
      }
    }
  }
};

//If SwiperCore is tree shaked SwiperCore.use won't be accessible
if (_typeof(SwiperCore === null || SwiperCore === void 0 ? void 0 : SwiperCore.use) === "function") {
  SwiperCore.use([Navigation$1, Pagination, Autoplay]);
}
var lazyloadSwiperJsStyles = function lazyloadSwiperJsStyles() {
  try {
    if (window === null || window === void 0 ? void 0 : window.requirees) {
      window.requirees("".concat(window.dxp.settings.cpCommonUrl, "/cp-client/styles/libraries/ForkedSwiperJsStylesheets.css"));
    }
  } catch (err) {
    logMessageOnDebugMode("Error loading swiperJS styles", "ERROR");
  }
};
lazyloadSwiperJsStyles();
var idCounter$4 = 1;
var PAGINATION_TYPES = CAROUSEL_CONSTANTS.PAGINATION_TYPES;
var Carousel = function Carousel(_ref) {
  var children = _ref.children,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? "toyCoCarousel-" : _ref$id,
    onSwiperCreated = _ref.onSwiperCreated,
    options = _ref.options,
    breakpointOptions = _ref.breakpointOptions,
    navigationOptions = _ref.navigationOptions,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    wrapperClassName = _ref.wrapperClassName,
    slideClassName = _ref.slideClassName,
    _ref$onSlideChangeCal = _ref.onSlideChangeCallback,
    onSlideChangeCallback = _ref$onSlideChangeCal === void 0 ? function () {
      return undefined;
    } : _ref$onSlideChangeCal,
    testId = _ref.testId,
    autoPlayOptions = _ref.autoPlayOptions,
    _ref$autoPlayEnabled = _ref.autoPlayEnabled,
    autoPlayEnabled = _ref$autoPlayEnabled === void 0 ? false : _ref$autoPlayEnabled,
    onClickPrev = _ref.onClickPrev,
    onClickNext = _ref.onClickNext;
  var _a;
  // filteredChildren --> removing non-slides elements(eg: {booleanCondition && <>} will add false as slide if the
  // booleanCondition is false)
  //@ts-expect-error will fix in CPBL-31212
  var filteredChildren = _.compact(children);
  var _useBreakpointChange = useBreakpointChange(),
    breakpointName = _useBreakpointChange.breakpointName;
  var _ref2 = options || {},
    _ref2$numberOfSlidesI = _ref2.numberOfSlidesInView,
    numberOfSlidesInView = _ref2$numberOfSlidesI === void 0 ? 1 : _ref2$numberOfSlidesI,
    shouldLoop = _ref2.shouldLoop,
    spacingBetweenItems = _ref2.spacingBetweenItems,
    _ref2$shouldCenterAct = _ref2.shouldCenterActiveSlide,
    shouldCenterActiveSlide = _ref2$shouldCenterAct === void 0 ? true : _ref2$shouldCenterAct,
    centeredSlidesBounds = _ref2.centeredSlidesBounds,
    _ref2$touchSwipeSensi = _ref2.touchSwipeSensitivity,
    threshold = _ref2$touchSwipeSensi === void 0 ? 5 : _ref2$touchSwipeSensi,
    shouldEqualizeSlidesHeight = _ref2.shouldEqualizeSlidesHeight,
    addObserver = _ref2.addObserver,
    addParentsObserve = _ref2.addParentsObserve,
    _ref2$carouselInterac = _ref2.carouselInteractionEnabled,
    carouselInteractionEnabled = _ref2$carouselInterac === void 0 ? true : _ref2$carouselInterac,
    _ref2$useBootstrap = _ref2.useBootstrap5,
    useBootstrap5 = _ref2$useBootstrap === void 0 ? false : _ref2$useBootstrap,
    _ref2$enableGradient = _ref2.enableGradient,
    enableGradient = _ref2$enableGradient === void 0 ? false : _ref2$enableGradient;
  var _ref3 = navigationOptions || {},
    shouldShowArrows = _ref3.shouldShowArrows,
    shouldShowArrowsOutside = _ref3.shouldShowArrowsOutside,
    shouldShowPagination = _ref3.shouldShowPagination,
    scrollPerPage = _ref3.scrollPerPage,
    _ref3$paginationType = _ref3.paginationType,
    paginationType = _ref3$paginationType === void 0 ? PAGINATION_TYPES.NUMBER : _ref3$paginationType,
    disableArrows = _ref3.disableArrows,
    enableTopArrowNavigation = _ref3.enableTopArrowNavigation;
  var _ref4 = autoPlayOptions || {},
    delay = _ref4.delay,
    disableOnInteraction = _ref4.disableOnInteraction,
    pauseOnMouseEnter = _ref4.pauseOnMouseEnter;
  var carouselUniqueId = useMemo(function () {
    return id + ++idCounter$4;
  }, [id]);
  var initialSlidesAndSpacing = useMemo(function () {
    return getInitialSlidesAndSpacing(breakpointOptions, numberOfSlidesInView, spacingBetweenItems, useBootstrap5);
  }, [breakpointOptions, numberOfSlidesInView, spacingBetweenItems, useBootstrap5]);
  var originalNumberOfSlides = (filteredChildren === null || filteredChildren === void 0 ? void 0 : filteredChildren.length) || 0;
  var arrowsOutsideClassName = shouldShowArrows && shouldShowArrowsOutside && styles$C.arrowsOutside || "";
  var useNumberPagination = !!(shouldShowPagination && paginationType === PAGINATION_TYPES.NUMBER);
  var paginationClassNames = getCarouselPaginationClassNames(navigationOptions, styles$C);
  var shouldRenderItemsOutsideOfCarousel =
  //@ts-expect-error will fix in CPBL-31212
  ((_a = breakpointOptions === null || breakpointOptions === void 0 ? void 0 : breakpointOptions[breakpointName]) === null || _a === void 0 ? void 0 : _a.renderChildrenOnly) || _.size(filteredChildren) === 1;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    swiperInstance = _useState2[0],
    setSwiperInstance = _useState2[1];
  var _useState3 = useState(1),
    _useState4 = _slicedToArray(_useState3, 2),
    activeSlide = _useState4[0],
    setActiveSlide = _useState4[1];
  var _useInitialSlidesAndS = useInitialSlidesAndSpacing(initialSlidesAndSpacing),
    numberOfSlidesInViewForBreakpoint = _useInitialSlidesAndS.numberOfSlidesInViewForBreakpoint,
    spacingSizeBetweenSlidesForBreakpoint = _useInitialSlidesAndS.spacingSizeBetweenSlidesForBreakpoint,
    setNumberOfSlidesInViewForBreakpoint = _useInitialSlidesAndS.setNumberOfSlidesInViewForBreakpoint,
    setSpacingBetweenSlidesForBreakpoint = _useInitialSlidesAndS.setSpacingBetweenSlidesForBreakpoint;
  var totalPages = useTotalPages({
    children: filteredChildren,
    numberOfSlidesInViewForBreakpoint: numberOfSlidesInViewForBreakpoint,
    scrollPerPage: scrollPerPage
  });
  var currentPage = useCurrentPage({
    activeSlide: activeSlide,
    numberOfSlidesInViewForBreakpoint: numberOfSlidesInViewForBreakpoint,
    shouldShowPagination: shouldShowPagination,
    scrollPerPage: scrollPerPage
  });
  var _useIsFirstIsLastPosi = useIsFirstIsLastPosition(numberOfSlidesInViewForBreakpoint, filteredChildren, swiperInstance, activeSlide),
    isAtLastPosition = _useIsFirstIsLastPosi.isAtLastPosition,
    isAtFirstPosition = _useIsFirstIsLastPosi.isAtFirstPosition;
  useScrollPerPage(scrollPerPage, shouldLoop, numberOfSlidesInViewForBreakpoint, originalNumberOfSlides, swiperInstance);
  return shouldRenderItemsOutsideOfCarousel ? ( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, filteredChildren)) : ( /*#__PURE__*/React__default.createElement("div", {
    className: classNames(wrapperClassName, styles$C.swiperCarousel, arrowsOutsideClassName, paginationClassNames, {
      'cp-isAtFirstSlidePosition': isAtFirstPosition,
      'cp-isAtLastSlidePosition': isAtLastPosition
    }, _defineProperty({}, styles$C.spaceForNavAbove, enableTopArrowNavigation))
  }, enableGradient && ( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, !isAtFirstPosition && ( /*#__PURE__*/React__default.createElement("div", {
    className: classNames(styles$C.fade, styles$C.leftFade)
  })), !isAtLastPosition && ( /*#__PURE__*/React__default.createElement("div", {
    className: classNames(styles$C.fade, styles$C.rightFade)
  })))), /*#__PURE__*/React__default.createElement(CarouselNavigation, Object.assign({}, {
    shouldShowArrows: shouldShowArrows,
    shouldShowArrowsOutside: shouldShowArrowsOutside,
    nextUniqueSelector: "".concat(carouselUniqueId, "-next"),
    prevUniqueSelector: "".concat(carouselUniqueId, "-prev"),
    isAtFirstPosition: isAtFirstPosition,
    isAtLastPosition: isAtLastPosition,
    shouldLoop: shouldLoop,
    shouldShowPagination: useNumberPagination,
    currentPage: currentPage,
    totalPages: totalPages,
    testId: testId,
    disableArrows: disableArrows,
    onClickPrev: onClickPrev,
    onClickNext: onClickNext,
    enableTopArrowNavigation: enableTopArrowNavigation
  })), /*#__PURE__*/React__default.createElement(Swiper, Object.assign({}, Object.assign(Object.assign(Object.assign({
    allowSlideNext: carouselInteractionEnabled,
    allowSlidePrev: carouselInteractionEnabled,
    observer: !!addObserver,
    observeParents: !!addParentsObserve,
    pagination: getPaginationOptions(paginationType, navigationOptions),
    threshold: threshold,
    className: className,
    speed: CAROUSEL_CONSTANTS.DEFAULT_SPEED_MS,
    loop: !!shouldLoop
  }, autoPlayEnabled ? {
    autoplay: {
      delay: delay,
      disableOnInteraction: disableOnInteraction,
      pauseOnMouseEnter: pauseOnMouseEnter
    }
  } : {}), shouldShowArrows ? {
    navigation: {
      nextEl: ".".concat(carouselUniqueId, "-next"),
      prevEl: ".".concat(carouselUniqueId, "-prev")
    }
  } : {}), {
    slidesPerGroup: scrollPerPage && numberOfSlidesInView || 1,
    slidesPerView: numberOfSlidesInViewForBreakpoint,
    spaceBetween: spacingSizeBetweenSlidesForBreakpoint || 0,
    centeredSlides: scrollPerPage === true ? false : shouldCenterActiveSlide,
    centeredSlidesBounds: centeredSlidesBounds,
    breakpoints: breakpointOptions ? mapBreakpointOptions({
      breakpointOptions: breakpointOptions,
      scrollPerPage: scrollPerPage,
      mobileFirstOptions: options
    }) : null,
    onSwiper: function onSwiper(swiper) {
      // @ts-expect-error will fix in CPBL-31212
      setSwiperInstance(swiper);
      if (_typeof(onSwiperCreated) === "function") {
        onSwiperCreated(swiper);
      }
    },
    onSlideChange: function onSlideChange(swiper) {
      setActiveSlide(swiper.realIndex + 1);
      onSlideChangeCallback(swiper.realIndex);
    },
    // @ts-expect-error will fix in CPBL-31212
    onBreakpoint: function onBreakpoint(swiper, breakpointParams) {
      setNumberOfSlidesInViewForBreakpoint((breakpointParams === null || breakpointParams === void 0 ? void 0 : breakpointParams.slidesPerView) || numberOfSlidesInView);
      setSpacingBetweenSlidesForBreakpoint((breakpointParams === null || breakpointParams === void 0 ? void 0 : breakpointParams.spaceBetween) || spacingBetweenItems);
    }
  })), (filteredChildren === null || filteredChildren === void 0 ? void 0 : filteredChildren.length) ?
  //@ts-expect-error will fix in CPBL-31212
  filteredChildren.map(function (section, index) {
    return /*#__PURE__*/React__default.createElement(SwiperSlide, {
      key: index,
      className: classNames(slideClassName, shouldEqualizeSlidesHeight && styles$C.equalizeSlideHeights)
    }, filteredChildren[index]);
  }) : null)));
};

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

var css_248z$B = ".toyCo_Text-clickable-10115042{cursor:pointer}.toyCo_Text-validationError-10215042{color:var(--cp-error-color,var(--cp-red,#f02));font-size:15px;font-weight:400}";
var styles$B = {"clickable":"toyCo_Text-clickable-10115042","validationError":"toyCo_Text-validationError-10215042"};
styleInject(css_248z$B);

var TOYOTA = BRAND.TOYOTA,
  LEXUS = BRAND.LEXUS;
var L1$1 = ENVIRONMENTS.L1,
  T1$2 = ENVIRONMENTS.T1,
  DXPLEXUS$1 = ENVIRONMENTS.DXPLEXUS,
  DXPTOYOTA$1 = ENVIRONMENTS.DXPTOYOTA;
/* eslint-enable @typescript-eslint/no-explicit-any */
/**
 * @function getBrand
 * @description gets the brand name depending on the environment the application is running on
 */
var getBrand = function getBrand() {
  var dxpBrand = _.get(window.dxp, "settings.brand");
  var t1BrandOverwrite = _.get(window.T1, "settings.brand");
  return !!dxpBrand && dxpBrand.toUpperCase() || !!t1BrandOverwrite && t1BrandOverwrite.toUpperCase() || !!window.L1 && LEXUS || TOYOTA;
};
/**
 * @function isToyotaBrand
 * @description determines whether the brand of the environment is toyota
 */
var isToyotaBrand = function isToyotaBrand() {
  return getBrand() === TOYOTA;
};
/**
 * @function isLexusBrand
 * @description determines whether the brand of the environment is lexus
 */
var isLexusBrand = function isLexusBrand() {
  return getBrand() === LEXUS;
};
/**
 * @function isDeployedInDxp
 * @description determines whether the environment is dxp
 */
var isDeployedInDxp = function isDeployedInDxp() {
  return !!window.dxp;
};
/**
 * @function isDxpToyota
 * @description determines whether the environment is dxp and brand toyota
 */
var isDxpToyota = function isDxpToyota() {
  return isDeployedInDxp() && isToyotaBrand();
};
/**
 * @function isDxpLexus
 * @description determines whether the environment is dxp and brand lexus
 */
var isDxpLexus = function isDxpLexus() {
  return isDeployedInDxp() && isLexusBrand();
};
/**
 * @function isDeployedInT1
 * @description determines whether the environment is T1
 */
var isDeployedInT1 = function isDeployedInT1() {
  return !isDeployedInDxp() && isToyotaBrand();
};
/**
 * @function isDeployedInL1
 * @description determines whether the environment is L1
 */
var isDeployedInL1 = function isDeployedInL1() {
  return !isDeployedInDxp() && isLexusBrand();
};
// duplicated function to keep backwards compatibility, as 'isDeployedInL1' is more clear than 'isDeployedInLexus'
var isDeployedInLexus = function isDeployedInLexus() {
  return isDeployedInL1();
};
/**
 * @function isAllianceBrand
 * @description returns true|false if context is alliance
 */
var isAllianceBrand = function isAllianceBrand(brand) {
  //@ts-ignore
  return Boolean(brand && !!ALLIANCE_BRANDS[brand.toUpperCase()]);
};
/**
 * @function getEnvironment
 * @description returns a string representation of the environment
 */
var getEnvironment = function getEnvironment() {
  if (isDeployedInL1()) {
    return L1$1;
  }
  if (isDeployedInT1()) {
    return T1$2;
  }
  if (isDxpLexus()) {
    return DXPLEXUS$1;
  }
  if (isDxpToyota()) {
    return DXPTOYOTA$1;
  }
  return T1$2;
};
/**
 * @function getCultureIdentifier
 * @description returns the culture identifier related to the country
 */
function getCultureIdentifier() {
  return _.get(window, "globalize.cultureSelector");
}
/**
 * @function isDeployedInAuthorProd
 * @description returns if the current environment is dxp author-prod
 */
function isDeployedInAuthorProd() {
  var path = _.get(window, "location.hostname") || "";
  return isDeployedInDxp() && path.includes("author-prod");
}
/**
 * @function isDeployedInAuthor
 * @description returns if the current environment is dxp author (any environment)
 */
function isDeployedInAuthor() {
  var path = _.get(window, "location.hostname") || "";
  var author = /author-(dev|uat|test|prod)/i;
  return isDeployedInDxp() && author.test(path);
}
// This function needs to check JEST_WORKER_ID to do not impact unit tests as it also uses nodeJS,
// otherwise would return true when we actually want to simulate the browser while running UT
/**
 * @function isServerMode
 * @description returns if the current environment is running on server mode and not by unit tests
 */
function isServerMode() {
  if ((typeof process === "undefined" ? "undefined" : _typeof(process)) !== "undefined") {
    var processName = _.get(process, "release.name", ""),
      processJestWorkerId = _.get(process, "env.JEST_WORKER_ID");
    return processName.search(/node|io.js/) !== -1 && processJestWorkerId === undefined;
  }
  return false;
}

var DXPLEXUS = ENVIRONMENTS.DXPLEXUS,
  DXPTOYOTA = ENVIRONMENTS.DXPTOYOTA,
  T1$1 = ENVIRONMENTS.T1,
  L1 = ENVIRONMENTS.L1,
  ALL = ENVIRONMENTS.ALL;
var getTypographyClassMap = function getTypographyClassMap(options) {
  var _a, _b;
  // keep legacy apps backwards compatible
  var supportCpDxpTypography = (_a = options === null || options === void 0 ? void 0 : options.supportCpDxpTypography) !== null && _a !== void 0 ? _a : Boolean((_b = $$1("cp-client")) === null || _b === void 0 ? void 0 : _b.length);
  var base = {
    HEADER_1: [{
      "class": "l-alpha-text",
      applyOn: [DXPLEXUS],
      environmentName: _defineProperty({}, DXPLEXUS, "H1 - 32 | 48 REGULAR")
    }],
    HEADER_2: [{
      "class": "l-beta-text",
      applyOn: [DXPLEXUS],
      environmentName: _defineProperty({}, DXPLEXUS, "H2 - 28 | 40 REGULAR")
    }],
    HEADER_3: [{
      "class": "l-gamma-text",
      applyOn: [DXPLEXUS],
      environmentName: _defineProperty({}, DXPLEXUS, "H3 - 24 | 32 REGULAR")
    }],
    HEADER_4: [{
      "class": "l-delta-text",
      applyOn: [DXPLEXUS],
      environmentName: _defineProperty({}, DXPLEXUS, "H4 - 20 | 28 REGULAR")
    }],
    HEADER_5: [{
      "class": "l-epsilon-text",
      applyOn: [DXPLEXUS],
      environmentName: _defineProperty({}, DXPLEXUS, "H5 - SUBHEADER 1 - 14 | 16 REG")
    }],
    PARAGRAPH: [{
      "class": "l-body-text",
      applyOn: [DXPLEXUS],
      environmentName: _defineProperty({}, DXPLEXUS, "Body - 18 Book")
    }],
    SPAN: [{
      "class": "",
      applyOn: []
    }],
    SUPPORT_TEXT: [{
      "class": "support-text",
      applyOn: supportCpDxpTypography ? [T1$1, L1] : [ALL]
    }],
    VALIDATION_ERROR: [{
      "class": "".concat(styles$B.validationError),
      applyOn: [ALL]
    }],
    INTRO: [{
      "class": "intro",
      applyOn: [ALL]
    }],
    QUOTE: [{
      "class": "l-quote-text",
      applyOn: [DXPLEXUS],
      environmentName: _defineProperty({}, DXPLEXUS, "Quote - 24 | 26 Book")
    }, {
      "class": "quote3",
      applyOn: supportCpDxpTypography ? [T1$1, L1] : [DXPTOYOTA, T1$1, L1]
    }]
  };
  var extendedCpDxpMapping = {
    CTA: [{
      "class": "l-cta-text",
      applyOn: [DXPLEXUS],
      environmentName: _defineProperty({}, DXPLEXUS, "CTA - 14 Bold")
    }],
    CAPTION: [{
      "class": "l-caption-text",
      applyOn: [DXPLEXUS],
      environmentName: _defineProperty({}, DXPLEXUS, "CAPTION - 14 Book")
    }],
    HEADER_1: [{
      "class": "cp-h1",
      applyOn: [DXPTOYOTA],
      environmentName: _defineProperty({}, DXPTOYOTA, "40 TITLE BOOK | 34 Header Book")
    }],
    HEADER_2: [{
      "class": "cp-h2",
      applyOn: [DXPTOYOTA],
      environmentName: _defineProperty({}, DXPTOYOTA, "34 Header Book | 28 Header Regular")
    }],
    HEADER_2_STRONG: [{
      "class": "cp-h2-strong",
      applyOn: [DXPTOYOTA],
      environmentName: _defineProperty({}, DXPTOYOTA, "34 HEADER SEMIBOLD | 28 Header Regular")
    }],
    HEADER_3: [{
      "class": "cp-h3",
      applyOn: [DXPTOYOTA],
      environmentName: _defineProperty({}, DXPTOYOTA, "28 Header Regular | 22 Subheader Regular")
    }],
    HEADER_4: [{
      "class": "cp-h4",
      applyOn: [DXPTOYOTA],
      environmentName: _defineProperty({}, DXPTOYOTA, "22 Subheader Regular | 20 Card Subheader Regular")
    }],
    HEADER_5: [{
      "class": "cp-h5",
      applyOn: [DXPTOYOTA],
      environmentName: _defineProperty({}, DXPTOYOTA, "20 Subheader Regular")
    }],
    HEADER_5_STRONG: [{
      "class": "cp-h5-strong",
      applyOn: [DXPTOYOTA],
      environmentName: _defineProperty({}, DXPTOYOTA, "20 Subheader Semibold")
    }],
    HEADER_6: [{
      "class": "cp-h6",
      applyOn: [DXPTOYOTA],
      environmentName: _defineProperty({}, DXPTOYOTA, "16 Header Body Regular")
    }],
    PARAGRAPH: [{
      "class": "cp-p",
      applyOn: [DXPTOYOTA],
      environmentName: _defineProperty({}, DXPTOYOTA, "16 Body Book")
    }],
    PARAGRAPH_STRONG: [{
      "class": "cp-l-body-text-strong",
      applyOn: [DXPLEXUS],
      environmentName: _defineProperty({}, DXPLEXUS, "Body - 18 Bold")
    }, {
      "class": "cp-h6",
      applyOn: [DXPTOYOTA],
      environmentName: _defineProperty({}, DXPTOYOTA, "16 Header Body Regular")
    }],
    LIST_ITEM: [{
      "class": "l-listItem-text",
      applyOn: [DXPLEXUS],
      environmentName: _defineProperty({}, DXPLEXUS, "List item - 16 Book")
    }],
    LIST_ITEM_SMALL: [{
      "class": "l-smallListItem-text",
      applyOn: [DXPLEXUS],
      environmentName: _defineProperty({}, DXPLEXUS, "List Item - 14 Book Small")
    }],
    SUPPORT_TEXT: [{
      "class": "cp-support-text",
      applyOn: [DXPTOYOTA],
      environmentName: _defineProperty({}, DXPTOYOTA, "Support Book")
    }, {
      "class": "l-legal-text",
      applyOn: [DXPLEXUS],
      environmentName: _defineProperty({}, DXPLEXUS, "Legal - 12 Book")
    }],
    SUPPORT_TEXT_STRONG: [{
      "class": "cp-support-strong",
      applyOn: [DXPTOYOTA],
      environmentName: _defineProperty({}, DXPTOYOTA, "SUPPORT HEADER SEMIBOLD")
    }],
    QUOTE: [{
      "class": "cp-quote cp-h5",
      applyOn: [DXPTOYOTA],
      environmentName: _defineProperty({}, DXPTOYOTA, "Quotation")
    }]
  };
  var mergeArraysAlso = function mergeArraysAlso(objValue, srcValue) {
    return _.isArray(objValue) ? objValue.concat(srcValue) : undefined;
  };
  return supportCpDxpTypography ? _.mergeWith(base, extendedCpDxpMapping, mergeArraysAlso) : base;
};

//All text kinds supported for redesign no matter the env
var TEXT_KINDS_ALL;
(function (TEXT_KINDS_ALL) {
  TEXT_KINDS_ALL["CAPTION"] = "CAPTION";
  TEXT_KINDS_ALL["CTA"] = "CTA";
  TEXT_KINDS_ALL["HEADER_1"] = "HEADER_1";
  TEXT_KINDS_ALL["HEADER_2"] = "HEADER_2";
  TEXT_KINDS_ALL["HEADER_2_STRONG"] = "HEADER_2_STRONG";
  TEXT_KINDS_ALL["HEADER_3"] = "HEADER_3";
  TEXT_KINDS_ALL["HEADER_4"] = "HEADER_4";
  TEXT_KINDS_ALL["HEADER_5"] = "HEADER_5";
  TEXT_KINDS_ALL["HEADER_5_STRONG"] = "HEADER_5_STRONG";
  TEXT_KINDS_ALL["LIST_ITEM"] = "LIST_ITEM";
  TEXT_KINDS_ALL["LIST_ITEM_SMALL"] = "LIST_ITEM_SMALL";
  TEXT_KINDS_ALL["PARAGRAPH"] = "PARAGRAPH";
  TEXT_KINDS_ALL["PARAGRAPH_STRONG"] = "PARAGRAPH_STRONG";
  TEXT_KINDS_ALL["QUOTE"] = "QUOTE";
  TEXT_KINDS_ALL["SUPPORT_TEXT"] = "SUPPORT_TEXT";
  TEXT_KINDS_ALL["SUPPORT_TEXT_STRONG"] = "SUPPORT_TEXT_STRONG";
  TEXT_KINDS_ALL["SPAN"] = "SPAN";
})(TEXT_KINDS_ALL || (TEXT_KINDS_ALL = {}));
var MAP_KIND_TO_ELEMENT = {
  HEADER_1: "h1",
  HEADER_2: "h2",
  HEADER_3: "h3",
  HEADER_4: "h4",
  HEADER_5: "h5",
  PARAGRAPH: "p",
  SPAN: "span",
  VALIDATION_ERROR: "p"
};
var getContextAppropriateKind = function getContextAppropriateKind(kind) {
  if (!kind) {
    return;
  }
  if (_typeof(kind) === "string") {
    return kind;
  }
  var environment = getEnvironment();
  return kind[environment];
};
/**
 * @function getTypographyStyles
 * @description returns dedicated environment typography classnames depending on your needs. You can either pass a
 * string "kind of typography" that will map to the correct classname based on the environment. Small example: you want
 * your text to have the same typography as a header one, then pass 'HEADER_1' as kind and your element will get a
 * classname specific to the environment you are using(if the kind is supported for that env). You can also pass kind as
 * an object to control on which environment you want to apply the kind. EG: { dxpLexus: 'HEADER_1' } will apply the h1
 * equivalent classname on dxp lexus environment only...
 * Supported kinds can be: 'HEADER_1' to 'HEADER_5', 'PARAGRAPH', 'QUOTE', more to come
 */
var getTypographyStyles = function getTypographyStyles(kind, options) {
  var environment = getEnvironment();
  var typographyClassMap = getTypographyClassMap(options);
  var contextAppropriateKind = getContextAppropriateKind(kind);
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  var classOptions = typographyClassMap[contextAppropriateKind];
  var classnames = "";
  if (classOptions) {
    classnames = classOptions.reduce(function (previousValue, currentValue) {
      if (_.includes(currentValue.applyOn, environment) || _.includes(currentValue.applyOn, ENVIRONMENTS.ALL)) {
        return previousValue.length ? "".concat(previousValue, " ").concat(currentValue["class"]) : currentValue["class"];
      }
      return previousValue;
    }, "");
  }
  return classnames;
};

/**
 * @deprecated
 * Use TEXT_KINDS_ALL instead
 */
var TEXT_KINDS = _.mapValues(getTypographyClassMap(), function (_value, key) {
  return key;
});
var Text = function Text(_a) {
  var kind = _a.kind,
    htmlTag = _a.htmlTag,
    _a$className = _a.className,
    className = _a$className === void 0 ? "" : _a$className,
    children = _a.children,
    onClick = _a.onClick,
    isRichText = _a.isRichText,
    _a$isContentRequired = _a.isContentRequired,
    isContentRequired = _a$isContentRequired === void 0 ? true : _a$isContentRequired,
    testId = _a.testId,
    options = _a.options,
    otherProps = __rest(_a, ["kind", "htmlTag", "className", "children", "onClick", "isRichText", "isContentRequired", "testId", "options"]);
  var contextAppropriateKind = getContextAppropriateKind(kind);
  var TextElement = htmlTag || MAP_KIND_TO_ELEMENT[contextAppropriateKind] || "p";
  var typographyStyles = getTypographyStyles(kind, options);
  var props = Object.assign({
    className: classNames(typographyStyles, onClick && styles$B.clickable, className) || undefined,
    onClick: onClick,
    'data-test-id': testId
  }, otherProps);
  return isRichText ? ( /*#__PURE__*/React__default.createElement(TextElement, Object.assign({}, Object.assign(Object.assign({}, props), {
    dangerouslySetInnerHTML: {
      __html: children || (isContentRequired ? TRIDION_LABEL_MISSING : "")
    }
  })))) : ( /*#__PURE__*/React__default.createElement(TextElement, Object.assign({}, props), children || (isContentRequired ? TRIDION_LABEL_MISSING : "")));
};

var PROGRESS = CAROUSEL_CONSTANTS.PAGINATION_TYPES.PROGRESS;
var ProgressCarousel = function ProgressCarousel(_ref) {
  var title = _ref.title,
    className = _ref.className,
    carouselId = _ref.carouselId,
    carouselClassName = _ref.carouselClassName,
    slideClassName = _ref.slideClassName,
    wrapperClassName = _ref.wrapperClassName,
    options = _ref.options,
    breakpointOptions = _ref.breakpointOptions,
    navigationOptions = _ref.navigationOptions,
    children = _ref.children,
    testId = _ref.testId,
    onSlideChangeCallback = _ref.onSlideChangeCallback,
    autoPlayOptions = _ref.autoPlayOptions,
    autoPlayEnabled = _ref.autoPlayEnabled;
  return /*#__PURE__*/React__default.createElement("div", {
    className: className
  }, title && /*#__PURE__*/React__default.createElement(Text, {
    kind: TEXT_KINDS_ALL.HEADER_5
  }, title), /*#__PURE__*/React__default.createElement(Carousel, {
    children: children,
    id: carouselId,
    options: options,
    breakpointOptions: breakpointOptions,
    navigationOptions: _objectSpread2(_objectSpread2({}, {
      shouldShowPagination: true,
      paginationType: PROGRESS,
      progressPaginationOptions: {
        type: PROGRESS
      }
    }), navigationOptions),
    className: carouselClassName,
    slideClassName: slideClassName,
    wrapperClassName: wrapperClassName,
    onSlideChangeCallback: onSlideChangeCallback,
    testId: testId,
    autoPlayEnabled: autoPlayEnabled,
    autoPlayOptions: autoPlayOptions
  }));
};
ProgressCarousel.propTypes = {
  title: PropTypes.string,
  id: PropTypes.string,
  carouselId: PropTypes.string,
  className: PropTypes.string,
  carouselClassName: PropTypes.string,
  slideClassName: PropTypes.string,
  wrapperClassName: PropTypes.string,
  navigationOptions: PropTypes.object,
  options: PropTypes.object,
  breakpointOptions: PropTypes.object,
  autoPlayOptions: PropTypes.object,
  autoPlayEnabled: PropTypes.bool,
  children: PropTypes.node,
  testId: PropTypes.string,
  onSlideChangeCallback: PropTypes.func
};
ProgressCarousel.defaultProps = {
  onSlideChangeCallback: function onSlideChangeCallback() {
    return null;
  },
  options: {
    carouselInteractionEnabled: true,
    shouldLoop: false,
    useBootstrap5: true,
    shouldCenterActiveSlide: false
  },
  breakpointOptions: {
    XS: {
      numberOfSlidesInView: 1.2,
      spacingBetweenItems: 15
    },
    SM: {
      numberOfSlidesInView: 2.2,
      spacingBetweenItems: 20
    },
    MD: {
      numberOfSlidesInView: 3.2,
      spacingBetweenItems: 25
    },
    LG: {
      numberOfSlidesInView: 3.2,
      spacingBetweenItems: 30
    }
  },
  navigationOptions: {
    shouldShowArrows: false,
    shouldShowPagination: true,
    shouldShowArrowsOutside: false,
    shouldShowPaginationBelow: false
  }
};

var css_248z$A = ".toyCo_backgroundImage-backgroundImage-4015042{--size:cover;--position:center;background-image:var(--xs);background-position:var(--cp-bg-img-position,var(--position));background-size:var(--cp-bg-img-size,var(--size));height:100%;width:100%}@media (min-width:576px){.toyCo_backgroundImage-sm-4115042{background-image:var(--sm)}}@media (min-width:768px){.toyCo_backgroundImage-md-4215042{background-image:var(--md)}}@media (min-width:992px){.toyCo_backgroundImage-lg-4315042{background-image:var(--lg)}}@media (min-width:1200px){.toyCo_backgroundImage-xl-4415042{background-image:var(--xl)}}";
var styles$A = {"backgroundImage":"toyCo_backgroundImage-backgroundImage-4015042","sm":"toyCo_backgroundImage-sm-4115042","md":"toyCo_backgroundImage-md-4215042","lg":"toyCo_backgroundImage-lg-4315042","xl":"toyCo_backgroundImage-xl-4415042"};
styleInject(css_248z$A);

/* eslint-enable quotes */
var BackgroundImage = function BackgroundImage(_ref) {
  var XS = _ref.XS,
    SM = _ref.SM,
    MD = _ref.MD,
    LG = _ref.LG,
    XL = _ref.XL,
    className = _ref.className,
    children = _ref.children,
    styleOptions = _ref.styleOptions,
    forwardedRef = _ref.forwardedRef;
  var defaultBackgroundImage = XS || SM || MD || LG || XL;
  var inlineStyles = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
    '--xs': "url(".concat(defaultBackgroundImage, ")")
  }, SM ? {
    '--sm': "url(\"".concat(SM, "\")")
  } : {}), MD ? {
    '--md': "url(\"".concat(MD, "\")")
  } : {}), LG ? {
    '--lg': "url(\"".concat(LG, "\")")
  } : {}), XL ? {
    '--xl': "url(\"".concat(XL, "\")")
  } : {}), (styleOptions === null || styleOptions === void 0 ? void 0 : styleOptions.size) ? {
    '--size': styleOptions === null || styleOptions === void 0 ? void 0 : styleOptions.size
  } : {}), (styleOptions === null || styleOptions === void 0 ? void 0 : styleOptions.position) ? {
    '--position': styleOptions === null || styleOptions === void 0 ? void 0 : styleOptions.position
  } : {});
  return /*#__PURE__*/React__default.createElement("div", {
    ref: forwardedRef,
    style: inlineStyles,
    className: classNames(className, styles$A.backgroundImage, _defineProperty({}, styles$A.sm, !!SM), _defineProperty({}, styles$A.md, !!MD), _defineProperty({}, styles$A.md, !!MD), _defineProperty({}, styles$A.lg, !!LG), _defineProperty({}, styles$A.xl, !!XL))
  }, children);
};

var ControlledCarousel = function ControlledCarousel(_ref) {
  var children = _ref.children,
    id = _ref.id,
    _ref$onSwiperCreated = _ref.onSwiperCreated,
    _onSwiperCreated = _ref$onSwiperCreated === void 0 ? function () {
      return undefined;
    } : _ref$onSwiperCreated,
    options = _ref.options,
    breakpointOptions = _ref.breakpointOptions,
    navigationOptions = _ref.navigationOptions,
    className = _ref.className,
    testId = _ref.testId,
    wrapperClassName = _ref.wrapperClassName,
    goToIndex = _ref.goToIndex,
    onSlideChangeCallback = _ref.onSlideChangeCallback,
    onClickPrev = _ref.onClickPrev,
    onClickNext = _ref.onClickNext;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    swiperInstance = _useState2[0],
    setSwiperInstance = _useState2[1];
  useEffect(function () {
    if (
    //@ts-expect-error will fix in CPBL-31212
    (swiperInstance === null || swiperInstance === void 0 ? void 0 : swiperInstance.activeIndex) !== goToIndex && _typeof(goToIndex) === "number") {
      //@ts-expect-error will fix in CPBL-31212
      swiperInstance === null || swiperInstance === void 0 ? void 0 : swiperInstance.slideTo(goToIndex);
    }
  }, [goToIndex, swiperInstance]);
  return /*#__PURE__*/React__default.createElement(Carousel, Object.assign({}, {
    children: children,
    id: id,
    onSwiperCreated: function onSwiperCreated(instance) {
      setSwiperInstance(instance);
      _onSwiperCreated(instance);
    },
    options: options,
    breakpointOptions: breakpointOptions,
    navigationOptions: navigationOptions,
    wrapperClassName: wrapperClassName,
    className: className,
    onSlideChangeCallback: onSlideChangeCallback,
    testId: testId,
    onClickPrev: onClickPrev,
    onClickNext: onClickNext
  }));
};

var css_248z$z = ".toyCo_Loader-child-1615042{left:50%;position:absolute;top:calc(50% + 4.5rem);transform:translateX(-50%)}";
var styles$z = {"child":"toyCo_Loader-child-1615042"};
styleInject(css_248z$z);

var Loader = function Loader(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    children = _ref.children;
  return /*#__PURE__*/React__default.createElement("div", {
    className: classNames("loading", className, children ? "transparent" : "")
  }, children ? /*#__PURE__*/React__default.createElement("div", {
    className: styles$z.child
  }, children) : null);
};

var THE_HEADERS = {
  APP_ID: "X-TME-APPID",
  TME_TOKEN: "X-TME-TOKEN",
  ACCEPT_LANGUAGE: "Accept-Language",
  ORIGIN: "X-TME-ORIGIN",
  ORDER_ID: "X-TME-ORDERID",
  RESERVATION_CODE: "X-TME-RESERVATIONCODE",
  REDIRECTION_PATH: "X-TME-REDIRECTIONPATH",
  BRAND: "X-TME-BRAND",
  LOCALE: "X-TME-LC",
  RESPONSE: "X-Response",
  CONSUMER: "X-TME-CONSUMER"
};
/**
 * @class HeaderBuilder
 * @description builds request headers standard for CP requests(X-TME-TOKEN, etc...) with methods such as addToken(token) / addBrand(brand = `TOYOTA`) / addLocale(locale) / ...
 */
var HeaderBuilder = /*#__PURE__*/function () {
  function HeaderBuilder() {
    var initialHeaders = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, HeaderBuilder);
    this.headers = initialHeaders;
  }
  _createClass(HeaderBuilder, [{
    key: "addToken",
    value: function addToken(token) {
      this.headers[THE_HEADERS.TME_TOKEN] = token || getUserToken();
      return this;
    }
  }, {
    key: "addBrand",
    value: function addBrand(brand) {
      this.headers[THE_HEADERS.BRAND] = brand || "".concat(window.T1.settings.brand) || "TOYOTA";
      return this;
    }
  }, {
    key: "addLocale",
    value: function addLocale(locale) {
      this.headers[THE_HEADERS.LOCALE] = locale || "".concat(window.T1.settings.language, "-").concat(window.T1.settings.country);
      return this;
    }
  }, {
    key: "addOrigin",
    value: function addOrigin(origin) {
      this.headers[THE_HEADERS.ORIGIN] = origin;
      return this;
    }
  }, {
    key: "addAppId",
    value: function addAppId(appId) {
      if (appId) {
        this.headers[THE_HEADERS.APP_ID] = appId;
      }
      return this;
    }
  }, {
    key: "addReservationCode",
    value: function addReservationCode(reservationCode) {
      if (reservationCode) {
        this.headers[THE_HEADERS.RESERVATION_CODE] = reservationCode;
      }
      return this;
    }
  }, {
    key: "addOrderId",
    value: function addOrderId(orderId) {
      if (orderId) {
        this.headers[THE_HEADERS.ORDER_ID] = orderId;
      }
      return this;
    }
  }, {
    key: "addRedirectionPath",
    value: function addRedirectionPath(redirectionPath) {
      if (redirectionPath) {
        this.headers[THE_HEADERS.REDIRECTION_PATH] = redirectionPath;
      }
      return this;
    }
    /**
     * Field to indicate which consumer is making the request
     * If repo name does not reveal sensitive details, use repo name as consumer
     * @param consumer - consumer name (repo name or service name)
     */
  }, {
    key: "addConsumer",
    value: function addConsumer(consumer) {
      if (consumer) {
        this.headers[THE_HEADERS.CONSUMER] = consumer;
      }
      return this;
    }
  }, {
    key: "build",
    value: function build() {
      return this.headers;
    }
  }]);
  return HeaderBuilder;
}();

/*global window*/

var contract = {
  event: {
    publish: {
      injection: {
        channel: 'com.toyota.tme.t1.injection',
        topic: 'component.inject'
      },
      dxpNavigationVisibility: {
        channel: "com.toyota.tme.t1.navigation",
        topic: "nav.primary.visibility",
        requestTopic: "nav.primary.visibility.request"
      }
    }
  },
  service: {
    host: {
      aggregator: "https://".concat(_.get(window, "T1.settings.cpB2cAggrHost")),
      fallback: {
        aggregatorPrev: 'https://cpb2csp.toyota-europe.com',
        aggregatorProd: 'https://cpb2cs.toyota-europe.com',
        clientBucketProd: '//t1-client.toyota-europe.com',
        clientBucketPrev: '//t1-client-prev.toyota-europe.com',
        gatewayP0ToyotaPrev: 'https://d2dh3eoasd9jdq.cloudfront.net',
        gatewayP0ToyotaProd: 'https://c1-apigateway-supra.toyota-europe.com',
        gatewayP0LexusPrev: 'https://d39k0gg40rs9rx.cloudfront.net',
        gatewayP0LexusProd: 'https://d10qzaqe8j7pwe.cloudfront.net',
        losPrev: 'https://weblos-prev.toyota-europe.com',
        losProd: 'https://weblos.toyota-europe.com',
        ssoPrev: 'https://ssomsp.toyota-europe.com',
        ssoProd: 'https://ssoms.toyota-europe.com'
      }
    },
    endpoint: {
      content: "/api/or/content",
      consentCenter: {
        content: "/consentCenter",
        consentTypes: "/api/consentTypes",
        update: "/api/consentTypes"
      }
    }
  },
  localstorageKeys: {
    profile: "com.toyota.tme.user.customerProfile",
    userToken: "com.toyota.tme.user.token"
  },
  ajax: {
    type: {
      get: "GET",
      post: "POST"
    }
  }
};

var _contract$ajax$type = contract.ajax.type,
  get = _contract$ajax$type.get,
  post = _contract$ajax$type.post;
var setHeaders = function setHeaders() {
  var headerBuilder = new HeaderBuilder();
  headerBuilder.addLocale();
  headerBuilder.addBrand(getBrand());
  headerBuilder.addToken();
  return headerBuilder;
};
var fetchGet = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(url) {
    var response;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return fetch(url, {
            method: get,
            headers: setHeaders().headers
          });
        case 2:
          response = _context.sent;
          if (response.ok) {
            _context.next = 5;
            break;
          }
          throw new Error("HTTP error! status: ".concat(response.status));
        case 5:
          _context.next = 7;
          return response.json();
        case 7:
          return _context.abrupt("return", _context.sent);
        case 8:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function fetchGet(_x) {
    return _ref.apply(this, arguments);
  };
}();
var fetchPost = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(_ref2) {
    var url, body, response;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          url = _ref2.url, body = _ref2.body;
          _context2.next = 3;
          return fetch(url, {
            method: post,
            headers: setHeaders().headers,
            body: JSON.stringify(body)
          });
        case 3:
          response = _context2.sent;
          if (response.ok) {
            _context2.next = 6;
            break;
          }
          throw new Error("HTTP error! status: ".concat(response.status));
        case 6:
          _context2.next = 8;
          return response.json();
        case 8:
          return _context2.abrupt("return", _context2.sent);
        case 9:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function fetchPost(_x2) {
    return _ref3.apply(this, arguments);
  };
}();

/**
 * @function replacePlaceholdersByAnchorTag
 * @description replaces some placeholders inside a string by anchor openining/closing tags
 */
var replacePlaceholdersByAnchorTag = function replacePlaceholdersByAnchorTag(text, openingPlaceholder, closingPlaceholder, hrefValue, options) {
  var result;
  if (_.size(text) && text) {
    result = text.replace(closingPlaceholder, "</a>");
    result = result.replace(openingPlaceholder, replaceOpeningPlaceholder(hrefValue, options));
  }
  return result;
};
var replaceOpeningPlaceholder = function replaceOpeningPlaceholder(hrefValue, options) {
  var href = "href=\"".concat(hrefValue, "\"");
  var target = _.get(options, "target") ? "target=\"".concat(_.get(options, "target"), "\"") : "";
  var selectors = _.get(options, "classNames") ? "class=\"".concat(_.get(options, "classNames"), "\"") : "";
  return "<a ".concat(href).concat(target ? " ".concat(target) : "").concat(selectors ? " ".concat(selectors) : "", ">");
};
/**
 * @function camelCaseToUpperUnderscore
 * @description uppercases a string and separates camelcase parts of the string with underscores
 */
var camelCaseToUpperUnderscore = function camelCaseToUpperUnderscore(camelCasedString) {
  if (!camelCasedString) {
    return camelCasedString;
  }
  return camelCasedString.replace(/\.?([A-Z])/g, function (_x, y) {
    return "_" + y;
  }).replace(/^_/, "").toUpperCase();
};
/**
 * @function stringToBool
 * @description converts booleanStrings to boolean
 */
var stringToBool = function stringToBool(str) {
  switch (_typeof(str)) {
    case "string":
      return str.toLowerCase() === "true";
    case "boolean":
      return str;
    default:
      return false;
  }
};
/**
 * @function areStringsEqualCaseInsensitive
 * @description checks if strings are equal if both are lower cased
 */
var areStringsEqualCaseInsensitive = function areStringsEqualCaseInsensitive(string1, string2) {
  return (string1 === null || string1 === void 0 ? void 0 : string1.toLowerCase()) === (string2 === null || string2 === void 0 ? void 0 : string2.toLowerCase());
};

var _contract$service = contract.service,
  host = _contract$service.host,
  endpoint = _contract$service.endpoint;
var getConsentElements = function getConsentElements(list, treatedName, consentValue) {
  return list.map(function (el) {
    return _.get(el, "code") === treatedName ? Object.assign(Object.assign({}, el), {
      flag: consentValue
    }) : el;
  });
};
var getUserDetails = function getUserDetails(customerProfile) {
  return {
    country: _.get(customerProfile, "countryCode"),
    email: _.get(customerProfile, "email"),
    language: _.get(customerProfile, "languageCode")
  };
};
var appendDescriptionsToConsents = function appendDescriptionsToConsents(consents, consentCenterLabels) {
  var consentOptions = _.get(consentCenterLabels, "consentCenter.consentOptions", {});
  return consents.map(function (consent) {
    var consentLabels = consentOptions[_.camelCase(consent.code)] || {};
    consent.description = consentLabels.label || TRIDION_LABEL_MISSING;
    consent.longDescription = consentLabels.description || TRIDION_LABEL_MISSING;
    return consent;
  });
};
var getUserConsentCenter = function getUserConsentCenter() {
  return fetchGet("".concat(host.aggregator).concat(endpoint.consentCenter.consentTypes)).then(function (results) {
    return {
      success: Object.assign({}, results)
    };
  })["catch"](function (error) {
    return {
      error: {
        statusCode: _.get(error, "response.status"),
        message: _.get(error, "response.statusText")
      }
    };
  });
};
var getConsentCenterLabels = function getConsentCenterLabels() {
  return fetchGet("".concat(host.aggregator).concat(endpoint.content).concat(endpoint.consentCenter.content)).then(function (results) {
    return {
      consentCenter: results
    };
  })["catch"](function (error) {
    return error;
  });
};
var updateConsentState = function updateConsentState(newState, consentValue, name) {
  var treatedName = camelCaseToUpperUnderscore(name),
    successObj = _.get(newState, "success", {}),
    consentsObj = _.get(successObj, "consents", {});
  newState = Object.assign(Object.assign({}, newState), {
    success: {
      channels: getConsentElements(_.get(successObj, "channels", []), treatedName, consentValue),
      consents: Object.assign(Object.assign({}, consentsObj), {
        canonical: getConsentElements(_.get(consentsObj, "canonical", []), treatedName, consentValue),
        nmsc: getConsentElements(_.get(consentsObj, "nmsc", []), treatedName, consentValue)
      })
    }
  });
  return newState;
};
var saveCommunicationPreferences = function saveCommunicationPreferences(consentTypes, customerProfile, consentCenterLabels, hasDirtyPreferences) {
  if (!hasDirtyPreferences) {
    return Promise.resolve("success");
  }
  var consentTypesState = _.get(consentTypes, "success");
  var dirtyConsentTypes = {
    userDetails: getUserDetails(customerProfile),
    channels: appendDescriptionsToConsents(_.get(consentTypesState, "channels"), consentCenterLabels),
    consents: {
      nmsc: appendDescriptionsToConsents(_.get(consentTypesState, "consents.nmsc", []), consentCenterLabels),
      canonical: appendDescriptionsToConsents(_.get(consentTypesState, "consents.canonical", []), consentCenterLabels)
    }
  };
  return fetchPost({
    url: "".concat(host.aggregator).concat(endpoint.consentCenter.update),
    body: dirtyConsentTypes
  });
};

var ConsentCentreErrorMessage = function ConsentCentreErrorMessage(_ref) {
  var customerLegislationDPOContactsIntro = _ref.customerLegislationDPOContactsIntro,
    customerLegislationDPOContacts = _ref.customerLegislationDPOContacts,
    notAvailableYet = _ref.notAvailableYet;
  return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(Text, {
    className: "last-updated-message",
    kind: TEXT_KINDS_ALL.PARAGRAPH
  }, notAvailableYet), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Text, {
    kind: TEXT_KINDS_ALL.HEADER_5,
    className: "s-margin-b"
  }, customerLegislationDPOContactsIntro), /*#__PURE__*/React__default.createElement(Text, {
    isRichText: true,
    kind: TEXT_KINDS_ALL.PARAGRAPH
  }, customerLegislationDPOContacts)));
};
ConsentCentreErrorMessage.propTypes = {
  customerLegislationDPOContactsIntro: PropTypes.string,
  customerLegislationDPOContacts: PropTypes.string,
  notAvailableYet: PropTypes.string
};

var css_248z$y = ".toyCo_CommunicationPreferences-consentCheckboxPopover-11615042{display:inline-flex;vertical-align:top}@media only screen and (min-width:768px){.toyCo_CommunicationPreferences-consentCheckboxPopover-11615042{display:inline-block;margin-bottom:24px}}.toyCo_CommunicationPreferences-noTextIndent-11715042{text-indent:0}.toyCo_CommunicationPreferences-successMessage-11815042{padding-left:24px;text-indent:0}.toyCo_CommunicationPreferences-successMessageWrapper-11915042{align-items:center;display:flex;margin-bottom:36px}.toyCo_CommunicationPreferences-errorMessageWrapper-12015042.error-message{display:block;margin-bottom:36px}.toyCo_CommunicationPreferences-iconOk-12115042{color:#f02;display:inline-block;font-size:1.6rem;position:absolute}.toyCo_CommunicationPreferences-saveChangesButton-12215042{margin:12px 0 36px}.toyCo_CommunicationPreferences-checkboxSection-12315042{display:inline-grid;display:-ms-grid;margin-top:14px}.toyCo_CommunicationPreferences-switchContainer-12415042{display:flex;justify-content:space-between}.toyCo_CommunicationPreferences-switchContainer-12415042 .t1-text-label{max-width:90%}@media only screen and (max-width:768px){.toyCo_CommunicationPreferences-switchContainerBlockMobile-12515042{display:block}}.toyCo_CommunicationPreferences-gridContainer-12615042 .t1-text-label{grid-column:1;-ms-grid-column:1}.toyCo_CommunicationPreferences-gridContainer-12615042 .t1-switch{grid-column:2;-ms-grid-column:2}";
var styles$y = {"consentCheckboxPopover":"toyCo_CommunicationPreferences-consentCheckboxPopover-11615042","noTextIndent":"toyCo_CommunicationPreferences-noTextIndent-11715042","successMessage":"toyCo_CommunicationPreferences-successMessage-11815042","successMessageWrapper":"toyCo_CommunicationPreferences-successMessageWrapper-11915042","errorMessageWrapper":"toyCo_CommunicationPreferences-errorMessageWrapper-12015042","iconOk":"toyCo_CommunicationPreferences-iconOk-12115042","saveChangesButton":"toyCo_CommunicationPreferences-saveChangesButton-12215042","checkboxSection":"toyCo_CommunicationPreferences-checkboxSection-12315042","switchContainer":"toyCo_CommunicationPreferences-switchContainer-12415042","switchContainerBlockMobile":"toyCo_CommunicationPreferences-switchContainerBlockMobile-12515042","gridContainer":"toyCo_CommunicationPreferences-gridContainer-12615042"};
styleInject(css_248z$y);

// This function is only exported for unit testing purposes.
function _dynatraceUnhandledPromiseRejection(event) {
  window.dtrum.reportError(event.reason);
}
function setup() {
  if (window.dtrum) {
    // Make Dynatrace report unhandled errors from promises properly.
    window.addEventListener("unhandledrejection", _dynatraceUnhandledPromiseRejection);
  }
}
function requireJsOnNodeCreatedInjection(filesToLoad) {
  return function (requireJSCreatedNode, config, module, url) {
    var previousOnNodeCreated = _.get(window.require, "s.contexts._.config.onNodeCreated");
    previousOnNodeCreated && previousOnNodeCreated(requireJSCreatedNode, config, module, url);
    if (filesToLoad.indexOf(url) >= 0) {
      // This is required to give permission to Dynatrace to track the stack trace + message of
      // an error inside a script that originates outside of toyota-europe domain.
      requireJSCreatedNode.crossOrigin = "anonymous";
    }
  };
}
function onClickWithLogs(identifier, onClick) {
  return function () {
    if (window.dtrum) {
      var tag = identifier || "DATA TEST ID MISSING";
      window.dtrum.leaveAction(window.dtrum.enterAction(tag, "click", window.dtrum.now()));
    }
    return onClick.apply(void 0, arguments);
  };
}

var _dynatrace = /*#__PURE__*/Object.freeze({
  __proto__: null,
  _dynatraceUnhandledPromiseRejection: _dynatraceUnhandledPromiseRejection,
  setup: setup,
  requireJsOnNodeCreatedInjection: requireJsOnNodeCreatedInjection,
  onClickWithLogs: onClickWithLogs
});

var css_248z$x = ".toyCo_Icon-clickable-1515042{cursor:pointer}.toyCo_Icon-clickable-1515042:focus-visible{outline:var(--cp-accessibility-outline);outline-offset:2px}";
var styles$x = {"clickable":"toyCo_Icon-clickable-1515042"};
styleInject(css_248z$x);

var MAP_KIND_TO_CLASSNAME$2 = {
  ICON: "icon",
  GLYPHICON: "glyphicon",
  DXPICON: "dxp-icon"
};
var ICON_KINDS;
(function (ICON_KINDS) {
  ICON_KINDS["ICON"] = "ICON";
  ICON_KINDS["GLYPHICON"] = "GLYPHICON";
  ICON_KINDS["DXPICON"] = "DXPICON";
})(ICON_KINDS || (ICON_KINDS = {}));
var Icon = function Icon(_ref) {
  var className = _ref.className,
    iconType = _ref.iconType,
    onClick = _ref.onClick,
    children = _ref.children,
    testId = _ref.testId,
    hideDefaultClass = _ref.hideDefaultClass,
    focusable = _ref.focusable;
  return /*#__PURE__*/React__default.createElement("span", Object.assign({
    onKeyDown: function onKeyDown(event) {
      event.key === "Enter" && onClick && onClick();
    }
  }, {
    'data-test-id': testId,
    className: classNames(!hideDefaultClass && _.get(MAP_KIND_TO_CLASSNAME$2, iconType || "", MAP_KIND_TO_CLASSNAME$2.ICON), className, onClick && styles$x.clickable),
    onClick: onClick,
    tabIndex: focusable ? 0 : -1
  }), children);
};

var css_248z$w = ".toyCo_Button-iconLink-5415042{align-items:center;background-color:transparent;border:none;display:inline-flex}.toyCo_Button-iconLink-5415042:not(.t1-reskin *):hover{color:#f02;text-decoration:none}.toyCo_Button-iconLink-5415042:is(.t1-reskin *):hover{color:#282830;opacity:.8;text-decoration:none}.toyCo_Button-iconLink-5415042 .icon:not(.t1-reskin *){color:#f02;font-size:20px;padding-top:2px}.toyCo_Button-iconLink-5415042 .icon:is(.t1-reskin *){color:#282830;font-size:1.2rem;vertical-align:inherit}.toyCo_Button-iconLink-5415042.toyCo_Button-iconAfterText-5515042 .dxp-icon,.toyCo_Button-iconLink-5415042.toyCo_Button-iconAfterText-5515042 .icon{margin-bottom:-3px;padding-left:.5rem}.toyCo_Button-iconLink-5415042.toyCo_Button-iconBeforeText-5615042 .dxp-icon,.toyCo_Button-iconLink-5415042.toyCo_Button-iconBeforeText-5615042 .icon{margin-bottom:-3px;padding-right:var(--cp-btn-icon-before-pr,.5rem)}.toyCo_Button-hasLongText-5715042{white-space:break-spaces}@media only screen and (max-width:767px){.toyCo_Button-mobileFullwidth-5815042{width:100%!important}}";
var styles$w = {"iconLink":"toyCo_Button-iconLink-5415042","iconAfterText":"toyCo_Button-iconAfterText-5515042","iconBeforeText":"toyCo_Button-iconBeforeText-5615042","hasLongText":"toyCo_Button-hasLongText-5715042","mobileFullwidth":"toyCo_Button-mobileFullwidth-5815042"};
styleInject(css_248z$w);

var BUTTON_KINDS = {
  PRIMARY: "PRIMARY",
  SECONDARY: "SECONDARY",
  TERTIARY: "TERTIARY",
  ICON_LINK: "ICON_LINK"
};

var MAP_KIND_TO_CLASSNAME_LEXUS_DXP = _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, BUTTON_KINDS.PRIMARY, "btn-primary"), BUTTON_KINDS.SECONDARY, "btn-secondary"), BUTTON_KINDS.TERTIARY, "btn-tertiary"), BUTTON_KINDS.ICON_LINK, "btn-text-link");
var LexusDxpButton = function LexusDxpButton(_ref) {
  var kind = _ref.kind,
    _ref$classNames = _ref.classNames,
    classNames$1 = _ref$classNames === void 0 ? "" : _ref$classNames,
    disabled = _ref.disabled,
    isIconLink = _ref.isIconLink,
    icon = _ref.icon,
    iconAfterText = _ref.iconAfterText,
    testId = _ref.testId,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? function () {
      return null;
    } : _ref$onClick,
    isAnchorTagType = _ref.isAnchorTagType,
    buttonType = _ref.buttonType,
    href = _ref.href,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? TRIDION_LABEL_MISSING : _ref$label,
    _ref$targetType = _ref.targetType,
    targetType = _ref$targetType === void 0 ? "_self" : _ref$targetType,
    id = _ref.id,
    isMobileFullwidth = _ref.isMobileFullwidth,
    _ref$showFullText = _ref.showFullText,
    showFullText = _ref$showFullText === void 0 ? false : _ref$showFullText,
    children = _ref.children,
    _ref$otherButtonProps = _ref.otherButtonProps,
    otherButtonProps = _ref$otherButtonProps === void 0 ? {} : _ref$otherButtonProps;
  var CustomTag = isAnchorTagType && href ? "a" : "button";
  return /*#__PURE__*/React__default.createElement("div", {
    className: classNames("cmp-btn", MAP_KIND_TO_CLASSNAME_LEXUS_DXP[kind], classNames$1)
  }, /*#__PURE__*/React__default.createElement(CustomTag, Object.assign({
    tabIndex: otherButtonProps["tabIndex"] || disabled ? -1 : 0
  }, Object.assign(Object.assign(Object.assign(Object.assign({
    id: id
  }, isAnchorTagType ? {
    target: targetType
  } : {}), {
    disabled: disabled,
    'data-test-id': testId,
    className: classNames("btn-text", disabled && "disabled", isIconLink && icon && !iconAfterText && "icon-left", isMobileFullwidth ? styles$w.mobileFullwidth : "", showFullText ? "h-auto" : "", classNames$1),
    onClick: onClickWithLogs(testId || classNames$1, onClick),
    href: isAnchorTagType ? href : undefined,
    type: buttonType ? buttonType : undefined
  }), disabled ? {
    'aria-disabled': true
  } : {}), otherButtonProps)), /*#__PURE__*/React__default.createElement("span", {
    className: classNames("btn-text t-base-text l-micro-text", showFullText ? styles$w.hasLongText : "")
  }, children ? children : label), isIconLink && icon));
};

var MAP_KIND_TO_CLASSNAME$1 = _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, BUTTON_KINDS.PRIMARY, "cp-btn-primary"), BUTTON_KINDS.SECONDARY, "cp-btn-secondary"), BUTTON_KINDS.TERTIARY, "cp-btn-tertiary"), BUTTON_KINDS.ICON_LINK, styles$w.iconLink);
var BUTTON_TAG_TYPES = {
  ANCHOR: "a",
  BUTTON: "button"
};
var Button = function Button(_a) {
  var kind = _a.kind,
    _a$label = _a.label,
    label = _a$label === void 0 ? TRIDION_LABEL_MISSING : _a$label,
    disabled = _a.disabled,
    _a$classNames = _a.classNames,
    classNames$1 = _a$classNames === void 0 ? "" : _a$classNames,
    _a$onClick = _a.onClick,
    onClick = _a$onClick === void 0 ? function () {
      return null;
    } : _a$onClick,
    _a$tagType = _a.tagType,
    tagType = _a$tagType === void 0 ? "button" : _a$tagType,
    buttonType = _a.buttonType,
    testId = _a.testId,
    iconAfterText = _a.iconAfterText,
    _a$iconClass = _a.iconClass,
    iconClass = _a$iconClass === void 0 ? "" : _a$iconClass,
    href = _a.href,
    isMobileFullwidth = _a.isMobileFullwidth,
    _a$shouldUseDxpLexusB = _a.shouldUseDxpLexusButton,
    shouldUseDxpLexusButton = _a$shouldUseDxpLexusB === void 0 ? true : _a$shouldUseDxpLexusB,
    _a$targetType = _a.targetType,
    targetType = _a$targetType === void 0 ? "_self" : _a$targetType,
    _a$hideIconClass = _a.hideIconClass,
    hideIconClass = _a$hideIconClass === void 0 ? false : _a$hideIconClass,
    _a$showFullText = _a.showFullText,
    showFullText = _a$showFullText === void 0 ? false : _a$showFullText,
    id = _a.id,
    _a$iconType = _a.iconType,
    iconType = _a$iconType === void 0 ? "ICON" : _a$iconType,
    children = _a.children,
    otherButtonProps = __rest(_a, ["kind", "label", "disabled", "classNames", "onClick", "tagType", "buttonType", "testId", "iconAfterText", "iconClass", "href", "isMobileFullwidth", "shouldUseDxpLexusButton", "targetType", "hideIconClass", "showFullText", "id", "iconType", "children"]);
  var isAnchorTagType = tagType === BUTTON_TAG_TYPES.ANCHOR;
  var CustomTag = isAnchorTagType && href ? "a" : "button";
  var isIconLink = kind === "ICON_LINK";
  var isButton = !isAnchorTagType;
  var buttonTypeValue = buttonType || (isButton ? "button" : undefined);
  var isIconBeforeText = isIconLink && !iconAfterText;
  var isIconAfterText = isIconLink && iconAfterText;
  var icon = iconClass ? ( /*#__PURE__*/React__default.createElement(Icon, {
    iconType: iconType,
    className: iconClass,
    hideDefaultClass: hideIconClass,
    onClick: function onClick() {
      return null;
    }
  })) : null;
  return isDxpLexus() && shouldUseDxpLexusButton ? ( /*#__PURE__*/React__default.createElement(LexusDxpButton, {
    kind: kind,
    classNames: classNames$1,
    disabled: Boolean(disabled),
    isIconLink: Boolean(isIconLink),
    icon: icon,
    iconAfterText: iconAfterText,
    testId: testId,
    onClick: onClick,
    isAnchorTagType: Boolean(isAnchorTagType),
    href: href,
    label: label,
    targetType: targetType,
    id: id,
    isMobileFullwidth: Boolean(isMobileFullwidth),
    showFullText: Boolean(showFullText),
    buttonType: buttonType,
    "aria-label": otherButtonProps["aria-label"],
    otherButtonProps: otherButtonProps
  }, children)) : ( /*#__PURE__*/React__default.createElement(CustomTag, Object.assign({
    tabIndex: otherButtonProps["tabIndex"] || disabled ? -1 : 0
  }, Object.assign(Object.assign(Object.assign(Object.assign({
    id: id
  }, isAnchorTagType ? {
    target: targetType
  } : {}), {
    disabled: disabled,
    href: isAnchorTagType ? href : undefined,
    className: classNames(isIconLink ? iconAfterText && styles$w.iconAfterText || styles$w.iconBeforeText : "cp-btn",
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    MAP_KIND_TO_CLASSNAME$1[kind], isMobileFullwidth ? styles$w.mobileFullwidth : "", showFullText ? "h-auto" : "", classNames$1),
    type: buttonTypeValue,
    'data-test-id': testId,
    onClick: onClickWithLogs(testId || classNames$1, onClick)
  }), disabled ? {
    'aria-disabled': true
  } : {}), otherButtonProps)), isIconBeforeText && icon, children ? children : label, isIconAfterText && icon));
};

/**
 * @function statusCodeToServerErrorMessage
 * @description Returns an error message from tridion/aem(does not matter) based on the status a request returned. E.G:
 * your errors object is { 'unauthorised': 'msg', 'forbidden': 'msg2', 'conflict': 'msg3',
 * 'system': 'msg4', 'unavailable': 'msg5','unavailable': 'msg6' }. And the status was 404, then the function will map
 * the status to the 'unauthorised' value which is 'msg'... If the status is not recognized it will return "translation
 * missing"
 */
var statusCodeToServerErrorMessage = function statusCodeToServerErrorMessage(statusCode, errors) {
  if (errors && _typeof(errors) === "object") {
    var statusCodeToName = {
      401: "unauthorised",
      403: "forbidden",
      404: "notFound",
      409: "conflict",
      500: "system",
      503: "unavailable",
      0: "unavailable"
    };
    return errors[statusCodeToName[statusCode]] || errors["system"] || TRIDION_LABEL_MISSING;
  }
  return TRIDION_LABEL_MISSING;
};

var css_248z$v = ".toyCo_ToggleSwitch-toggleSwitch-4815042 .t1-switch-input{clip:rect(0,0,0,0);display:initial!important;height:0;position:absolute;width:0}.toyCo_ToggleSwitch-toggleSwitch-4815042 .t1-switch .t1-slider:after{border-radius:17px;content:\"\";height:calc(100% + 8px);left:50%;opacity:0;outline:var(--cp-blue,#0072f0) .2rem solid;position:absolute;top:50%;transform:translate(-50%,-50%);width:calc(100% + 8px)}.toyCo_ToggleSwitch-toggleSwitch-4815042 .t1-switch-input:focus~.t1-switch .t1-slider:after{opacity:1}";
var styles$v = {"toggleSwitch":"toyCo_ToggleSwitch-toggleSwitch-4815042"};
styleInject(css_248z$v);

var ToggleSwitch = function ToggleSwitch(props) {
  var _props$toggled = props.toggled,
    toggled = _props$toggled === void 0 ? false : _props$toggled,
    name = props.name,
    _props$className = props.className,
    className = _props$className === void 0 ? "" : _props$className,
    labels = props.labels,
    _props$label = props.label,
    label = _props$label === void 0 ? TRIDION_LABEL_MISSING : _props$label,
    popOver = props.popOver,
    _onChange = props.onChange,
    dataTestId = props.dataTestId,
    inlineStyle = props.inlineStyle,
    ariaLabel = props.ariaLabel;
  return /*#__PURE__*/React__default.createElement("div", Object.assign({}, {
    className: classNames("t1-switch-container", className, styles$v.toggleSwitch),
    'data-test-id': dataTestId,
    style: inlineStyle
  }), /*#__PURE__*/React__default.createElement("input", Object.assign({}, {
    type: "checkbox",
    className: "t1-switch-input",
    name: name,
    checked: toggled,
    onChange: function onChange() {
      return _onChange(!toggled, name);
    }
  }, {
    "aria-label": ariaLabel
  })), /*#__PURE__*/React__default.createElement("div", Object.assign({}, {
    className: "t1-text-label",
    onClick: function onClick() {
      return _onChange(!toggled, name);
    }
  }), label, /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("span", {
    className: "t1-switch-state",
    "data-on": labels === null || labels === void 0 ? void 0 : labels.selectOn,
    "data-off": labels === null || labels === void 0 ? void 0 : labels.selectOff
  })), /*#__PURE__*/React__default.createElement("label", Object.assign({}, {
    className: "t1-switch",
    htmlFor: name,
    onClick: function onClick() {
      return _onChange(!toggled, name);
    }
  }), /*#__PURE__*/React__default.createElement("span", {
    className: "t1-slider"
  })), popOver);
};

var css_248z$u = ".toyCo_Popover-ctaStylingFromAbove-4515042{color:inherit}.toyCo_Popover-whitePopover-4615042.bottom .expansion-arrow{border-bottom:10px solid #fff}.toyCo_Popover-whitePopover-4615042.bottom .expansion-inner{background-color:#fff;padding-top:10px}.toyCo_Popover-whitePopover-4615042 .expansion-inner{word-wrap:break-word;font-size:15px}.toyCo_Popover-icon-4715042{padding-left:5px;transform:translateY(3px)}";
var styles$u = {"ctaStylingFromAbove":"toyCo_Popover-ctaStylingFromAbove-4515042","whitePopover":"toyCo_Popover-whitePopover-4615042","icon":"toyCo_Popover-icon-4715042"};
styleInject(css_248z$u);

var MAP_KIND_TO_CLASSNAME = {
  WHITE_POPOVER: styles$u.whitePopover
};
var POPOVER_KINDS = _.mapValues(Object.assign({}, MAP_KIND_TO_CLASSNAME), function (_value, key) {
  return key;
});
var MAP_CTA_KIND_TO_CLASSNAME = {
  DEFAULT: "",
  INHERITED: styles$u.ctaStylingFromAbove
};
_.mapValues(Object.assign({}, MAP_CTA_KIND_TO_CLASSNAME), function (_value, key) {
  return key;
});
var POPOVER_ICON_KINDS = {
  ICON: "icon",
  SVG_ICON: "icon-svg"
};
var Popover = function Popover(_ref) {
  var _ref$children = _ref.children,
    children = _ref$children === void 0 ? TRIDION_LABEL_MISSING : _ref$children,
    popoverId = _ref.popoverId,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? "" : _ref$testId,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    _ref$iconClassName = _ref.iconClassName,
    iconClassName = _ref$iconClassName === void 0 ? "" : _ref$iconClassName,
    _ref$wrapperClassName = _ref.wrapperClassName,
    wrapperClassName = _ref$wrapperClassName === void 0 ? "" : _ref$wrapperClassName,
    _ref$placement = _ref.placement,
    placement = _ref$placement === void 0 ? "top" : _ref$placement,
    kind = _ref.kind,
    ctaKind = _ref.ctaKind,
    iconKind = _ref.iconKind,
    iconName = _ref.iconName,
    title = _ref.title,
    _ref$showIcon = _ref.showIcon,
    showIcon = _ref$showIcon === void 0 ? true : _ref$showIcon,
    onClick = _ref.onClick;
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  var ctaClassName = MAP_CTA_KIND_TO_CLASSNAME[ctaKind] || "";
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  var expansionClassName = MAP_KIND_TO_CLASSNAME[kind] || "";
  return /*#__PURE__*/React__default.createElement("div", {
    className: wrapperClassName
  }, /*#__PURE__*/React__default.createElement("div", Object.assign({
    onClick: onClick,
    "data-tippy-placement": placement,
    "data-test-id": testId
  }, {
    className: className
  }), /*#__PURE__*/React__default.createElement("button", Object.assign({}, {
    role: "tooltip",
    className: "readMore ".concat(iconClassName, " ").concat(ctaClassName),
    'data-tooltip-selector': "#popover-content-".concat(popoverId),
    'data-tippy-placement': placement
  }), /*#__PURE__*/React__default.createElement("span", null, title && title), showIcon && ( /*#__PURE__*/React__default.createElement("i", {
    className: "".concat(iconKind || "dxp-icon", " ").concat(iconName || "icon-Info-small", " ").concat(styles$u.icon),
    "data-test-id": "".concat(testId, "Icon")
  })))), /*#__PURE__*/React__default.createElement("div", Object.assign({}, {
    id: "popover-content-".concat(popoverId),
    className: "expansion-content bottom right ".concat(expansionClassName),
    'data-test-id': "".concat(testId, "Content")
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "expansion-inner"
  }, children), /*#__PURE__*/React__default.createElement("div", {
    className: "expansion-arrow"
  }), /*#__PURE__*/React__default.createElement("a", {
    className: "closelink"
  }, /*#__PURE__*/React__default.createElement("i", {
    className: "dxp-icon icon-Close-small"
  }))));
};

var ConsentToggleSwitch = function ConsentToggleSwitch(_ref) {
  var toggleFieldsWithCodes = _ref.toggleFieldsWithCodes,
    toggleValue = _ref.toggleValue,
    consentOptions = _ref.consentOptions,
    onChange = _ref.onChange,
    isForChannels = _ref.isForChannels,
    labels = _ref.labels,
    popoverId = _ref.popoverId,
    index = _ref.index;
  var toggleField = toggleFieldsWithCodes.find(function (element) {
    return element.upperCaseCode === toggleValue.code;
  });
  var inlineStyle = {
    msGridRow: ++index
  };
  var label = _.get(consentOptions, "".concat(toggleField.name, ".label"), TRIDION_LABEL_MISSING);
  var description = _.get(consentOptions, "".concat(toggleField.name, ".description"), TRIDION_LABEL_MISSING);
  var popOver = description && !isForChannels ? /*#__PURE__*/React__default.createElement(Popover, {
    "data-test-id": "consentToggleSwitchPopover",
    popoverId: popoverId,
    className: styles$y.consentCheckboxPopover
  }, /*#__PURE__*/React__default.createElement(Text, {
    isRichText: true,
    kind: TEXT_KINDS_ALL.PARAGRAPH
  }, description)) : null;
  return /*#__PURE__*/React__default.createElement(ToggleSwitch, {
    name: toggleField.name,
    dataTestId: "consent",
    toggled: toggleValue.flag,
    onChange: onChange,
    label: label,
    labels: labels,
    popOver: popOver,
    className: classNames(styles$y.switchContainer, isForChannels ? styles$y.gridContainer : styles$y.switchContainerBlockMobile),
    inlineStyle: inlineStyle
  });
};
ConsentToggleSwitch.propTypes = {
  toggleFieldsWithCodes: PropTypes.array.isRequired,
  labels: PropTypes.object.isRequired,
  toggleValue: PropTypes.object.isRequired,
  consentOptions: PropTypes.object.isRequired,
  popoverId: PropTypes.string.isRequired,
  isForChannels: PropTypes.bool,
  onChange: PropTypes.func,
  index: PropTypes.number
};

var addUppercaseCodeToToggleFields = function addUppercaseCodeToToggleFields(toggleFields) {
  if (!Array.isArray(toggleFields)) {
    return [];
  }
  return toggleFields.map(function (element) {
    return {
      name: element,
      upperCaseCode: camelCaseToUpperUnderscore(element)
    };
  });
};

var TitledSectionWithToggleSwitch = function TitledSectionWithToggleSwitch(props) {
  var className = props.className,
    labels = props.labels,
    toggleFields = props.toggleFields,
    title = props.title,
    description = props.description,
    toggleValues = props.toggleValues,
    onChange = props.onChange,
    isForChannels = props.isForChannels;
  var consentOptions = _.get(labels, "consentCenter.consentOptions", {});
  var toggleFieldsWithCodes = addUppercaseCodeToToggleFields(toggleFields);
  return /*#__PURE__*/React__default.createElement("div", {
    className: className
  }, /*#__PURE__*/React__default.createElement(Text, {
    kind: TEXT_KINDS_ALL.HEADER_5,
    className: "s-margin-b"
  }, title), description ? /*#__PURE__*/React__default.createElement(Text, {
    isRichText: true,
    className: styles$y.noTextIndent
  }, description) : null, /*#__PURE__*/React__default.createElement("div", {
    className: styles$y.checkboxSection
  }, toggleValues.map(function (toggleValue, index) {
    return /*#__PURE__*/React__default.createElement(ConsentToggleSwitch, {
      key: index,
      toggleFieldsWithCodes: toggleFieldsWithCodes,
      toggleValue: toggleValue,
      consentOptions: consentOptions,
      onChange: onChange,
      isForChannels: isForChannels,
      labels: labels,
      popoverId: toggleValue.code + index,
      index: index
    });
  })));
};
TitledSectionWithToggleSwitch.propTypes = {
  labels: PropTypes.object.isRequired,
  toggleFields: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  toggleValues: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
  isForChannels: PropTypes.bool
};

var PAN_E = CONSENT_TYPES.PAN_E,
  LOCAL_LEGAL_CONSENT = CONSENT_TYPES.LOCAL_LEGAL_CONSENT,
  PREFERRED_CHANNEL = CONSENT_TYPES.PREFERRED_CHANNEL;
var ConsentCentre = function ConsentCentre(_ref) {
  var consentTypes = _ref.consentTypes,
    labels = _ref.labels,
    communicationPreferences = _ref.communicationPreferences,
    className = _ref.className,
    consentTypesPost = _ref.consentTypesPost,
    hasUpdateButton = _ref.hasUpdateButton,
    onChange = _ref.onChange,
    onClick = _ref.onClick;
  var _$get = _.get(consentTypes, "success", {}),
    channels = _$get.channels,
    _$get2 = _.get(consentTypes, "success.consents", {}),
    nmsc = _$get2.nmsc,
    canonical = _$get2.canonical,
    updateButtonLabel = _.get(communicationPreferences, "updateButton");
  var _ref2 = communicationPreferences || {},
    panETitle = _ref2.panETitle,
    panEDescription = _ref2.panEDescription,
    localLegalConsentTitle = _ref2.localLegalConsentTitle,
    preferredChannelTitle = _ref2.preferredChannelTitle,
    preferredChannelDescription = _ref2.preferredChannelDescription,
    customerLegislationDPOContactsIntro = _ref2.customerLegislationDPOContactsIntro,
    customerLegislationDPOContacts = _ref2.customerLegislationDPOContacts;
  var showParagraphAboveButton = function showParagraphAboveButton() {
    var updateSuccess = _.get(labels, "consentCenter.updateSuccess");
    if (_.get(consentTypesPost, "success")) {
      return /*#__PURE__*/React__default.createElement("div", {
        className: styles$y.successMessageWrapper
      }, /*#__PURE__*/React__default.createElement(Icon, {
        className: classNames(styles$y.iconOk, "icon-Check-small"),
        iconType: "DXPICON"
      }), /*#__PURE__*/React__default.createElement(Text, {
        className: styles$y.successMessage,
        kind: TEXT_KINDS_ALL.PARAGRAPH
      }, updateSuccess));
    } else if (_.get(consentTypesPost, "error")) {
      var statusCode = _.get(consentTypesPost, "error.status");
      var tridionErrors = _.get(communicationPreferences, "error", {});
      var tridionErrorLabel = statusCodeToServerErrorMessage(statusCode, tridionErrors);
      return /*#__PURE__*/React__default.createElement(Text, {
        className: classNames("error-message", styles$y.errorMessageWrapper),
        kind: TEXT_KINDS_ALL.PARAGRAPH
      }, tridionErrorLabel);
    } else {
      return null;
    }
  };
  return /*#__PURE__*/React__default.createElement("form", {
    className: "form"
  }, canonical.length > 0 ? /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(TitledSectionWithToggleSwitch, {
    className: className,
    labels: labels,
    toggleValues: canonical,
    toggleFields: PAN_E,
    title: panETitle,
    description: panEDescription,
    onChange: onChange
  }), /*#__PURE__*/React__default.createElement("hr", null)) : "", nmsc.length > 0 ? /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(TitledSectionWithToggleSwitch, {
    className: className,
    labels: labels,
    toggleValues: nmsc,
    toggleFields: LOCAL_LEGAL_CONSENT,
    title: localLegalConsentTitle,
    onChange: onChange
  }), /*#__PURE__*/React__default.createElement("hr", null)) : "", channels.length > 0 ? /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(TitledSectionWithToggleSwitch, {
    className: className,
    labels: labels,
    toggleValues: channels,
    toggleFields: PREFERRED_CHANNEL,
    title: preferredChannelTitle,
    description: preferredChannelDescription,
    onChange: onChange,
    isForChannels: true
  }), /*#__PURE__*/React__default.createElement("hr", null)) : "", hasUpdateButton && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, showParagraphAboveButton(), _.get(consentTypesPost, "started") ? /*#__PURE__*/React__default.createElement(Loader, null) : /*#__PURE__*/React__default.createElement(Button, {
    onClick: onClick,
    testId: "saveMyCommunicationPreferencesButton",
    kind: "PRIMARY",
    classNames: styles$y.saveChangesButton,
    label: updateButtonLabel
  })), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Text, {
    kind: TEXT_KINDS_ALL.HEADER_5,
    className: "s-margin-b"
  }, customerLegislationDPOContactsIntro), /*#__PURE__*/React__default.createElement(Text, {
    isRichText: true,
    kind: TEXT_KINDS_ALL.PARAGRAPH
  }, customerLegislationDPOContacts)));
};
ConsentCentre.propTypes = {
  labels: PropTypes.object.isRequired,
  consentTypes: PropTypes.objectOf(PropTypes.shape({
    success: PropTypes.objectOf(PropTypes.shape({
      channels: PropTypes.arrayOf(PropTypes.shape({
        code: PropTypes.string.isRequired,
        flag: PropTypes.bool
      })),
      consents: PropTypes.objectOf(PropTypes.shape({
        canonical: PropTypes.arrayOf(PropTypes.shape({
          code: PropTypes.string.isRequired,
          flag: PropTypes.bool
        })),
        nmsc: PropTypes.arrayOf(PropTypes.shape({
          code: PropTypes.string.isRequired,
          flag: PropTypes.bool
        }))
      }))
    }))
  })).isRequired,
  onChange: PropTypes.func.isRequired,
  communicationPreferences: PropTypes.object.isRequired,
  consentTypesPost: PropTypes.object,
  onClick: PropTypes.func,
  className: PropTypes.string,
  hasUpdateButton: PropTypes.bool
};

var profile = contract.localstorageKeys.profile;
var CommunicationPreferences = function CommunicationPreferences(_ref) {
  var className = _ref.className,
    hasUpdateButton = _ref.hasUpdateButton,
    hideIfUserHasNoAccess = _ref.hideIfUserHasNoAccess;
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    consentTypes = _useState2[0],
    setConsentTypes = _useState2[1];
  var _useState3 = useState({}),
    _useState4 = _slicedToArray(_useState3, 2),
    originalConsentTypes = _useState4[0],
    setOriginalConsentTypes = _useState4[1];
  var _useState5 = useState({}),
    _useState6 = _slicedToArray(_useState5, 2),
    consentTypesPost = _useState6[0],
    setConsentTypesPost = _useState6[1];
  var _useState7 = useState({}),
    _useState8 = _slicedToArray(_useState7, 2),
    labels = _useState8[0],
    setLabels = _useState8[1];
  var communicationPreferences = _.get(labels, "consentCenter");
  var _ref2 = communicationPreferences || {},
    customerLegislationDPOContactsIntro = _ref2.customerLegislationDPOContactsIntro,
    customerLegislationDPOContacts = _ref2.customerLegislationDPOContacts,
    notAvailableYet = _ref2.notAvailableYet;
  var customerProfile = JSON.parse(window.localStorage.getItem(profile));
  useEffect(function () {
    fetchConsentCenterUser();
    fetchConsentCenterLabels();
  }, []);
  var fetchConsentCenterUser = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var userConsentTypes;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setConsentTypes({
              started: "fetching data"
            });
            _context.next = 3;
            return getUserConsentCenter();
          case 3:
            userConsentTypes = _context.sent;
            setConsentTypes(userConsentTypes);
            setOriginalConsentTypes(userConsentTypes);
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function fetchConsentCenterUser() {
      return _ref3.apply(this, arguments);
    };
  }();
  var fetchConsentCenterLabels = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var togglesT1Labels, response;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            togglesT1Labels = _.pick(_.get(T1, "labels", {}), ["selectOn", "selectOff"]);
            _context2.t0 = _objectSpread2;
            _context2.t1 = _objectSpread2;
            _context2.t2 = {};
            _context2.next = 6;
            return getConsentCenterLabels();
          case 6:
            _context2.t3 = _context2.sent;
            _context2.t4 = (0, _context2.t1)(_context2.t2, _context2.t3);
            _context2.t5 = togglesT1Labels;
            response = (0, _context2.t0)(_context2.t4, _context2.t5);
            setLabels(response);
          case 11:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function fetchConsentCenterLabels() {
      return _ref4.apply(this, arguments);
    };
  }();
  var submitPreferences = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      var hasDirtyPreferences, response;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            hasDirtyPreferences = originalConsentTypes !== consentTypes;
            _context3.next = 3;
            return setConsentTypesPost({
              started: Date.now()
            });
          case 3:
            _context3.prev = 3;
            _context3.next = 6;
            return saveCommunicationPreferences(consentTypes, customerProfile, labels, hasDirtyPreferences);
          case 6:
            response = _context3.sent;
            setConsentTypesPost({
              success: response
            });
            setOriginalConsentTypes(consentTypes);
            _context3.next = 14;
            break;
          case 11:
            _context3.prev = 11;
            _context3.t0 = _context3["catch"](3);
            setConsentTypesPost({
              error: _context3.t0
            });
          case 14:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[3, 11]]);
    }));
    return function submitPreferences() {
      return _ref5.apply(this, arguments);
    };
  }();
  var onChange = function onChange(consentValue, name) {
    setConsentTypes(function (state) {
      return updateConsentState(state, consentValue, name);
    });
  };
  CommunicationPreferences.submitCommunicationPreferences = function () {
    return submitPreferences();
  };
  var displayContent = function displayContent() {
    if (_.isEmpty(consentTypes) || consentTypes.started) {
      return /*#__PURE__*/React__default.createElement(Loader, null);
    } else if (consentTypes.error && consentTypes.error.statusCode === CONSENT_TYPES.ERRORS.NOT_AVAILABLE) {
      return hideIfUserHasNoAccess ? null : /*#__PURE__*/React__default.createElement(ConsentCentreErrorMessage, {
        customerLegislationDPOContactsIntro: customerLegislationDPOContactsIntro,
        customerLegislationDPOContacts: customerLegislationDPOContacts,
        notAvailableYet: notAvailableYet
      });
    } else if (consentTypes.error) {
      return null;
    } else {
      return /*#__PURE__*/React__default.createElement(ConsentCentre, {
        className: className,
        hasUpdateButton: hasUpdateButton,
        consentTypes: consentTypes,
        labels: labels,
        communicationPreferences: communicationPreferences,
        consentTypesPost: consentTypesPost,
        onChange: onChange,
        onClick: function onClick() {
          return submitPreferences();
        }
      });
    }
  };
  return displayContent();
};
CommunicationPreferences.propTypes = {
  className: PropTypes.string,
  hasUpdateButton: PropTypes.bool
};

var css_248z$t = ".toyCo_image-fadeIn-1215042{opacity:0;transition:opacity .6s linear}.toyCo_image-deblur-1315042{filter:blur(3px);opacity:0;transition:filter .6s linear .1s}.toyCo_image-loaded-1415042.toyCo_image-fadeIn-1215042{opacity:1}.toyCo_image-loaded-1415042.toyCo_image-deblur-1315042{filter:blur(0);opacity:1}";
var styles$t = {"fadeIn":"toyCo_image-fadeIn-1215042","deblur":"toyCo_image-deblur-1315042","loaded":"toyCo_image-loaded-1415042"};
styleInject(css_248z$t);

/** Has a limited amount of specific props but also supports any attributes
 * the "img" html tag supports as a prop */
var Image$1 = function Image(_a) {
  var className = _a.className,
    imageUrl = _a.imageUrl,
    fallBackImageUrl = _a.fallBackImageUrl,
    onErrorFn = _a.onErrorFn,
    options = _a.options,
    testId = _a.testId,
    _a$onLoad = _a.onLoad,
    _onLoad = _a$onLoad === void 0 ? function () {
      return null;
    } : _a$onLoad,
    _a$dataDecorative = _a.dataDecorative,
    dataDecorative = _a$dataDecorative === void 0 ? false : _a$dataDecorative,
    onError = _a.onError,
    otherImgTagProps = __rest(_a, ["className", "imageUrl", "fallBackImageUrl", "onErrorFn", "options", "testId", "onLoad", "dataDecorative", "onError"]);
  var hasMountedRef = useRef();
  var defaultFallback = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
  var _useState = useState(imageUrl || fallBackImageUrl),
    _useState2 = _slicedToArray(_useState, 2),
    imageSrc = _useState2[0],
    setImageSrc = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    hasLoaded = _useState4[0],
    setHasLoaded = _useState4[1];
  var onErrorCallback = useCallback(function (e) {
    var target = e.target;
    if (onErrorFn || onError) {
      onErrorFn && onErrorFn(e);
      onError && onError(e);
      return;
    }
    if (target.src === imageUrl && fallBackImageUrl && imageUrl !== fallBackImageUrl) {
      setImageSrc(fallBackImageUrl);
    } else {
      setImageSrc(defaultFallback);
    }
  }, [onErrorFn, onError, imageUrl, fallBackImageUrl, defaultFallback]);
  useEffect(function () {
    if (hasMountedRef.current) {
      setImageSrc(imageUrl);
    }
  }, [imageUrl]);
  // trick to set a "hasmounted" flag: keep as last useEffect
  useEffect(function () {
    hasMountedRef.current = true;
  }, []);
  return /*#__PURE__*/React__default.createElement("img", Object.assign({
    className: classNames(className, (options === null || options === void 0 ? void 0 : options.shouldFadeIn) && styles$t.fadeIn, (options === null || options === void 0 ? void 0 : options.shouldDeblur) && styles$t.deblur, hasLoaded && "".concat(styles$t.loaded, " cp-img-loaded")),
    src: imageSrc,
    onError: onErrorCallback,
    loading: (options === null || options === void 0 ? void 0 : options.shouldLazyLoad) ? "lazy" : "eager",
    onLoad: function onLoad(event) {
      setHasLoaded(true);
      _onLoad(event);
    },
    "data-test-id": testId
  }, otherImgTagProps, {
    "data-decorative": dataDecorative ? true : undefined
  }));
};

/** ImageResponsive component uses react 5 breakpoints until XL: it will optimize the image load by loading the asset
 * that matches the viewport current breakpoint. If you do not provide the asset that matches the breakpoint: no worries
 * : the component will fallback to the next most optimized asset... */
var ImageResponsive = function ImageResponsive(_a) {
  var XS = _a.XS,
    SM = _a.SM,
    MD = _a.MD,
    LG = _a.LG,
    XL = _a.XL,
    fallBackImageUrl = _a.fallBackImageUrl,
    onClick = _a.onClick,
    imageOptions = _a.imageOptions,
    otherImgTagProps = __rest(_a, ["XS", "SM", "MD", "LG", "XL", "fallBackImageUrl", "onClick", "imageOptions"]);
  return /*#__PURE__*/React__default.createElement("picture", {
    onClick: onClick
  }, XL && /*#__PURE__*/React__default.createElement("source", {
    media: "(min-width: 1200px)",
    srcSet: XL
  }), LG && /*#__PURE__*/React__default.createElement("source", {
    media: "(min-width: 992px)",
    srcSet: LG
  }), MD && /*#__PURE__*/React__default.createElement("source", {
    media: "(min-width: 768px)",
    srcSet: MD
  }), SM && /*#__PURE__*/React__default.createElement("source", {
    media: "(min-width: 576px)",
    srcSet: SM
  }), XS && /*#__PURE__*/React__default.createElement("source", {
    media: "(min-width: 1px)",
    srcSet: XS
  }), /*#__PURE__*/React__default.createElement(Image$1, Object.assign({
    imageUrl: XL || LG || MD || SM || XS || "",
    fallBackImageUrl: fallBackImageUrl,
    options: imageOptions
  }, otherImgTagProps)));
};

var SectionErrorBoundary = /*#__PURE__*/function (_React$Component) {
  _inherits(SectionErrorBoundary, _React$Component);
  function SectionErrorBoundary(props) {
    var _this;
    _classCallCheck(this, SectionErrorBoundary);
    _this = _callSuper(this, SectionErrorBoundary, [props]);
    _this.state = {
      hasError: false,
      errorInfo: ""
    };
    return _this;
  }
  /* eslint-disable no-console */
  _createClass(SectionErrorBoundary, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error, errorInfo) {
      var extraErrorInfo = errorInfo && _typeof(errorInfo) === "object" ? JSON.stringify(errorInfo, null, 2) : "";
      console.log(this.props.message);
      console.log(error);
      console.log(errorInfo);
      logMessageOnDebugMode("SectionErrorBoundary >>> " + "".concat(this.props.message ? "intro message: ".concat(this.props.message) : "") + " error message received from catch: ".concat(error === null || error === void 0 ? void 0 : error.message, " and additional") + " error info: ".concat(extraErrorInfo), "ERROR", {
        sendToDatadog: true,
        datadogParameters: this.props.datadogParameters
      });
      this.setState({
        errorInfo: errorInfo
      });
    }
  }, {
    key: "render",
    value: function render() {
      return this.state.hasError ? this.props.fallback || null : this.props.children;
    }
  }], [{
    key: "getDerivedStateFromError",
    value: function getDerivedStateFromError() {
      return {
        hasError: true
      };
    }
  }]);
  return SectionErrorBoundary;
}(React.Component);

var css_248z$s = ".toyCo_progressBar-bar-10015042{background-color:var(--cp-bar-colour,#000);height:var(--cp-bar-height,2px);transition:width .3s linear;width:var(--cp-bar-progress,0)}";
var styles$s = {"bar":"toyCo_progressBar-bar-10015042"};
styleInject(css_248z$s);

var ProgressBar = function ProgressBar(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    percentageProgress = _ref.percentageProgress,
    styleOptions = _ref.styleOptions;
  var applyStyleOptions = Object.assign(Object.assign({
    '--cp-bar-progress': "".concat(percentageProgress, "%")
  }, (styleOptions === null || styleOptions === void 0 ? void 0 : styleOptions.height) ? {
    '--cp-bar-height': styleOptions === null || styleOptions === void 0 ? void 0 : styleOptions.height
  } : {}), (styleOptions === null || styleOptions === void 0 ? void 0 : styleOptions.barColour) ? {
    '--cp-bar-colour': styleOptions === null || styleOptions === void 0 ? void 0 : styleOptions.barColour
  } : {});
  return /*#__PURE__*/React__default.createElement("div", {
    style: applyStyleOptions,
    className: "".concat(className, " ").concat(styles$s.bar)
  });
};

var StepsProgressBar = function StepsProgressBar(_ref) {
  var className = _ref.className,
    numberOfSteps = _ref.numberOfSteps,
    numberOfCompletedSteps = _ref.numberOfCompletedSteps,
    styleOptions = _ref.styleOptions;
  var percentageProgress = Math.min(numberOfCompletedSteps / numberOfSteps * 100, 100);
  return /*#__PURE__*/React__default.createElement(ProgressBar, {
    percentageProgress: percentageProgress,
    className: className,
    styleOptions: styleOptions
  });
};

function T1Legacy(_ref) {
  var children = _ref.children,
    className = _ref.className,
    options = _ref.options;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, (isDeployedInDxp() || isDeployedInL1()) && !(options === null || options === void 0 ? void 0 : options.isInsideCpClient) ? ( /*#__PURE__*/React__default.createElement("t1-legacy", Object.assign({}, {
    "class": classNames("t1-reskin", className)
  }), children)) : children || null);
}

function CpClient(_ref) {
  var children = _ref.children,
    className = _ref.className,
    options = _ref.options;
  var _ref2 = options || {},
    isInsideMaterialBox = _ref2.isInsideMaterialBox,
    canWrapMaterialBoxChildren = _ref2.canWrapMaterialBoxChildren;
  var canWrapChildren = Boolean(canWrapMaterialBoxChildren || !isInsideMaterialBox);
  var shouldWrapWithCpClientTag = isDeployedInDxp() && canWrapChildren;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, shouldWrapWithCpClientTag ? ( /*#__PURE__*/React__default.createElement("cp-client", Object.assign({}, {
    css: "false",
    "class": classNames("t1-reskin", className)
  }), children)) : children);
}

/**
 * @module environment
 * @description check if we are in prod, local dev, etc ...
 */
/**
 * @function isProduction
 * @description returns true/false if the environment is production
 */
var isProduction = function isProduction() {
  var envVariablesPath = isToyotaBrand() ? "T1" : "L1";
  return stringToBool(_.get(window, "".concat(envVariablesPath, ".settings.isProduction")));
};
/**
 * @function isLocalHost
 * @description returns true/false if the environment is localhost
 */
var isLocalHost = function isLocalHost() {
  var host = window.location.hostname;
  return host === "localhost" || host === "127.0.0.1" || host.indexOf("amazonaws.com") > -1 || host.indexOf("192.168.") > -1;
};

/**
 * @module usabilla
 */
var WIDGET_LOAD_EVENT = {
  event: "usabillaInpageLoad"
};
var dataLayerFallback = {
  push: function push(event) {
    if (!isProduction()) {
      // eslint-disable-next-line no-console
      console.error("gtmHelper: Invalid dataLayer object.", event);
    }
  }
};
var getDataLayer = function getDataLayer() {
  return _.isArray(window.dataLayer) ? window.dataLayer : dataLayerFallback;
};
/**
 * @function loadInpageUsabillaWidget
 * @description Usabilla Widget loading script is injected via GTM.
 */
var loadInpageUsabillaWidget = function loadInpageUsabillaWidget() {
  getDataLayer().push(WIDGET_LOAD_EVENT);
};

// eslint-disable-next-line react/display-name
var UsabillaWidget = /*#__PURE__*/React__default.memo(function (_ref) {
  var usabillaWidgetId = _ref.usabillaWidgetId,
    classNames = _ref.classNames;
  useEffect(function () {
    usabillaWidgetId && loadInpageUsabillaWidget();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return usabillaWidgetId ? ( /*#__PURE__*/React__default.createElement("div", {
    className: classNames,
    "ub-in-page": usabillaWidgetId
  })) : null;
});

var EcoEmissionLabels = function EcoEmissionLabels(_ref) {
  var labels = _ref.labels,
    thumbnailsAmount = _ref.thumbnailsAmount,
    title = _ref.title,
    link = _ref.link,
    linkLabel = _ref.linkLabel,
    style = _ref.style,
    fixedPosition = _ref.fixedPosition,
    zIndex = _ref.zIndex;
  var ecoLabelPopup = _.get(window, "dxp.settings.ecoLabelpopup");
  return /*#__PURE__*/React__default.createElement("dxp-emission-label", {
    "data-title": title === "" ? null : title,
    "data-more-info-link": link || (ecoLabelPopup === null || ecoLabelPopup === void 0 ? void 0 : ecoLabelPopup.readMoreLink),
    "data-more-info-link-label": linkLabel || (ecoLabelPopup === null || ecoLabelPopup === void 0 ? void 0 : ecoLabelPopup.moreInfoLinkLabel),
    "data-style": style === "" ? null : style,
    "data-thumbnails-count": thumbnailsAmount || "1",
    "data-labels": JSON.stringify(labels),
    "data-fixed-position": fixedPosition,
    "data-z-index": zIndex
  });
};

var DealerFinder = function DealerFinder(_a) {
  var className = _a.className,
    defaultSearch = _a.defaultSearch,
    _a$disableSaveAsPrefe = _a.disableSaveAsPreferred,
    disableSaveAsPreferred = _a$disableSaveAsPrefe === void 0 ? true : _a$disableSaveAsPrefe,
    _a$enableDealerRating = _a.enableDealerRating,
    enableDealerRating = _a$enableDealerRating === void 0 ? false : _a$enableDealerRating,
    _a$enableSelectButton = _a.enableSelectButton,
    enableSelectButton = _a$enableSelectButton === void 0 ? false : _a$enableSelectButton,
    _a$enableDynamicMap = _a.enableDynamicMap,
    enableDynamicMap = _a$enableDynamicMap === void 0 ? true : _a$enableDynamicMap,
    _a$onDealerCardSelect = _a.onDealerCardSelected,
    onDealerCardSelected = _a$onDealerCardSelect === void 0 ? function () {
      return null;
    } : _a$onDealerCardSelect,
    _a$onDealerSpecifical = _a.onDealerSpecificallySelected,
    onDealerSpecificallySelected = _a$onDealerSpecifical === void 0 ? function () {
      return null;
    } : _a$onDealerSpecifical,
    _a$onDealerSearchErro = _a.onDealerSearchError,
    onDealerSearchError = _a$onDealerSearchErro === void 0 ? function () {
      return null;
    } : _a$onDealerSearchErro,
    _a$readOnlySelectedSe = _a.readOnlySelectedServices,
    readOnlySelectedServices = _a$readOnlySelectedSe === void 0 ? true : _a$readOnlySelectedSe,
    _a$searchType = _a.searchType,
    searchType = _a$searchType === void 0 ? "location" : _a$searchType,
    _a$searchResultCount = _a.searchResultCount,
    searchResultCount = _a$searchResultCount === void 0 ? 10 : _a$searchResultCount,
    _a$services = _a.services,
    services = _a$services === void 0 ? "ShowRoom" : _a$services,
    _a$searchLayout = _a.searchLayout,
    searchLayout = _a$searchLayout === void 0 ? "inline" : _a$searchLayout,
    _a$showNotMatchingSer = _a.showNotMatchingServices,
    showNotMatchingServices = _a$showNotMatchingSer === void 0 ? false : _a$showNotMatchingSer,
    _a$softFilteringDisab = _a.softFilteringDisableDealer,
    softFilteringDisableDealer = _a$softFilteringDisab === void 0 ? false : _a$softFilteringDisab,
    _a$shouldPreselectPre = _a.shouldPreselectPreferredDealer,
    shouldPreselectPreferredDealer = _a$shouldPreselectPre === void 0 ? true : _a$shouldPreselectPre,
    _a$shouldRemoveMainGu = _a.shouldRemoveMainGutter,
    shouldRemoveMainGutter = _a$shouldRemoveMainGu === void 0 ? true : _a$shouldRemoveMainGu,
    _a$shouldHideHeader = _a.shouldHideHeader,
    shouldHideHeader = _a$shouldHideHeader === void 0 ? true : _a$shouldHideHeader,
    _a$shouldHideServiceF = _a.shouldHideServiceFilter,
    shouldHideServiceFilter = _a$shouldHideServiceF === void 0 ? false : _a$shouldHideServiceF,
    _a$tilesLayout = _a.tilesLayout,
    tilesLayout = _a$tilesLayout === void 0 ? "MD" : _a$tilesLayout,
    _a$theme = _a.theme,
    theme = _a$theme === void 0 ? "transparent" : _a$theme,
    _a$dealerId = _a.dealerId,
    dealerId = _a$dealerId === void 0 ? null : _a$dealerId,
    _a$hashSetup = _a.hashSetup,
    hashSetup = _a$hashSetup === void 0 ? "" : _a$hashSetup,
    otherProps = __rest(_a, ["className", "defaultSearch", "disableSaveAsPreferred", "enableDealerRating", "enableSelectButton", "enableDynamicMap", "onDealerCardSelected", "onDealerSpecificallySelected", "onDealerSearchError", "readOnlySelectedServices", "searchType", "searchResultCount", "services", "searchLayout", "showNotMatchingServices", "softFilteringDisableDealer", "shouldPreselectPreferredDealer", "shouldRemoveMainGutter", "shouldHideHeader", "shouldHideServiceFilter", "tilesLayout", "theme", "dealerId", "hashSetup"]);
  return /*#__PURE__*/React__default.createElement("tme-dealerfinder", Object.assign({}, Object.assign({
    "class": classNames("cp-dealerfinder", className, {
      'cp-dealerfinder-transparent-bg': theme === "transparent",
      'cp-remove-df-gutter': shouldRemoveMainGutter
    }),
    dealercount: searchResultCount,
    disablesave: disableSaveAsPreferred,
    enableselect: enableSelectButton,
    'hide-header': shouldHideHeader,
    'hide-services': shouldHideServiceFilter,
    isdynamicmap: enableDynamicMap,
    isdealerrating: enableDealerRating,
    'is-prefill-preferred-dealer': shouldPreselectPreferredDealer,
    ondealererror: onDealerSearchError,
    ondealerselect: function ondealerselect(event) {
      if (event === null || event === void 0 ? void 0 : event.explicitSelect) {
        onDealerSpecificallySelected(event);
      } else {
        onDealerCardSelected(event);
      }
    },
    'read-only-selected-services': readOnlySelectedServices,
    services: services,
    'soft-filtering-disable-dealer': softFilteringDisableDealer,
    search: defaultSearch,
    'search-layout': searchLayout,
    searchtype: searchType,
    'show-not-matching-services': showNotMatchingServices,
    'tiles-layout': tilesLayout,
    uuid: dealerId,
    theme: theme,
    hashsetup: hashSetup,
    hashoverride: false
  }, otherProps)));
};

var css_248z$r = ".toyCo_GoBack-goBack-13515042:focus-visible{outline:var(--cp-accessibility-outline);outline-offset:2px}.toyCo_GoBack-goBack-13515042:is(.dxp-lexus *){align-items:flex-end}.toyCo_GoBack-goBack-13515042 .icon-Arrow_Left-small:is(.dxp-lexus *){padding-left:.5rem;padding-top:0}.toyCo_GoBack-goBackChevron-13615042{--cp-btn-icon-before-pr:0}.toyCo_GoBack-goBackChevron-13615042 .icon-Chevron_Left-small{background-color:var(--cp-grey-light-4);border-radius:50%;height:var(--cp-md-space);margin-right:var(--cp-xs-space);width:var(--cp-md-space)}.toyCo_GoBack-goBackChevron-13615042 .icon-Chevron_Left-small:before{color:var(--cp-grey-dark-2);line-height:var(--cp-md-space)}";
var styles$r = {"goBack":"toyCo_GoBack-goBack-13515042","goBackChevron":"toyCo_GoBack-goBackChevron-13615042"};
styleInject(css_248z$r);

var GoBack = function GoBack(_a) {
  var _a$label = _a.label,
    label = _a$label === void 0 ? TRIDION_LABEL_MISSING : _a$label,
    disabled = _a.disabled,
    _a$classNames = _a.classNames,
    classNames$1 = _a$classNames === void 0 ? "" : _a$classNames,
    _a$onClick = _a.onClick,
    onClick = _a$onClick === void 0 ? function () {
      return null;
    } : _a$onClick,
    testId = _a.testId,
    href = _a.href,
    _a$shouldUseDxpLexusB = _a.shouldUseDxpLexusButton,
    shouldUseDxpLexusButton = _a$shouldUseDxpLexusB === void 0 ? true : _a$shouldUseDxpLexusB,
    isChevronLayout = _a.isChevronLayout,
    otherButtonProps = __rest(_a, ["label", "disabled", "classNames", "onClick", "testId", "href", "shouldUseDxpLexusButton", "isChevronLayout"]);
  return /*#__PURE__*/React__default.createElement(Button
  //chevron layout is not supported with dxpLexusButton
  , Object.assign({
    //chevron layout is not supported with dxpLexusButton
    shouldUseDxpLexusButton: isChevronLayout ? false : shouldUseDxpLexusButton,
    kind: BUTTON_KINDS.ICON_LINK,
    tagType: "a",
    iconAfterText: false,
    iconType: "DXPICON",
    iconClass: isChevronLayout ? "icon-Chevron_Left-small" : "icon-Arrow_Left-small",
    classNames: classNames(classNames$1, isChevronLayout ? styles$r.goBackChevron : styles$r.goBack),
    label: label,
    testId: testId,
    onClick: onClick,
    disabled: disabled,
    href: href
  }, otherButtonProps));
};

var css_248z$q = ".toyCo_ReadMore-readMore-13015042:is(.dxp-lexus *){align-items:flex-end}.toyCo_ReadMore-readMore-13015042 .icon-Arrow_Right-small:is(.dxp-toyota *):before{margin-bottom:-3px}.toyCo_ReadMore-readMore-13015042 .icon-Arrow_Right-small:is(.dxp-lexus *){padding-left:.5rem;padding-top:0}";
var styles$q = {"readMore":"toyCo_ReadMore-readMore-13015042"};
styleInject(css_248z$q);

var ReadMore = function ReadMore(_a) {
  var _a$label = _a.label,
    label = _a$label === void 0 ? TRIDION_LABEL_MISSING : _a$label,
    disabled = _a.disabled,
    _a$classNames = _a.classNames,
    classNames$1 = _a$classNames === void 0 ? "" : _a$classNames,
    _a$onClick = _a.onClick,
    onClick = _a$onClick === void 0 ? function () {
      return null;
    } : _a$onClick,
    testId = _a.testId,
    href = _a.href,
    _a$shouldUseDxpLexusB = _a.shouldUseDxpLexusButton,
    shouldUseDxpLexusButton = _a$shouldUseDxpLexusB === void 0 ? true : _a$shouldUseDxpLexusB,
    otherButtonProps = __rest(_a, ["label", "disabled", "classNames", "onClick", "testId", "href", "shouldUseDxpLexusButton"]);
  return /*#__PURE__*/React__default.createElement(Button, Object.assign({
    shouldUseDxpLexusButton: shouldUseDxpLexusButton,
    kind: BUTTON_KINDS.ICON_LINK,
    tagType: "a",
    iconAfterText: true,
    iconType: "DXPICON",
    iconClass: "icon-Arrow_Right-small",
    classNames: classNames(classNames$1, styles$q.readMore),
    label: label,
    testId: testId,
    onClick: onClick,
    disabled: disabled,
    href: href
  }, otherButtonProps));
};

var scrollToElement = function scrollToElement(sectionId, scrollToOptions, topFixedElementHeight) {
  var topFixedElementIds = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  var element = document.getElementById(sectionId);
  if (element) {
    var elementPosition = getElementPositionOnDocument(element);
    var scrollToBottomExtra = scrollToOptions.scrollToBottom ? $$1(element).height() : 0;
    var elementPositionFromTop = elementPosition && elementPosition.top || 0;
    var elementPositionFromLeft = elementPosition && elementPosition.left || 0;
    var extraHeightToConsider = (topFixedElementHeight || 0) + getFixedElementsHeightSum(topFixedElementIds);
    var goToPosition = elementPositionFromTop - extraHeightToConsider +
    //@ts-expect-error will fix in CPBL-31212
    scrollToBottomExtra;
    window.scrollTo({
      left: elementPositionFromLeft,
      top: goToPosition,
      behavior: scrollToOptions.behavior
    });
  }
};
var ScrollToAnchor = function ScrollToAnchor(_ref) {
  var children = _ref.children,
    _ref$sectionId = _ref.sectionId,
    sectionId = _ref$sectionId === void 0 ? "" : _ref$sectionId,
    classNames = _ref.classNames,
    _ref$scrollToOptions = _ref.scrollToOptions,
    scrollToOptions = _ref$scrollToOptions === void 0 ? {
      behavior: "smooth"
    } : _ref$scrollToOptions,
    _ref$topFixedElementH = _ref.topFixedElementHeight,
    topFixedElementHeight = _ref$topFixedElementH === void 0 ? 0 : _ref$topFixedElementH,
    _ref$topFixedElementI = _ref.topFixedElementIds,
    topFixedElementIds = _ref$topFixedElementI === void 0 ? [] : _ref$topFixedElementI;
  var onClick = function onClick() {
    return scrollToElement(sectionId, scrollToOptions, topFixedElementHeight, topFixedElementIds);
  };
  return /*#__PURE__*/React__default.createElement("a", {
    className: classNames,
    onClick: onClick
  }, children);
};

var Card = function Card(_ref) {
  var className = _ref.className,
    children = _ref.children,
    isSelected = _ref.isSelected,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? function () {
      return null;
    } : _ref$onClick,
    options = _ref.options,
    testId = _ref.testId;
  var _ref2 = options || {},
    isSelectable = _ref2.isSelectable,
    useBoxShadowTransition = _ref2.useBoxShadowTransition;
  return /*#__PURE__*/React__default.createElement("div", {
    className: classNames(className, "cp-card", {
      'cp-card-selectable': isSelectable,
      'cp-selected': isSelected,
      'cp-card-box-shadow-trans': useBoxShadowTransition
    }),
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    onClick: onClick,
    "data-test-id": testId
  }, children);
};

var css_248z$p = ".toyCo_Accordion-heading-1715042{align-items:center;cursor:pointer;display:flex;margin-bottom:1rem;padding-bottom:1rem}.toyCo_Accordion-heading-1715042:focus-visible{border-radius:.2rem;outline:var(--cp-accessibility-outline)}.toyCo_Accordion-icon-1815042{margin-left:auto;margin-right:.5rem}.toyCo_Accordion-divider-1915042{border-bottom:.1rem solid var(--cp-grey-light)}";
var styles$p = {"heading":"toyCo_Accordion-heading-1715042","icon":"toyCo_Accordion-icon-1815042","divider":"toyCo_Accordion-divider-1915042"};
styleInject(css_248z$p);

var css_248z$o = ".toyCo_Collapsible-collapsible-2015042{--visiblePxWhenClosed:0;background-color:transparent;margin-bottom:10px;max-height:var(--maxHeightOpen);overflow:hidden;position:relative;transition:max-height .3s ease 0s;width:100%}.toyCo_Collapsible-collapsible-2015042 .toyCo_Collapsible-collapsibleButton-2115042{border:none;min-width:0;overflow:var(--toyCo-collapsible-btn-ovf,hidden);padding:0;text-align:var(--toyCo-collapsible-btn-ta,right);z-index:0}.toyCo_Collapsible-collapsible-2015042 .toyCo_Collapsible-collapsibleButton-2115042,.toyCo_Collapsible-collapsible-2015042 .toyCo_Collapsible-collapsibleButton-2115042:active,.toyCo_Collapsible-collapsible-2015042 .toyCo_Collapsible-collapsibleButton-2115042:focus,.toyCo_Collapsible-collapsible-2015042 .toyCo_Collapsible-collapsibleButton-2115042:hover{background:var(--toyCo-collapsible-btn-bg,transparent)}.toyCo_Collapsible-collapsible-2015042 .toyCo_Collapsible-collapsibleButton-2115042:hover{text-decoration:underline}.toyCo_Collapsible-collapsible-2015042 .toyCo_Collapsible-collapsibleButton-2115042:active,.toyCo_Collapsible-collapsible-2015042 .toyCo_Collapsible-collapsibleButton-2115042:focus,.toyCo_Collapsible-collapsible-2015042 .toyCo_Collapsible-collapsibleButton-2115042:hover{border-bottom:none;line-height:var(--toyCo-collapsible-btn-lh,unset);opacity:1}.toyCo_Collapsible-collapsible-2015042 .toyCo_Collapsible-collapsibleButton-2115042:after{display:var(--toyCo-collapsible-btn-chevron-d,none);font-family:dxp-icon;margin-left:5px;margin-top:2px;position:absolute}.toyCo_Collapsible-collapsibleBorder-2215042{border-bottom:1px solid rgba(40,40,48,.05);border-top:0}.toyCo_Collapsible-collapsibleClosed-2315042{max-height:var(--visiblePxWhenClosed);transition:max-height .3s ease 0s}.toyCo_Collapsible-collapsibleClosed-2315042 button.cp-btn{height:unset;line-height:var(--toyCo-collapsible-btn-lh,unset);min-width:100%}.toyCo_Collapsible-collapsibleGradientContainer-2415042:after{content:\"\";inset:0;opacity:0;position:absolute;transition:opacity .3s ease 0s}.toyCo_Collapsible-collapsibleGradientContainer-2415042.toyCo_Collapsible-closedGradient-2515042:after{background:linear-gradient(60deg,var(--color1),var(--color2) 60%,var(--color3));background:-webkit-linear-gradient(60deg,var(--color1),var(--color2) 60%,var(--color3));opacity:1}.toyCo_Collapsible-collapsibleButton-2115042{--cp-btn-mb:0;position:relative}.toyCo_Collapsible-collapsibleButton-2115042:is(.dxp-toyota *):after{content:\"\\e9bd\"}.toyCo_Collapsible-collapsibleButton-2115042:is(.dxp-lexus *):after{content:\"\\e9bc\"}.toyCo_Collapsible-collapsibleButtonClosed-2615042{bottom:0;position:absolute;right:0}.toyCo_Collapsible-collapsibleButtonClosed-2615042:is(.dxp-toyota *):after{content:\"\\e9b4\"}.toyCo_Collapsible-collapsibleButtonClosed-2615042:is(.dxp-lexus *):after{content:\"\\e9b1\"}.toyCo_Collapsible-buttonGradient-2715042 button.cp-btn{--toyCo-collapsible-btn-bg:linear-gradient(45deg,var(--color1),var(--color2) 75%,var(--color3));border-radius:0;margin-right:0}";
var styles$o = {"collapsible":"toyCo_Collapsible-collapsible-2015042","collapsibleButton":"toyCo_Collapsible-collapsibleButton-2115042","collapsibleBorder":"toyCo_Collapsible-collapsibleBorder-2215042","collapsibleClosed":"toyCo_Collapsible-collapsibleClosed-2315042","collapsibleGradientContainer":"toyCo_Collapsible-collapsibleGradientContainer-2415042","closedGradient":"toyCo_Collapsible-closedGradient-2515042","collapsibleButtonClosed":"toyCo_Collapsible-collapsibleButtonClosed-2615042","buttonGradient":"toyCo_Collapsible-buttonGradient-2715042"};
styleInject(css_248z$o);

function findHeight(ref, entries) {
  var _a;
  var entry = entries.find(function (entry) {
    return entry.target === ref.current;
  });
  return (_a = entry === null || entry === void 0 ? void 0 : entry.contentRect) === null || _a === void 0 ? void 0 : _a.height;
}
/* istanbul ignore next */
var useHeightChange = function useHeightChange(ref) {
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    height = _useState2[0],
    setHeight = _useState2[1];
  useEffect(function () {
    var observer = new window.ResizeObserver(function (entries) {
      var height = findHeight(ref, entries);
      if (height) {
        setHeight(height);
      }
    });
    if (ref === null || ref === void 0 ? void 0 : ref.current) {
      observer.observe(ref.current);
    }
    return function () {
      if (ref === null || ref === void 0 ? void 0 : ref.current) {
        observer.unobserve(ref.current);
      }
    };
  }, [ref]);
  return height;
};

var CollapsibleAccessibilityContext = /*#__PURE__*/createContext(true);
var CollapsibleBase = function CollapsibleBase(_ref) {
  var className = _ref.className,
    children = _ref.children,
    classNameForContainer = _ref.classNameForContainer,
    belowContent = _ref.belowContent,
    aboveContent = _ref.aboveContent,
    isOpen = _ref.isOpen,
    forwardedRef = _ref.forwardedRef,
    _ref$useForwardContai = _ref.useForwardContainerRef,
    useForwardContainerRef = _ref$useForwardContai === void 0 ? false : _ref$useForwardContai,
    containerStyle = _ref.containerStyle,
    id = _ref.id;
  var refCollapsibleContainer = useRef(null);
  var setRefCallback = useCallback(function (node) {
    if (node) {
      refCollapsibleContainer.current = node;
    }
  }, []);
  var collapsibleClassNames = classNames(styles$o.collapsible, className, _defineProperty({}, styles$o.collapsibleClosed, !isOpen));
  var height = useHeightChange(refCollapsibleContainer);
  var mergedContainerStyle = Object.assign({
    '--maxHeightOpen': "".concat(height, "px")
  }, containerStyle);
  return /*#__PURE__*/React__default.createElement("div", Object.assign({}, {
    style: mergedContainerStyle,
    className: collapsibleClassNames,
    id: id
  }), aboveContent, /*#__PURE__*/React__default.createElement(CollapsibleAccessibilityContext.Provider, {
    value: isOpen
  }, /*#__PURE__*/React__default.createElement("div", {
    className: classNameForContainer,
    ref: useForwardContainerRef ? forwardedRef : setRefCallback
  }, children)), belowContent);
};

var Accordion = function Accordion(_ref) {
  var sections = _ref.sections,
    testId = _ref.testId,
    classNameForContainer = _ref.classNameForContainer,
    classNameForHeading = _ref.classNameForHeading,
    classNameForHeadingChild = _ref.classNameForHeadingChild,
    _ref$useDivider = _ref.useDivider,
    useDivider = _ref$useDivider === void 0 ? false : _ref$useDivider,
    controlledOpenSections = _ref.controlledOpenSections,
    onSectionToggle = _ref.onSectionToggle;
  var getInitialOpenSections = function getInitialOpenSections() {
    if (controlledOpenSections) {
      return controlledOpenSections;
    }
    return sections.map(function () {
      return false;
    });
  };
  var _useState = useState(getInitialOpenSections()),
    _useState2 = _slicedToArray(_useState, 2),
    openSections = _useState2[0],
    setOpenSections = _useState2[1];
  var isAccessible = useContext(CollapsibleAccessibilityContext);
  useEffect(function () {
    if (controlledOpenSections) {
      setOpenSections(controlledOpenSections);
    }
  }, [controlledOpenSections]);
  var toggleAccordion = function toggleAccordion(index) {
    if (controlledOpenSections && onSectionToggle) {
      onSectionToggle(index);
    } else {
      setOpenSections(function (prev) {
        var newState = _toConsumableArray(prev);
        newState[index] = !newState[index];
        return newState;
      });
    }
  };
  return /*#__PURE__*/React__default.createElement("div", {
    "data-test-id": testId,
    className: classNameForContainer
  }, sections.map(function (section, index) {
    var isOpened = openSections[index];
    var screenReaderLabel = section === null || section === void 0 ? void 0 : section.screenReaderLabel;
    var headingClassname = classNames(styles$p.heading, classNameForHeading, useDivider ? styles$p.divider : "");
    var iconClassname = classNames(styles$p.icon, isOpened ? "icon-Chevron_Up-small" : "icon-Chevron_Down-small");
    return /*#__PURE__*/React__default.createElement("div", {
      "data-test-id": "".concat(testId).concat(index),
      key: index
    }, /*#__PURE__*/React__default.createElement("div", {
      className: headingClassname,
      role: "button",
      onClick: function onClick() {
        return toggleAccordion(index);
      },
      tabIndex: isAccessible ? 0 : -1,
      onKeyDown: function onKeyDown(e) {
        e.key === "Enter" && toggleAccordion(index);
      },
      "aria-label": "".concat(screenReaderLabel !== null && screenReaderLabel !== void 0 ? screenReaderLabel : "", " ").concat(isOpened ? "expanded" : "collapsed")
    }, /*#__PURE__*/React__default.createElement("div", {
      className: classNames(classNameForHeadingChild),
      "aria-hidden": true
    }, section.heading), section.showChevron && ( /*#__PURE__*/React__default.createElement(Icon, {
      iconType: "DXPICON",
      className: iconClassname
    }))), /*#__PURE__*/React__default.createElement(CollapsibleBase, {
      isOpen: isOpened,
      className: styles$p.section,
      "aria-hidden": true
    }, section.body));
  }));
};

var toggleCollapsible = function toggleCollapsible(isOpen, setIsOpen, useScrollToTop, collapsibleId, topFixedElementIds) {
  if (useScrollToTop && isOpen) {
    scrollToElement(collapsibleId, {
      behavior: "smooth"
    }, 0, topFixedElementIds);
  }
  setIsOpen(!isOpen);
};
var getMaxHeight = function getMaxHeight(isOpen, isVisibleButton, lineHeightInPx, visibleLinesWhenClosed, titleHeight, collapsibleContainerHeight, buttonHeight) {
  var result;
  if (isVisibleButton && !isOpen) {
    result = titleHeight + visibleLinesWhenClosed * lineHeightInPx;
  } else {
    result = titleHeight + collapsibleContainerHeight + buttonHeight;
  }
  return result;
};

/**
 * @function useViewportChange
 * @description returns viewport info
 * @param debounceTimer {number}
 */
var useViewportChange = function useViewportChange() {
  var debounceTimer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 250;
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    viewportData = _useState2[0],
    setViewportData = _useState2[1];
  useEffect(function () {
    var updateViewportData = function updateViewportData() {
      var newViewportData = getViewportData();
      if (!_.isEqual(newViewportData, viewportData)) {
        setViewportData(newViewportData);
      }
    };
    var handleWindowResize = debounce(updateViewportData, debounceTimer);
    updateViewportData();
    window.addEventListener("resize", handleWindowResize);
    return function () {
      return window.removeEventListener("resize", handleWindowResize);
    };
  }, [debounceTimer, viewportData]);
  return viewportData;
};

var idCounter$3 = 1;
var gradientCollapsibleOptionsDefault = {
  color1: "#ffffff80",
  color2: "#ffffff",
  color3: "#ffffff",
  fullGradient: false
};
var Collapsible = function Collapsible(_ref) {
  var buttonLabelOpen = _ref.buttonLabelOpen,
    buttonLabelClosed = _ref.buttonLabelClosed,
    className = _ref.className,
    _ref$displayButton = _ref.displayButton,
    displayButton = _ref$displayButton === void 0 ? true : _ref$displayButton,
    title = _ref.title,
    titleClassName = _ref.titleClassName,
    buttonDefaultClassName = _ref.buttonDefaultClassName,
    children = _ref.children,
    _ref$isOpenProp = _ref.isOpenProp,
    isOpenProp = _ref$isOpenProp === void 0 ? false : _ref$isOpenProp,
    testId = _ref.testId,
    _ref$isGradientCollap = _ref.isGradientCollapsible,
    isGradientCollapsible = _ref$isGradientCollap === void 0 ? false : _ref$isGradientCollap,
    _ref$gradientCollapsi = _ref.gradientCollapsibleOptions,
    gradientCollapsibleOptions = _ref$gradientCollapsi === void 0 ? gradientCollapsibleOptionsDefault : _ref$gradientCollapsi,
    _ref$visibleLinesWhen = _ref.visibleLinesWhenClosed,
    visibleLinesWhenClosed = _ref$visibleLinesWhen === void 0 ? 0 : _ref$visibleLinesWhen,
    oneLineHeightInPx = _ref.oneLineHeightInPx,
    visiblePxWhenClosed = _ref.visiblePxWhenClosed,
    textElementRef = _ref.textElementRef,
    classNameForContainer = _ref.classNameForContainer,
    noBorder = _ref.noBorder,
    maxHeightOpen = _ref.maxHeightOpen,
    _ref$buttonHeight = _ref.buttonHeight,
    buttonHeight = _ref$buttonHeight === void 0 ? 48 : _ref$buttonHeight,
    useScrollToTop = _ref.useScrollToTop,
    topFixedElementIds = _ref.topFixedElementIds,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? "tc-collapsible-" : _ref$id;
  var _a, _b;
  var collapsibleId = useMemo(function () {
    return id + ++idCounter$3;
  }, [id]);
  var refTitle = useRef(null);
  var refCollapsibleContainer = useRef(null);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    didMount = _useState4[0],
    setDidMount = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isVisibleButton = _useState6[0],
    setIsVisibleButton = _useState6[1];
  useViewportChange();
  useEffect(function () {
    setDidMount(true);
  }, []);
  var buttonLabel = isOpen ? buttonLabelOpen : buttonLabelClosed;
  var _ref2 = gradientCollapsibleOptions || {},
    color1 = _ref2.color1,
    color2 = _ref2.color2,
    color3 = _ref2.color3,
    fullGradient = _ref2.fullGradient;
  var collapsibleClassNames = classNames(className, _defineProperty({}, styles$o.buttonGradient, isGradientCollapsible && !fullGradient && !isOpen), _defineProperty({}, styles$o.collapsibleBorder, !noBorder && visibleLinesWhenClosed !== 0));
  var collapsibleContainerClassNames = classNames(classNameForContainer, _defineProperty({}, styles$o.collapsibleGradientContainer, isGradientCollapsible && fullGradient), _defineProperty({}, styles$o.closedGradient, !isOpen && fullGradient));
  var buttonClassNames = classNames(styles$o.collapsibleButton, !isOpen && styles$o.collapsibleButtonClosed, buttonDefaultClassName);
  var titleHeight = ((_a = refTitle === null || refTitle === void 0 ? void 0 : refTitle.current) === null || _a === void 0 ? void 0 : _a.clientHeight) || 0;
  var collapsibleContainerContentHeight = ((_b = refCollapsibleContainer === null || refCollapsibleContainer === void 0 ? void 0 : refCollapsibleContainer.current) === null || _b === void 0 ? void 0 : _b.clientHeight) || 0;
  var lineHeightInPx = oneLineHeightInPx || convertLineHeightToNumber(_.get(textElementRef, "current.style.lineHeight")) || parseInt(String(didMount ? $$1("body").css("line-height") : 24)) || 24;
  var hasVisibleLineWhenClosed = _.isNumber(visibleLinesWhenClosed) && visibleLinesWhenClosed > 0;
  var collapsibleContainerHeightPx = collapsibleContainerContentHeight ? "".concat(collapsibleContainerContentHeight + titleHeight, "px") : null;
  var containerStyle = Object.assign(Object.assign(Object.assign(Object.assign({}, isGradientCollapsible && {
    '--color1': color1,
    '--color2': color2,
    '--color3': color3
  }), {
    '--visiblePxWhenClosed': visiblePxWhenClosed || "70px",
    '--maxHeightOpen': maxHeightOpen || collapsibleContainerHeightPx || "unset"
  }), hasVisibleLineWhenClosed && {
    maxHeight: getMaxHeight(isOpen, isVisibleButton, lineHeightInPx, visibleLinesWhenClosed, titleHeight, collapsibleContainerContentHeight, buttonHeight) + "px"
  }), {
    '--line-height-in-px': lineHeightInPx + "px"
  });
  useEffect(function () {
    setIsVisibleButton(visiblePxWhenClosed || hasVisibleLineWhenClosed ? displayButton : false);
  }, [displayButton, visiblePxWhenClosed, hasVisibleLineWhenClosed]);
  useEffect(function () {
    setIsOpen(visiblePxWhenClosed || hasVisibleLineWhenClosed ? isOpenProp : true);
  }, [isOpenProp, visiblePxWhenClosed, hasVisibleLineWhenClosed]);
  return /*#__PURE__*/React__default.createElement(CollapsibleBase, Object.assign({}, {
    className: collapsibleClassNames,
    children: children,
    classNameForContainer: collapsibleContainerClassNames,
    belowContent: isVisibleButton && ( /*#__PURE__*/React__default.createElement(Button, Object.assign({}, {
      classNames: buttonClassNames,
      kind: BUTTON_KINDS.TERTIARY,
      shouldUseDxpLexusButton: false,
      label: buttonLabel,
      onClick: function onClick() {
        return toggleCollapsible(isOpen, setIsOpen, useScrollToTop, collapsibleId, topFixedElementIds);
      },
      testId: testId
    }))),
    aboveContent: ( /*#__PURE__*/React__default.createElement("div", {
      className: titleClassName,
      ref: refTitle
    }, title)),
    isOpen: isOpen,
    forwardedRef: refCollapsibleContainer,
    useForwardContainerRef: true,
    containerStyle: containerStyle,
    id: collapsibleId
  }), children);
};

var css_248z$n = ".toyCo_CollapsibleContainer-showMoreLessContainer-12715042 .toyCo_CollapsibleContainer-showMoreLessLabel-12815042{align-items:center;display:inline-flex}.toyCo_CollapsibleContainer-showMoreLessContainer-12715042 .toyCo_CollapsibleContainer-showMoreLessLabel-12815042 .toyCo_CollapsibleContainer-icon-12915042{color:#6a6b70;font-size:18px;margin-right:10px}";
var styles$n = {"showMoreLessContainer":"toyCo_CollapsibleContainer-showMoreLessContainer-12715042","showMoreLessLabel":"toyCo_CollapsibleContainer-showMoreLessLabel-12815042","icon":"toyCo_CollapsibleContainer-icon-12915042"};
styleInject(css_248z$n);

/**
 * @deprecated This file is no longer being used and will be removed in a future release.
 */
var CollapsibleContainer = function CollapsibleContainer(_ref) {
  var initialSize = _ref.initialSize,
    increaseOf = _ref.increaseOf,
    decreaseOf = _ref.decreaseOf,
    children = _ref.children,
    ShowMoreComponent = _ref.ShowMoreComponent,
    ShowLessComponent = _ref.ShowLessComponent,
    showMoreLabel = _ref.showMoreLabel,
    showLessLabel = _ref.showLessLabel,
    showMoreLessClassname = _ref.showMoreLessClassname,
    isCtaOnTop = _ref.isCtaOnTop,
    onShowMoreCallback = _ref.onShowMoreCallback,
    onShowLessCallback = _ref.onShowLessCallback,
    hideMoreLessWhenChildrenLessThanInitialSize = _ref.hideMoreLessWhenChildrenLessThanInitialSize;
  var _useState = useState(Math.min(initialSize, React__default.Children.toArray(children).length)),
    _useState2 = _slicedToArray(_useState, 2),
    amountOfItemsToShow = _useState2[0],
    setAmountOfItemsToShow = _useState2[1],
    lessChildrenThanInitialSize = React__default.Children.toArray(children).length < initialSize;
  var onShowMore = function onShowMore() {
    onShowMoreCallback && onShowMoreCallback();
    increaseOf > 0 ? setAmountOfItemsToShow(Math.min(amountOfItemsToShow + increaseOf, React__default.Children.toArray(children).length)) : setAmountOfItemsToShow(React__default.Children.toArray(children).length);
  };
  var onShowLess = function onShowLess() {
    onShowLessCallback && onShowLessCallback();
    var newAmountOfItemsToDisplay = amountOfItemsToShow - decreaseOf;
    decreaseOf > 0 && newAmountOfItemsToDisplay >= 0 ? setAmountOfItemsToShow(newAmountOfItemsToDisplay) : setAmountOfItemsToShow(initialSize);
  };
  var renderMoreLessCta = function renderMoreLessCta(isMore) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: "".concat(showMoreLessClassname, " ").concat(styles$n.showMoreLessContainer)
    }, isMore ? ShowMoreComponent ? /*#__PURE__*/React__default.createElement(ShowMoreComponent, {
      onClick: onShowMore
    }) : defaultMoreLessComponent(onShowMore, showMoreLabel, "".concat(styles$n.icon, " icon-Plus-small")) : ShowLessComponent ? /*#__PURE__*/React__default.createElement(ShowLessComponent, {
      onClick: onShowLess
    }) : defaultMoreLessComponent(onShowLess, showLessLabel, "".concat(styles$n.icon, " icon-Minus-small")));
  };
  var defaultMoreLessComponent = function defaultMoreLessComponent(onClick, label, iconStyle) {
    return /*#__PURE__*/React__default.createElement(Text, {
      kind: TEXT_KINDS.SPAN,
      className: "".concat(styles$n.showMoreLessLabel),
      onClick: onClick
    }, /*#__PURE__*/React__default.createElement(Icon, {
      className: "".concat(iconStyle),
      iconType: ICON_KINDS.DXPICON
    }), label);
  };
  var displayMoreLessCta = hideMoreLessWhenChildrenLessThanInitialSize && lessChildrenThanInitialSize ? null : renderMoreLessCta(React__default.Children.toArray(children).length > amountOfItemsToShow);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, isCtaOnTop && displayMoreLessCta, _.take(React__default.Children.toArray(children), amountOfItemsToShow), !isCtaOnTop && displayMoreLessCta);
};
CollapsibleContainer.defaultProps = {
  initialSize: 0,
  isCtaOnTop: false,
  showMoreLabel: "See more",
  showLessLabel: "See less",
  showMoreLessClassname: "",
  hideMoreLessWhenChildrenLessThanInitialSize: false
};
CollapsibleContainer.propTypes = {
  initialSize: PropTypes.number,
  increaseOf: PropTypes.number,
  decreaseOf: PropTypes.number,
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
  ShowMoreComponent: PropTypes.func,
  ShowLessComponent: PropTypes.func,
  showMoreLabel: PropTypes.string,
  showLessLabel: PropTypes.string,
  showMoreLessClassname: PropTypes.string,
  isCtaOnTop: PropTypes.bool,
  onShowMoreCallback: PropTypes.func,
  onShowLessCallback: PropTypes.func,
  hideMoreLessWhenChildrenLessThanInitialSize: PropTypes.bool
};

var css_248z$m = ".toyCo_ShowMoreDropdown-showMoreDropdown-2815042{display:inline-block;float:right;margin-top:10px;right:15px}.toyCo_ShowMoreDropdown-showMoreDropdown-2815042:is(.dxp-toyota *){--color-icon-plus:#282830;--bg-color-icon-plus:transparent}.toyCo_ShowMoreDropdown-showMoreDropdown-2815042:is(.dxp-lexus *){--color-icon-plus:#fff;--bg-color-icon-plus:#101010}.toyCo_ShowMoreDropdown-showMoreDropdown-2815042 .toyCo_ShowMoreDropdown-toggleDropdown-2915042:focus-visible{outline:var(--cp-accessibility-outline)}.toyCo_ShowMoreDropdown-showMoreDropdown-2815042 .toyCo_ShowMoreDropdown-dropdownToggle-3015042{align-items:center;border-radius:50%;box-shadow:0 0 0 1.5px;display:flex;font-size:0;justify-content:center;padding:21px}.toyCo_ShowMoreDropdown-showMoreDropdown-2815042 .toyCo_ShowMoreDropdown-dropdownToggle-3015042:hover{text-decoration:none}.toyCo_ShowMoreDropdown-showMoreDropdown-2815042 .toyCo_ShowMoreDropdown-dropdownToggle-3015042 .toyCo_ShowMoreDropdown-icon-3115042{font-size:15px}.toyCo_ShowMoreDropdown-showMoreDropdown-2815042 .toyCo_ShowMoreDropdown-dropdownToggle-3015042 .toyCo_ShowMoreDropdown-icon-3115042:is(.t1-reskin *){padding:11px}.toyCo_ShowMoreDropdown-showMoreDropdown-2815042.toyCo_ShowMoreDropdown-open-3215042 .toyCo_ShowMoreDropdown-dropdown-toggle-3315042{background-color:rgba(0,0,0,.15)}.toyCo_ShowMoreDropdown-showMoreDropdown-2815042 .toyCo_ShowMoreDropdown-iconPlus-3415042:not(.t1-reskin *){color:#f02}.toyCo_ShowMoreDropdown-showMoreDropdown-2815042 .toyCo_ShowMoreDropdown-iconPlus-3415042:is(.t1-reskin *){background-color:var(--bg-color-icon-plus);color:var(--color-icon-plus)}.toyCo_ShowMoreDropdown-showMoreDropdown-2815042 .toyCo_ShowMoreDropdown-iconRemove-3515042{color:#6a6b70!important}.toyCo_ShowMoreDropdown-showMoreDropdown-2815042 .toyCo_ShowMoreDropdown-dropdownMenu-3615042{background-color:#fff;left:auto;margin:var(--cp-dropdown-menu-all-margin,20px 0 0);min-width:var(--cp-dropdown-menu-min-width,auto);padding-bottom:0;padding-top:0;right:var(--cp-dropdown-menu-right,0);width:auto}.toyCo_ShowMoreDropdown-showMoreDropdown-2815042 .toyCo_ShowMoreDropdown-dropdownMenu-3615042:before{background:#fff;border-left:inherit;border-top:inherit;content:\"\";display:var(--cp-dropdown-menu-up-arrow-display,none);height:10px;position:absolute;right:15px;top:-5px;transform:rotate(45deg);width:10px}.toyCo_ShowMoreDropdown-showMoreDropdown-2815042 .toyCo_ShowMoreDropdown-dropdownMenu-3615042 .toyCo_ShowMoreDropdown-dropdownItem-3715042{border-bottom:var(--cp-dropdown-separator-width,1px) solid #eff0f0;margin:var(--cp-dropdown-item-all-margin,0 8px);padding:var(--cp-dropdown-item-all-padding,12px 0 12px);white-space:nowrap}.toyCo_ShowMoreDropdown-showMoreDropdown-2815042 .toyCo_ShowMoreDropdown-dropdownMenu-3615042 .toyCo_ShowMoreDropdown-dropdownItem-3715042>a{color:#6a6b70;text-decoration:none}.toyCo_ShowMoreDropdown-showMoreDropdown-2815042 .toyCo_ShowMoreDropdown-dropdownMenu-3615042 .toyCo_ShowMoreDropdown-dropdownItem-3715042:last-child{border-bottom:none}.toyCo_ShowMoreDropdown-showMoreDropdown-2815042 .toyCo_ShowMoreDropdown-dropdownMenu-3615042 .toyCo_ShowMoreDropdown-dropdownItem-3715042:focus-visible{outline:var(--cp-accessibility-outline)}.toyCo_ShowMoreDropdown-icon-3115042{transition:transform .2s linear}.toyCo_ShowMoreDropdown-icon-3115042:before{font-size:18px;left:50%;position:absolute;top:50%;transform:translate(-50%,-50%)}.toyCo_ShowMoreDropdown-isOpen-3815042 .toyCo_ShowMoreDropdown-icon-3115042{transform:rotate(45deg)}.toyCo_ShowMoreDropdown-isOpen-3815042 .toyCo_ShowMoreDropdown-icon-3115042:is(.t1-reskin *){transform:rotate(-45deg)}.toyCo_ShowMoreDropdown-isOpen-3815042 .toyCo_ShowMoreDropdown-icon-3115042:before{font-size:18px}.toyCo_ShowMoreDropdown-isOpen-3815042 .toyCo_ShowMoreDropdown-icon-3115042:is(.t1-reskin *):before{font-size:20px}.toyCo_ShowMoreDropdown-hasClosed-3915042 .toyCo_ShowMoreDropdown-dropdownMenu-3615042{animation:cpfadeOutThenHide .2s linear forwards;display:block}";
var styles$m = {"showMoreDropdown":"toyCo_ShowMoreDropdown-showMoreDropdown-2815042","toggleDropdown":"toyCo_ShowMoreDropdown-toggleDropdown-2915042","dropdownToggle":"toyCo_ShowMoreDropdown-dropdownToggle-3015042","icon":"toyCo_ShowMoreDropdown-icon-3115042","open":"toyCo_ShowMoreDropdown-open-3215042","dropdown-toggle":"toyCo_ShowMoreDropdown-dropdown-toggle-3315042","iconPlus":"toyCo_ShowMoreDropdown-iconPlus-3415042","iconRemove":"toyCo_ShowMoreDropdown-iconRemove-3515042","dropdownMenu":"toyCo_ShowMoreDropdown-dropdownMenu-3615042","dropdownItem":"toyCo_ShowMoreDropdown-dropdownItem-3715042","isOpen":"toyCo_ShowMoreDropdown-isOpen-3815042","hasClosed":"toyCo_ShowMoreDropdown-hasClosed-3915042"};
styleInject(css_248z$m);

var shouldIgnoreOutsideClick = function shouldIgnoreOutsideClick(refDropdown, event, isOpen) {
  return !!_.get(refDropdown, "current.contains") && refDropdown.current.contains(event.target) || !isOpen;
};
var onIsOpenChange = function onIsOpenChange(isOpen, refDropdown, setIsOpen) {
  if (isOpen) {
    var handleOutsideClick = outSideClickHandler(refDropdown, isOpen, setIsOpen);
    document.addEventListener("click", handleOutsideClick, false);
    return function () {
      return document.removeEventListener("click", handleOutsideClick, false);
    };
  }
};
var outSideClickHandler = function outSideClickHandler(refDropdown, isOpen, setIsOpen) {
  return function (event) {
    if (shouldIgnoreOutsideClick(refDropdown, event, isOpen)) {
      return;
    }
    setIsOpen(!isOpen);
  };
};

var ICONS = {
  ICON_PLUS: "icon-Plus-small",
  ICON_REMOVE: "icon-Close-small"
};
var ShowMoreDropdown = function ShowMoreDropdown(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    children = _ref.children,
    toggleElement = _ref.toggleElement,
    _ref$dropdownMenuClas = _ref.dropdownMenuClassName,
    dropdownMenuClassName = _ref$dropdownMenuClas === void 0 ? "" : _ref$dropdownMenuClas,
    onToggleCallback = _ref.onToggleCallback,
    focusOnTab = _ref.focusOnTab,
    label = _ref.label;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    hasOpenedOnce = _useState4[0],
    setHasOpenedOnce = _useState4[1];
  var refDropdown = useRef(null);
  var toggleDropdown = useCallback(function () {
    setHasOpenedOnce(true);
    setIsOpen(!isOpen);
  }, [isOpen]);
  var hasClosed = hasOpenedOnce && !isOpen;
  useEffect(function () {
    onIsOpenChange(isOpen, refDropdown, setIsOpen);
    if (hasOpenedOnce) {
      onToggleCallback === null || onToggleCallback === void 0 ? void 0 : onToggleCallback(isOpen);
    }
  }, [isOpen, setIsOpen, onToggleCallback, hasOpenedOnce]);
  var handleKeyDown = function handleKeyDown(event) {
    if (focusOnTab && (event.key === "Enter" || event.key === "Escape" && isOpen)) {
      toggleDropdown();
    }
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: classNames("dropdown", className, styles$m.showMoreDropdown, isOpen && "open cp-dropdown-opened", hasClosed ? styles$m.hasClosed : ""),
    ref: refDropdown
  }, toggleElement ? (
  /*#__PURE__*/
  // set tabIndex by default to 0
  React__default.createElement("div", {
    "aria-label": label || "show more dropdown",
    role: "button",
    onClick: toggleDropdown,
    tabIndex: focusOnTab ? 0 : -1,
    onKeyDown: handleKeyDown,
    className: styles$m.toggleDropdown
  }, toggleElement)) : ( /*#__PURE__*/React__default.createElement("a", {
    "aria-label": label || "show more dropdown",
    role: "button",
    className: classNames("dropdown-toggle cp-dropdown-toggle", styles$m.dropdownToggle, isOpen ? [styles$m.iconRemove, styles$m.isOpen] : styles$m.iconPlus),
    onClick: toggleDropdown
  }, /*#__PURE__*/React__default.createElement(Icon, {
    className: classNames(ICONS.ICON_PLUS, styles$m.icon),
    iconType: "DXPICON"
  }))), /*#__PURE__*/React__default.createElement("ul", {
    className: classNames("dropdown-menu cp-dropdown-menu", styles$m.dropdownMenu, dropdownMenuClassName)
  }, React__default.Children.map(children, function (child) {
    if ( /*#__PURE__*/isValidElement(child)) {
      return /*#__PURE__*/cloneElement(child, {
        toggleDropdown: toggleDropdown,
        isOpen: isOpen
      });
    }
    return child;
  })));
};

var ShowMoreDropdownItem = function ShowMoreDropdownItem(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? function () {
      return undefined;
    } : _ref$onClick,
    _ref$toggleDropdown = _ref.toggleDropdown,
    toggleDropdown = _ref$toggleDropdown === void 0 ? function () {
      return undefined;
    } : _ref$toggleDropdown,
    isOpen = _ref.isOpen,
    children = _ref.children,
    href = _ref.href,
    testId = _ref.testId,
    focusOnTab = _ref.focusOnTab;
  var handleKeyDown = function handleKeyDown(event) {
    if (focusOnTab && event.key === "Enter") {
      onClickWithLogs(testId || className, onClick)();
    }
    if (focusOnTab && isOpen && event.key === "Escape") {
      toggleDropdown();
    }
  };
  return /*#__PURE__*/React__default.createElement("li", {
    "data-test-id": testId,
    className: classNames(className, styles$m.dropdownItem),
    onClick: onClickWithLogs(testId || className, onClick),
    tabIndex: isOpen ? 0 : -1,
    onKeyDown: handleKeyDown
  }, href ? ( /*#__PURE__*/React__default.createElement("a", {
    href: href,
    target: "_blank",
    rel: "noopener noreferrer"
  }, children)) : children);
};

var css_248z$l = ".toyCo_ReadMoreText-wrapper-5915042{--toyCo-collapsible-btn-bg:linear-gradient(360deg,var(--cp-primary-white,#fff) 75%,transparent);--toyCo-collapsible-btn-ta:left;--toyCo-collapsible-btn-chevron-d:inline;--toyCo-collapsible-btn-ovf:visible;--cp-btn-mb:0;--toyCo-collapsible-btn-lh:var(--line-height-in-px)}.toyCo_ReadMoreText-wrapper-5915042 button.cp-btn{margin-right:0;text-transform:none}";
var styles$l = {"wrapper":"toyCo_ReadMoreText-wrapper-5915042"};
styleInject(css_248z$l);

/* eslint-disable react/jsx-props-no-spreading */
var ReadMoreText = function ReadMoreText(_ref) {
  var seeLessLabel = _ref.seeLessLabel,
    seeMoreLabel = _ref.seeMoreLabel,
    testId = _ref.testId,
    _ref$visibleLinesWhen = _ref.visibleLinesWhenClosed,
    visibleLinesWhenClosed = _ref$visibleLinesWhen === void 0 ? 3 : _ref$visibleLinesWhen,
    className = _ref.className,
    readMoreClassName = _ref.readMoreClassName,
    children = _ref.children;
  return /*#__PURE__*/React__default.createElement(Collapsible, Object.assign({}, {
    buttonLabelOpen: seeLessLabel,
    buttonLabelClosed: seeMoreLabel,
    isOpenProp: false,
    displayButton: true,
    testId: testId,
    visibleLinesWhenClosed: visibleLinesWhenClosed + 1,
    className: classNames(className, styles$l.wrapper),
    noBorder: true,
    buttonDefaultClassName: readMoreClassName,
    scrollToTop: true
  }), " ", children);
};

var css_248z$k = ".toyCo_MaterialBox-materialBox-6515042{display:none}.material-box-content .toyCo_MaterialBox-materialBox-6515042{display:block}.toyCo_MaterialBox-materialBox-6515042 .toyCo_MaterialBox-materialBoxContent-6615042{display:block;padding:var(--cp-material-box-content-padding,120px);width:100%}@media (max-width:768px){.toyCo_MaterialBox-materialBox-6515042 .toyCo_MaterialBox-materialBoxContent-6615042{padding:32px 24px}}";
var styles$k = {"materialBox":"toyCo_MaterialBox-materialBox-6515042","materialBoxContent":"toyCo_MaterialBox-materialBoxContent-6615042"};
styleInject(css_248z$k);

var css_248z$j = ".toyCo_MaterialBoxHeader-header-13715042{background:var(--cp-primary-white,#fff);box-shadow:0 1px 10px var(--cp-grey-light,#eff0f0);padding:var(--cp-material-box-header-padding,24px 120px);position:sticky;text-align:center;top:0;z-index:1}@media (max-width:768px){.toyCo_MaterialBoxHeader-header-13715042{padding:var(--cp-material-box-header-padding,24px 80px 24px 24px)}}.material-box-panels .material-box .material-box-content .toyCo_MaterialBoxHeader-header-13715042 .btn-close{right:40px;top:50%;transform:translateY(-50%)}.toyCo_MaterialBoxHeader-headerTitle-13815042{font-size:2.2rem;font-weight:400;margin:0;text-transform:none}@media (max-width:768px){.toyCo_MaterialBoxHeader-headerTitle-13815042{text-align:left}}.toyCo_MaterialBoxHeader-headerHr-13915042{border-top:1px solid #e4e4e4;margin:0}.toyCo_MaterialBoxHeader-closeBtn-14015042{align-items:center;background-color:var(--cp-background-dark);border-radius:50%;cursor:pointer;display:flex;height:3.2rem;justify-content:center;position:absolute;right:4rem;top:50%;transform:translateY(-50%);width:3.2rem}.toyCo_MaterialBoxHeader-closeBtn-14015042:focus-visible{outline:var(--cp-accessibility-outline)}.toyCo_MaterialBoxHeader-iconClose-14115042.icon-Close-small:before{color:var(--cp-primary-white);font-size:1.2rem;font-weight:700}";
var styles$j = {"header":"toyCo_MaterialBoxHeader-header-13715042","headerTitle":"toyCo_MaterialBoxHeader-headerTitle-13815042","headerHr":"toyCo_MaterialBoxHeader-headerHr-13915042","closeBtn":"toyCo_MaterialBoxHeader-closeBtn-14015042","iconClose":"toyCo_MaterialBoxHeader-iconClose-14115042"};
styleInject(css_248z$j);

function MaterialBoxHeader(_ref) {
  var children = _ref.children,
    className = _ref.className,
    testId = _ref.testId,
    closeMaterialBox = _ref.closeMaterialBox;
  var handleKeyDown = function handleKeyDown(event) {
    if (closeMaterialBox && event.key === "Enter") {
      closeMaterialBox(null);
    }
  };
  return /*#__PURE__*/React__default.createElement(CpClient, {
    "data-test-id": testId,
    className: classNames(styles$j.header, className),
    options: {
      isInsideMaterialBox: true,
      canWrapMaterialBoxChildren: true
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles$j.closeBtn,
    onClick: closeMaterialBox,
    onKeyDown: handleKeyDown,
    tabIndex: 0
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "dxp-icon icon-Close-small ".concat(styles$j.iconClose)
  })), /*#__PURE__*/React__default.createElement(Text, {
    testId: "headerTitle".concat(testId),
    className: styles$j.headerTitle,
    kind: TEXT_KINDS_ALL.HEADER_2
  }, children));
}

var idCounter$2 = 1;
/** Handles the opening and closing of a MaterialBox using the underlying MaterialBox implementation via Postal service.*/
function MaterialBox(_a) {
  var _a$show = _a.show,
    show = _a$show === void 0 ? false : _a$show,
    id = _a.id,
    children = _a.children,
    onClose = _a.onClose,
    onOpened = _a.onOpened,
    _a$className = _a.className,
    className = _a$className === void 0 ? "c-material-box" : _a$className,
    dataTestId = _a.dataTestId,
    extraT1MaterialboxConfiguration = _a.extraT1MaterialboxConfiguration,
    _a$useInstanceToClose = _a.useInstanceToClose,
    useInstanceToClose = _a$useInstanceToClose === void 0 ? false : _a$useInstanceToClose,
    headerTitle = _a.headerTitle,
    headerClassName = _a.headerClassName,
    options = _a.options,
    otherProps = __rest(_a, ["show", "id", "children", "onClose", "onOpened", "className", "dataTestId", "extraT1MaterialboxConfiguration", "useInstanceToClose", "headerTitle", "headerClassName", "options"]);
  var _ref = options || {},
    shouldSpreadCloseMaterialBox = _ref.shouldSpreadCloseMaterialBox,
    shouldUseCpClientTag = _ref.shouldUseCpClientTag;
  var materialBoxId = useMemo(function () {
    return "material-box-".concat(id) + ++idCounter$2;
  }, [id]);
  var isOpen = useRef(false);
  var materialBoxInstance = useRef(null);
  var hasHeader = Boolean(headerTitle);
  var containerClasses = extraT1MaterialboxConfiguration === null || extraT1MaterialboxConfiguration === void 0 ? void 0 : extraT1MaterialboxConfiguration.styleClass;
  var styleClass = "".concat(containerClasses ? containerClasses : "", " ").concat(hasHeader ? "cp-scrollbar" : "");
  var isInjectedInsideApp = Boolean(extraT1MaterialboxConfiguration === null || extraT1MaterialboxConfiguration === void 0 ? void 0 : extraT1MaterialboxConfiguration.wrapper);
  if (materialBoxInstance.current) {
    materialBoxInstance.current.selector = "#".concat(materialBoxId);
  }
  useEffect(function () {
    var materialBoxSubscription = window.T1.channels.dialog.subscribe({
      topic: _.get(window, "T1.constants.MATERIALBOX_CLOSED", "materialBox.closed"),
      callback: function callback(closedInstance) {
        if (closedInstance && _.get(closedInstance, "identifier") !== materialBoxId) {
          return;
        }
        materialBoxInstance.current = null;
        isOpen.current = false;
        onClose && onClose();
      }
    });
    return function () {
      materialBoxSubscription.unsubscribe();
    };
  }, [onClose, materialBoxId]);
  var openMaterialBox = useCallback(function () {
    if (!isOpen.current) {
      window.T1.channels.dialog.publish({
        topic: _.get(window, "T1.constants.MATERIALBOX_OPEN", "materialBox.open"),
        data: Object.assign(Object.assign({
          selector: "#".concat(materialBoxId),
          onOpen: function onOpen() {
            materialBoxInstance.current = this;
            isOpen.current = true;
            onOpened && onOpened();
            setTimeout(function () {
              var $btn = $("#".concat(materialBoxId)).parent().find(".btn-close");
              $btn.length && ($btn === null || $btn === void 0 ? void 0 : $btn.focus());
            }, 1000);
          }
        }, extraT1MaterialboxConfiguration), {
          styleClass: styleClass,
          globalClose: hasHeader ? false : (extraT1MaterialboxConfiguration === null || extraT1MaterialboxConfiguration === void 0 ? void 0 : extraT1MaterialboxConfiguration.globalClose) !== false
        })
      });
    }
  }, [materialBoxId, onOpened, extraT1MaterialboxConfiguration, styleClass, hasHeader]);
  var closeMaterialBox = useCallback(function () {
    if (isOpen.current) {
      isOpen.current = false;
      var data = useInstanceToClose ? {
        box: materialBoxInstance.current
      } : {
        selector: "#".concat(materialBoxId)
      };
      window.T1.channels.dialog.publish({
        topic: _.get(window, "T1.constants.MATERIALBOX_CLOSE", "materialBox.close"),
        data: data
      });
    }
  }, [materialBoxId]);
  useEffect(function () {
    show ? openMaterialBox() : closeMaterialBox();
  }, [show, openMaterialBox, closeMaterialBox]);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(function () {
    return closeMaterialBox;
  }, []);
  return /*#__PURE__*/React__default.createElement("div", Object.assign({
    id: materialBoxId,
    className: classNames(styles$k.materialBox, className)
  }, Object.assign({
    'data-test-id': dataTestId
  }, otherProps)), hasHeader && ( /*#__PURE__*/React__default.createElement(MaterialBoxHeader, {
    closeMaterialBox: closeMaterialBox,
    testId: dataTestId && "".concat(dataTestId, "-header"),
    className: headerClassName
  }, headerTitle)), /*#__PURE__*/React__default.createElement(CpClient, {
    className: classNames(_defineProperty({}, styles$k.materialBoxContent, hasHeader)),
    options: {
      canWrapMaterialBoxChildren: shouldUseCpClientTag || isInjectedInsideApp,
      isInsideMaterialBox: true
    }
  }, /*#__PURE__*/React__default.createElement(T1Legacy, {
    className: classNames(_defineProperty({}, styles$k.materialBoxContent, hasHeader)),
    options: {
      isInsideCpClient: shouldUseCpClientTag || isInjectedInsideApp
    }
  }, show && React__default.Children.map(children, function (child) {
    return /*#__PURE__*/cloneElement(child, Object.assign({}, shouldSpreadCloseMaterialBox ? {
      closeMaterialBox: closeMaterialBox
    } : {}));
  }))));
}

var css_248z$i = ".toyCo_stickyFooter-stickyFooter-4915042{background:#fff;bottom:0;box-shadow:0 -5px 20px rgba(0,0,0,.15);position:fixed;transition:border-radius .6s linear;width:100%;z-index:1060}.toyCo_stickyFooter-stickyFooter-4915042.cp-is-open{border-radius:12px 12px 0 0}.toyCo_stickyFooter-childrenIsHidden-5015042{padding-bottom:10px}.toyCo_stickyFooter-coverBackground-5115042{background:rgba(40,40,48,.2);display:block;height:100vh;opacity:0;position:fixed;top:0;transition:opacity .6s linear,backdrop-filter .6s linear;width:100vw;z-index:-1}.toyCo_stickyFooter-coverBackground-5115042.toyCo_stickyFooter-show-5215042{backdrop-filter:blur(2px);opacity:1;z-index:1059}.toyCo_stickyFooter-disablePageScroll-5315042{overflow:hidden}";
var styles$i = {"stickyFooter":"toyCo_stickyFooter-stickyFooter-4915042","childrenIsHidden":"toyCo_stickyFooter-childrenIsHidden-5015042","coverBackground":"toyCo_stickyFooter-coverBackground-5115042","show":"toyCo_stickyFooter-show-5215042","disablePageScroll":"toyCo_stickyFooter-disablePageScroll-5315042"};
styleInject(css_248z$i);

var css_248z$h = ".toyCo_stickyFooterExpandedContent-expansionToggle-18015042{background:#fff;border:2px solid #eff0f0;border-radius:50%;color:var(--cp-brand-signature-color,#f02);cursor:pointer;height:32px;left:calc(50% - 16px);line-height:28px;position:absolute;text-align:center;top:-20px;width:32px;z-index:1060}.toyCo_stickyFooterExpandedContent-expansionToggle-18015042:is(.lexus *){border:2px solid #eeedec;color:#101010;line-height:30px}.toyCo_stickyFooterExpandedContent-expansionToggle-18015042:is(.dxp-lexus *){border:var(--cp-expansion-toggle-b,2px solid #eeedec);color:#101010}.toyCo_stickyFooterExpandedContent-expansionToggle-18015042:is(.dxp-toyota *){color:var(--cp-brand-signature-color,var(--cp-grey-dark))}.toyCo_stickyFooterExpandedContent-expansionToggle-18015042:before{font-weight:700;left:50%;position:absolute;top:50%;transform:translate(-50%,-50%);transition:transform .2s linear}.toyCo_stickyFooterExpandedContent-expansionToggle-18015042.toyCo_stickyFooterExpandedContent-isExpanded-18115042:before{transform:translate(-50%,-50%) rotate(-180deg)}.toyCo_stickyFooterExpandedContent-expansionToggle-18015042.dxp-icon[class*=-small]:before{font-size:16px}.toyCo_stickyFooterExpandedContent-expansionContent-18215042{height:0;overflow:hidden;transition-duration:.5s;transition-property:height;transition-timing-function:ease-in}.toyCo_stickyFooterExpandedContent-expansionContentExpanded-18315042{height:60vh;margin-bottom:20px;overflow-y:auto}@media (min-width:1200px){.toyCo_stickyFooterExpandedContent-defaultTheme-18415042{padding-left:40px;padding-right:40px}}.toyCo_stickyFooterExpandedContent-defaultTheme-18415042::-webkit-scrollbar{background-color:var(--cp-scrollbar-bg,var(--cp-grey-light-2));width:var(--cp-scrollbar-width,5px)}.toyCo_stickyFooterExpandedContent-defaultTheme-18415042::-webkit-scrollbar-thumb{background:var(--cp-scrollbar-c,var(--cp-grey-medium));border-radius:5px}.toyCo_stickyFooterExpandedContent-defaultIcon-18515042.toyCo_stickyFooterExpandedContent-expansionToggle-18015042{color:var(--cp-brand-signature-color,var(--cp-grey-dark,#282830))}@media (min-width:992px){.toyCo_stickyFooterExpandedContent-defaultIcon-18515042{background:transparent;border:0;left:40px;top:10px}.toyCo_stickyFooterExpandedContent-defaultIcon-18515042.icon:before{font-size:25px}}";
var styles$h = {"expansionToggle":"toyCo_stickyFooterExpandedContent-expansionToggle-18015042","isExpanded":"toyCo_stickyFooterExpandedContent-isExpanded-18115042","expansionContent":"toyCo_stickyFooterExpandedContent-expansionContent-18215042","expansionContentExpanded":"toyCo_stickyFooterExpandedContent-expansionContentExpanded-18315042","defaultTheme":"toyCo_stickyFooterExpandedContent-defaultTheme-18415042","defaultIcon":"toyCo_stickyFooterExpandedContent-defaultIcon-18515042"};
styleInject(css_248z$h);

var StickyFooterExpandedContent = function StickyFooterExpandedContent(_ref) {
  var expandableContent = _ref.expandableContent,
    isExpanded = _ref.isExpanded,
    handleExpandableContent = _ref.handleExpandableContent,
    onExpandIconClick = _ref.onExpandIconClick,
    className = _ref.className,
    isDefaultTheme = _ref.isDefaultTheme,
    useTopArrow = _ref.useTopArrow;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("button", {
    "aria-label": "expand sticky footer toggle",
    className: classNames("dxp-icon", "icon-Chevron_Up-small", _defineProperty({}, styles$h.isExpanded, isExpanded), styles$h.expansionToggle, _defineProperty({}, styles$h.defaultIcon, _typeof(useTopArrow) === "boolean" ? !useTopArrow : !!isDefaultTheme)),
    onClick: function onClick() {
      handleExpandableContent === null || handleExpandableContent === void 0 ? void 0 : handleExpandableContent();
      onExpandIconClick === null || onExpandIconClick === void 0 ? void 0 : onExpandIconClick();
    }
  }), /*#__PURE__*/React__default.createElement("div", {
    className: classNames(styles$h.expansionContent, _defineProperty(_defineProperty({}, styles$h.expansionContentExpanded, isExpanded), styles$h.defaultTheme, !!isDefaultTheme), className)
  }, expandableContent));
};

var StickyFooter = function StickyFooter(_ref) {
  var children = _ref.children,
    contentAbove = _ref.contentAbove,
    content = _ref.content,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    options = _ref.options;
  var _ref2 = options || {},
    shouldShowChildrenAboveContent = _ref2.shouldShowChildrenAboveContent;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, contentAbove, /*#__PURE__*/React__default.createElement("div", {
    className: classNames(styles$i.stickyFooter, className)
  }, shouldShowChildrenAboveContent ? children : null, content, shouldShowChildrenAboveContent ? null : children));
};

/**
 * @module hooks__previousValue
 */
/**
 * @function usePreviousValue
 * @description returns the previous value of a prop/state by keeping it in a reference and updates it right after with
 * the new value if that value changed
 */
var usePreviousValue = function usePreviousValue(value) {
  var ref = useRef();
  useEffect(function () {
    ref.current = value;
  }, [value]);
  return ref.current;
};

var StickyCollapsibleFooter = function StickyCollapsibleFooter(_ref) {
  var children = _ref.children,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    contentClassName = _ref.contentClassName,
    expandableContent = _ref.expandableContent,
    options = _ref.options,
    onExpandedChange = _ref.onExpandedChange,
    onExpandIconClick = _ref.onExpandIconClick,
    _ref$forceCloseCounte = _ref.forceCloseCounter,
    forceCloseCounter = _ref$forceCloseCounte === void 0 ? 0 : _ref$forceCloseCounte,
    _ref$forceOpenCounter = _ref.forceOpenCounter,
    forceOpenCounter = _ref$forceOpenCounter === void 0 ? 0 : _ref$forceOpenCounter;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isExpanded = _useState2[0],
    setIsExpanded = _useState2[1];
  var _ref2 = options || {},
    shouldShowChildrenAboveContent = _ref2.shouldShowChildrenAboveContent,
    _ref2$isDefaultTheme = _ref2.isDefaultTheme,
    isDefaultTheme = _ref2$isDefaultTheme === void 0 ? true : _ref2$isDefaultTheme,
    useTopArrow = _ref2.useTopArrow,
    shouldCoverBackground = _ref2.shouldCoverBackground;
  var prevForceCloseCounter = usePreviousValue(forceCloseCounter) || 0;
  var prevForceOpenCounter = usePreviousValue(forceOpenCounter) || 0;
  var updateExpanded = useCallback(function (value) {
    setIsExpanded(value);
    onExpandedChange === null || onExpandedChange === void 0 ? void 0 : onExpandedChange(value);
  }, [onExpandedChange, setIsExpanded]);
  useEffect(function () {
    if (forceCloseCounter > prevForceCloseCounter && prevForceCloseCounter >= 0) {
      updateExpanded(false);
    } else if (forceOpenCounter > prevForceOpenCounter && prevForceOpenCounter >= 0) {
      updateExpanded(true);
    }
  }, [forceCloseCounter, forceOpenCounter, prevForceCloseCounter, prevForceOpenCounter, updateExpanded]);
  return /*#__PURE__*/React__default.createElement(StickyFooter, {
    contentAbove: shouldCoverBackground ? ( /*#__PURE__*/React__default.createElement("div", {
      className: classNames(styles$i.coverBackground, _defineProperty({}, styles$i.show, isExpanded))
    })) : undefined,
    className: classNames(className, {
      'cp-is-open': isExpanded
    }),
    options: {
      shouldShowChildrenAboveContent: shouldShowChildrenAboveContent
    },
    content: expandableContent && ( /*#__PURE__*/React__default.createElement(StickyFooterExpandedContent, Object.assign({}, {
      expandableContent: expandableContent,
      handleExpandableContent: function handleExpandableContent() {
        updateExpanded(!isExpanded);
      },
      onExpandIconClick: onExpandIconClick,
      isExpanded: isExpanded,
      className: contentClassName,
      isDefaultTheme: isDefaultTheme,
      useTopArrow: useTopArrow
    })))
  }, children);
};

var css_248z$g = ".toyCo_OverflowableRow-arrowWrapper-6015042{padding:.1rem;position:relative}.toyCo_OverflowableRow-leftArrow-6115042,.toyCo_OverflowableRow-rightArrow-6215042{align-content:center;height:100%;position:absolute;top:0;width:5rem;z-index:2}.toyCo_OverflowableRow-leftArrow-6115042{background:linear-gradient(-90deg,hsla(0,0%,100%,0),#fff 65%);left:0}.toyCo_OverflowableRow-rightArrow-6215042{background:linear-gradient(90deg,hsla(0,0%,100%,0),#fff 65%);right:0;text-align:right}.dxp .toyCo_OverflowableRow-swiperSlideWidth-6315042{width:fit-content}.dxp .toyCo_OverflowableRow-continuousUnderline-6415042{margin:0;padding:0 2rem 1rem}";
var styles$g = {"arrowWrapper":"toyCo_OverflowableRow-arrowWrapper-6015042","leftArrow":"toyCo_OverflowableRow-leftArrow-6115042","rightArrow":"toyCo_OverflowableRow-rightArrow-6215042","swiperSlideWidth":"toyCo_OverflowableRow-swiperSlideWidth-6315042","continuousUnderline":"toyCo_OverflowableRow-continuousUnderline-6415042"};
styleInject(css_248z$g);

if (_typeof(SwiperCore === null || SwiperCore === void 0 ? void 0 : SwiperCore.use) === "function") {
  SwiperCore.use([Navigation$1]);
}
function OverflowableRow(_ref) {
  var itemClass = _ref.itemClass,
    listClass = _ref.listClass,
    _ref$activeTabIndex = _ref.activeTabIndex,
    activeTabIndex = _ref$activeTabIndex === void 0 ? 0 : _ref$activeTabIndex,
    _ref$tabs = _ref.tabs,
    tabs = _ref$tabs === void 0 ? [] : _ref$tabs,
    _ref$onTabChange = _ref.onTabChange,
    onTabChange = _ref$onTabChange === void 0 ? _.noop : _ref$onTabChange,
    _ref$showOverflowIndi = _ref.showOverflowIndicators,
    showOverflowIndicators = _ref$showOverflowIndi === void 0 ? false : _ref$showOverflowIndi,
    className = _ref.className,
    _ref$useContinuousUnd = _ref.useContinuousUnderline,
    useContinuousUnderline = _ref$useContinuousUnd === void 0 ? false : _ref$useContinuousUnd;
  var viewport = useViewportChange();
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    swiper = _useState2[0],
    setSwiper = _useState2[1];
  var _useState3 = useState(true),
    _useState4 = _slicedToArray(_useState3, 2),
    isSwipable = _useState4[0],
    setIsSwipable = _useState4[1];
  var _useState5 = useState(true),
    _useState6 = _slicedToArray(_useState5, 2),
    isAtStart = _useState6[0],
    setIsAtStart = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isAtEnd = _useState8[0],
    setIsAtEnd = _useState8[1];
  var swiperRef = useRef();
  var showLeftArrow = showOverflowIndicators && !isAtStart;
  var showRightArrow = showOverflowIndicators && !isAtEnd;
  var handleKeyDown = function handleKeyDown(event, id, index) {
    if (event.key === "Enter" && swiperRef.current) {
      event.preventDefault();
      onClickWithLogs(id, onTabChange(index));
    }
  };
  var updateOverflowIndicators = useCallback(function (swiper) {
    var isEnd = swiper.isEnd,
      isBeginning = swiper.isBeginning,
      realIndex = swiper.realIndex;
    setIsAtEnd(isEnd || realIndex + 1 === tabs.length - 1);
    setIsAtStart(isBeginning || realIndex === 0);
  }, [tabs, setIsAtEnd, setIsAtStart]);
  var initializeOverflowIndicators = useCallback(function (swiper) {
    if (swiper.isBeginning && swiper.isEnd) {
      setIsAtEnd(true);
      setIsAtStart(true);
      setIsSwipable(false);
    } else {
      updateOverflowIndicators(swiper);
      setIsSwipable(true);
    }
  }, [updateOverflowIndicators]);
  useEffect(function () {
    swiper && initializeOverflowIndicators(swiper);
  }, [viewport, swiper, initializeOverflowIndicators]);
  return /*#__PURE__*/React__default.createElement("div", Object.assign({}, {
    className: classNames(className, showOverflowIndicators && styles$g.arrowWrapper)
  }), showLeftArrow && ( /*#__PURE__*/React__default.createElement("div", {
    className: classNames(styles$g.leftArrow),
    onClick: function onClick() {
      var _a;
      return (_a = swiperRef === null || swiperRef === void 0 ? void 0 : swiperRef.current) === null || _a === void 0 ? void 0 : _a.slidePrev();
    }
  }, /*#__PURE__*/React__default.createElement(Icon, {
    className: classNames("icon-Chevron_Left-small"),
    iconType: "DXPICON"
  }))), /*#__PURE__*/React__default.createElement(Swiper, Object.assign({
    keyboard: {
      enabled: true
    },
    pagination: {
      clickable: true
    }
  }, {
    onBeforeInit: function onBeforeInit(swiper) {
      swiperRef.current = swiper;
    },
    modules: [Navigation$1],
    onSwiper: function onSwiper(swiper) {
      setSwiper(swiper);
      initializeOverflowIndicators(swiper);
    },
    onTouchMove: function onTouchMove(params) {
      return updateOverflowIndicators(params);
    },
    onSlideChange: function onSlideChange(params) {
      return updateOverflowIndicators(params);
    },
    noSwiping: !isSwipable,
    noSwipingClass: "swiper-container",
    slidesPerView: "auto",
    freeMode: true,
    className: classNames(listClass),
    href: "#"
  }), tabs.map(function (_ref2, index) {
    var label = _ref2.label,
      id = _ref2.id;
    return /*#__PURE__*/React__default.createElement(SwiperSlide, Object.assign({
      tabIndex: 0,
      "data-test-id": "".concat(id, "Tab"),
      key: "tab-" + index
    }, {
      className: classNames(itemClass, index === activeTabIndex && "active", styles$g.swiperSlideWidth, useContinuousUnderline && styles$g.continuousUnderline),
      onKeyDown: function onKeyDown(event) {
        return handleKeyDown(event, "".concat(id, "Tab"), index);
      },
      onClick: function onClick() {
        return onClickWithLogs("".concat(id, "Tab"), onTabChange(index));
      }
    }), label);
  })), showRightArrow && ( /*#__PURE__*/React__default.createElement("div", {
    className: classNames(styles$g.rightArrow),
    onClick: function onClick() {
      var _a;
      return (_a = swiperRef === null || swiperRef === void 0 ? void 0 : swiperRef.current) === null || _a === void 0 ? void 0 : _a.slideNext();
    }
  }, /*#__PURE__*/React__default.createElement(Icon, {
    className: classNames("icon-Chevron_Right-small"),
    iconType: "DXPICON"
  }))));
}

var TabsMenu = function TabsMenu(_ref) {
  var _ref$activeTabIndex = _ref.activeTabIndex,
    activeTabIndex = _ref$activeTabIndex === void 0 ? 0 : _ref$activeTabIndex,
    tabs = _ref.tabs,
    _ref$onTabChange = _ref.onTabChange,
    onTabChange = _ref$onTabChange === void 0 ? _.noop : _ref$onTabChange,
    showOverflowIndicators = _ref.showOverflowIndicators,
    className = _ref.className,
    useContinuousUnderline = _ref.useContinuousUnderline;
  return /*#__PURE__*/React__default.createElement(OverflowableRow, {
    itemClass: "tab cp-tab-list-item",
    listClass: "t1-tab-list cp-tab-list",
    activeTabIndex: activeTabIndex,
    tabs: tabs,
    onTabChange: onTabChange,
    showOverflowIndicators: showOverflowIndicators,
    useContinuousUnderline: useContinuousUnderline,
    className: className
  });
};

var Navigation = function Navigation(_ref) {
  var tabs = _ref.tabs,
    initialState = _ref.initialState,
    validationEnabled = _ref.validationEnabled,
    loop = _ref.loop,
    initialTab = _ref.initialTab;
  var tabKeys = useMemo(function () {
    return Object.keys(tabs);
  }, [tabs]);
  var defaultTabsValidation = function defaultTabsValidation() {
    var tabValidation = {};
    tabKeys.forEach(function (tabKey) {
      return tabValidation[tabKey] = !validationEnabled;
    });
    return tabValidation;
  };
  var _useState = useState(initialTab || _.first(tabKeys)),
    _useState2 = _slicedToArray(_useState, 2),
    selectedTabUnsafe = _useState2[0],
    setSelectedTab = _useState2[1];
  var _useState3 = useState(defaultTabsValidation()),
    _useState4 = _slicedToArray(_useState3, 2),
    tabsValidation = _useState4[0],
    setTabsValidation = _useState4[1];
  var _useState5 = useState(initialState),
    _useState6 = _slicedToArray(_useState5, 2),
    sharedState = _useState6[0],
    setSharedState = _useState6[1];
  var selectedTab = _.get(tabs, selectedTabUnsafe, false) ? selectedTabUnsafe : _.first(tabKeys);
  var executeIfNextTabExists = function executeIfNextTabExists(toExecute) {
    var currentIndex = tabKeys.indexOf(selectedTab);
    if (currentIndex >= 0 && currentIndex < tabKeys.length - 1) {
      toExecute(currentIndex);
    } else if (loop && currentIndex === tabKeys.length - 1) {
      setSelectedTab(tabKeys[0]);
    }
  };
  var goToNextTab = function goToNextTab() {
    executeIfNextTabExists(function (currentIndex) {
      _.get(tabsValidation, tabKeys[currentIndex], !validationEnabled) && setSelectedTab(tabKeys[currentIndex + 1]);
    });
  };
  var goToNextTabAndSetValid = function goToNextTabAndSetValid() {
    executeIfNextTabExists(function (currentIndex) {
      setCurrentTabValidation(true);
      setSelectedTab(tabKeys[currentIndex + 1]);
    });
  };
  var goToPreviousTab = function goToPreviousTab() {
    var currentIndex = tabKeys.indexOf(selectedTab);
    if (currentIndex >= 1) {
      setSelectedTab(tabKeys[currentIndex - 1]);
    } else if (currentIndex === 0 && loop) {
      setSelectedTab(tabKeys[tabKeys.length - 1]);
    }
  };
  var goToSpecificTab = function goToSpecificTab(tabKey) {
    tabKeys.includes(tabKey) && setSelectedTab(tabKey);
  };
  var setCurrentTabValidation = function setCurrentTabValidation(isValid) {
    setTabsValidation(_objectSpread2(_objectSpread2({}, tabsValidation), {}, _defineProperty({}, selectedTab, isValid)));
  };
  var TabToRender = _.get(tabs, "".concat(selectedTab, ".Component"), null);
  var tabProps = _.get(tabs, "".concat(selectedTab, ".tabProps"), {});
  return /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement(TabToRender, _objectSpread2({
    navigation: {
      goToNextTab: goToNextTab,
      goToNextTabAndSetValid: goToNextTabAndSetValid,
      goToPreviousTab: goToPreviousTab,
      goToSpecificTab: goToSpecificTab,
      setCurrentTabValidation: setCurrentTabValidation,
      isTabValid: tabsValidation[selectedTab],
      sharedState: sharedState,
      setSharedState: setSharedState,
      currentTabIndex: tabKeys.indexOf(selectedTab),
      numberOfTabs: tabKeys.length
    }
  }, tabProps)));
};
Navigation.defaultProps = {
  tabs: {},
  initialState: {},
  validationEnabled: true,
  loop: false
};
Navigation.propTypes = {
  tabs: PropTypes.object,
  initialState: PropTypes.object,
  validationEnabled: PropTypes.bool,
  loop: PropTypes.bool,
  initialTab: PropTypes.string
};

var getInitialState = function getInitialState(initialTabId, tabs) {
  if (initialTabId) {
    var initialTabIndex = tabs.findIndex(function (tab) {
      return _.get(tab, "tabProps.id") === initialTabId;
    });
    return initialTabIndex > -1 ? initialTabIndex : 0;
  }
  return 0;
};

/**
 * @deprecated This component is a mess and will soone be removed: just use ProcessNavigationUi instead
 */
var NavigationArray = function NavigationArray(_ref) {
  var tabs = _ref.tabs,
    className = _ref.className,
    initialSharedState = _ref.initialSharedState,
    initialTabId = _ref.initialTabId,
    isLooping = _ref.isLooping,
    isNavigationDisplayed = _ref.isNavigationDisplayed,
    isGoToPreviousSpecificStepAllowed = _ref.isGoToPreviousSpecificStepAllowed,
    isGoToNextSpecificStepAllowed = _ref.isGoToNextSpecificStepAllowed,
    styleOptions = _ref.styleOptions,
    options = _ref.options,
    NavigationUiComponent = _ref.NavigationUiComponent;
  var _useState = useState(getInitialState(initialTabId, tabs)),
    _useState2 = _slicedToArray(_useState, 2),
    currentTabIndex = _useState2[0],
    setCurrentTabIndex = _useState2[1];
  var _useState3 = useState(initialSharedState),
    _useState4 = _slicedToArray(_useState3, 2),
    sharedState = _useState4[0],
    setSharedState = _useState4[1];
  var goToNextTab = function goToNextTab() {
    var nextTabIndex = currentTabIndex + 1;
    if (nextTabIndex === tabs.length) {
      if (isLooping) {
        setCurrentTabIndex(0);
      }
    } else {
      setCurrentTabIndex(nextTabIndex);
    }
  };
  var goToPreviousTab = function goToPreviousTab() {
    if (currentTabIndex === 0) {
      if (isLooping) {
        setCurrentTabIndex(tabs.length - 1);
      }
    } else {
      var newIndex = currentTabIndex - 1;
      if (tabs[newIndex].tabProps.beforeNavigate) {
        tabs[newIndex].tabProps.beforeNavigate().then(function () {
          setCurrentTabIndex(newIndex);
        });
      } else {
        setCurrentTabIndex(newIndex);
      }
    }
  };
  var goToSpecificTab = function goToSpecificTab(tabId) {
    var ignoreConditions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var fromNavigationUi = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var indexOfTab = tabs.findIndex(function (tab) {
      return _.get(tab, "tabProps.id") === tabId;
    });
    var tabProps = _.get(tabs, "".concat(currentTabIndex, ".tabProps"));
    var reachableSteps = _.get(tabProps, "reachableSteps");
    var canReachThisStepFromNextOnes = isGoToPreviousSpecificStepAllowed && indexOfTab < currentTabIndex;
    var canReachThisStepFromPreviousOnes = isGoToNextSpecificStepAllowed && indexOfTab > currentTabIndex;
    var canReachThisSpecificStep = reachableSteps && reachableSteps.includes(tabId) && !fromNavigationUi;
    var checkAndNavigate = function checkAndNavigate() {
      if (ignoreConditions || indexOfTab > -1 && (canReachThisStepFromNextOnes || canReachThisStepFromPreviousOnes || canReachThisSpecificStep)) {
        setCurrentTabIndex(indexOfTab);
      }
    };
    if (tabs[indexOfTab].tabProps.beforeNavigate) {
      tabs[indexOfTab].tabProps.beforeNavigate().then(function () {
        checkAndNavigate();
      });
    } else {
      checkAndNavigate();
    }
  };
  var CurrentTab = _.get(tabs, "".concat(currentTabIndex, ".Component"));
  var tabProps = _.get(tabs, "".concat(currentTabIndex, ".tabProps"));
  var navigationProps = {
    goToNextTab: goToNextTab,
    goToPreviousTab: goToPreviousTab,
    goToSpecificTab: goToSpecificTab,
    currentTabIndex: currentTabIndex,
    totalAmountOfTabs: tabs.reduce(function (counter, tab) {
      return _.get(tab, "tabProps.isHiddenInNavigation") ? counter : counter + 1;
    }, 0),
    sharedState: sharedState,
    setSharedState: setSharedState,
    isGoToPreviousSpecificStepAllowed: isGoToPreviousSpecificStepAllowed,
    isGoToNextSpecificStepAllowed: isGoToNextSpecificStepAllowed
  };
  var isNavDisplayed = isNavigationDisplayed && !_.get(tabProps, "isNavigationHidden");
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, isNavDisplayed && /*#__PURE__*/React__default.createElement(NavigationUiComponent, {
    navigation: navigationProps,
    className: className,
    tabs: tabs,
    styleOptions: styleOptions,
    options: options
  }), /*#__PURE__*/React__default.createElement(CurrentTab, _objectSpread2(_objectSpread2({}, tabProps), {}, {
    navigation: navigationProps
  })));
};
NavigationArray.defaultProps = {
  tabs: []
};
NavigationArray.propTypes = {
  tabs: PropTypes.arrayOf(PropTypes.shape({
    tabProps: PropTypes.shape({
      id: PropTypes.string.isRequired,
      isNavigationHidden: PropTypes.bool,
      isHiddenInNavigation: PropTypes.bool,
      labels: PropTypes.shape({
        navigationTitle: PropTypes.string
      }),
      beforeNavigate: PropTypes.func
    }).isRequired,
    Component: PropTypes.func.isRequired
  })),
  className: PropTypes.string,
  initialSharedState: PropTypes.object,
  initialTabId: PropTypes.string,
  isLooping: PropTypes.bool,
  isNavigationDisplayed: PropTypes.bool,
  isGoToPreviousSpecificStepAllowed: PropTypes.bool,
  isGoToNextSpecificStepAllowed: PropTypes.bool,
  NavigationUiComponent: PropTypes.func,
  styleOptions: PropTypes.object,
  options: PropTypes.object
};

var css_248z$f = ".toyCo_NextSteps-orderSteps-6715042>div{display:inline-block;vertical-align:middle}.toyCo_NextSteps-orderSteps-6715042 hr{margin:15px 0 20px}.toyCo_NextSteps-orderSteps-6715042 .toyCo_NextSteps-stepIcon-6815042{color:#6a6b70;width:70px}.toyCo_NextSteps-orderSteps-6715042 .toyCo_NextSteps-titleDescription-6915042{width:calc(100% - 70px)}.toyCo_NextSteps-orderSteps-6715042 .toyCo_NextSteps-button-7015042{margin-left:70px;margin-top:16px}";
var styles$f = {"orderSteps":"toyCo_NextSteps-orderSteps-6715042","stepIcon":"toyCo_NextSteps-stepIcon-6815042","titleDescription":"toyCo_NextSteps-titleDescription-6915042","button":"toyCo_NextSteps-button-7015042"};
styleInject(css_248z$f);

var NextSteps = function NextSteps(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    _ref$stepsLabels = _ref.stepsLabels,
    stepsLabels = _ref$stepsLabels === void 0 ? [] : _ref$stepsLabels,
    handleCTA = _ref.handleCTA;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "".concat(styles$f.orderSteps, " ").concat(className)
  }, _.isArray(stepsLabels) && stepsLabels.map(function (_ref2, index) {
    var title = _ref2.title,
      description = _ref2.description,
      icon = _ref2.icon,
      button = _ref2.button,
      dataTestId = _ref2.dataTestId;
    return /*#__PURE__*/React__default.createElement(Fragment, {
      key: index
    }, /*#__PURE__*/React__default.createElement("div", {
      className: styles$f.stepIcon
    }, /*#__PURE__*/React__default.createElement(Icon, {
      className: icon
    })), /*#__PURE__*/React__default.createElement("div", {
      className: styles$f.titleDescription,
      "data-test-id": dataTestId
    }, /*#__PURE__*/React__default.createElement("strong", null, ++index, ". ", title), /*#__PURE__*/React__default.createElement("div", null, description)), button && ( /*#__PURE__*/React__default.createElement(Button, Object.assign({}, {
      kind: BUTTON_KINDS.PRIMARY,
      onClick: function onClick() {
        return handleCTA ? handleCTA() : null;
      },
      classNames: styles$f.button,
      label: button,
      testId: "or-guest-user-register"
    }))), index !== stepsLabels.length && /*#__PURE__*/React__default.createElement("hr", null));
  }));
};

var css_248z$e = "@charset \"UTF-8\";.dxp{--toyCo-navigation-item-height:30px}.dxp-toyota{--tc-badge-done-c:\"\\\"}.dxp-lexus{--tc-badge-done-c:\"\\\"}.toyCo_ProcessNavigation-processNavigationWrapper-15815042{--navigationBg:transparent;--badgeTextColor:var(--cp-grey-dark,$t1-grey-2);--badgeSimpleNavTextColor:var(--cp-grey-dark,$t1-red);--highlightedStepTitleColor:var(--cp-grey-dark,$t1-black);--activeStepTitleNumberColor:inherit;--stepTitleColor:var(--cp-grey-dark,$t1-grey-2);--simpleNavStepTitleColor:var(--cp-grey-dark,$t1-grey-2);--spaceAroundTabs:space-around;background-color:var(--navigationBg);border-bottom:1px solid #eff0f0;border-top:1px solid #eff0f0;display:flex;overflow:hidden;padding:var(--cp-toyco-stepnav-ptb,16px) 0;width:100%}.toyCo_ProcessNavigation-processNavigationWrapper-15815042:not(.toyCo_ProcessNavigation-isInitialNavOverflowChecked-15915042){visibility:hidden}.toyCo_ProcessNavigation-processNavigationWrapper-15815042 .isHighlighted{background-color:var(--cp-brand-signature-color,var(--cp-grey-dark,#f02))}.toyCo_ProcessNavigation-simpleNavigationContainer-16015042{align-items:center;display:flex;justify-content:space-between;margin:auto}.toyCo_ProcessNavigation-simpleNavigationContainer-16015042 .toyCo_ProcessNavigation-stepTitle-16115042{--cp-header-override-mb:0;color:var(--simpleNavStepTitleColor)}.toyCo_ProcessNavigation-simpleNavigationContainer-16015042 .toyCo_ProcessNavigation-navigationArrow-16215042{cursor:pointer;height:20px;position:relative;width:20px}.toyCo_ProcessNavigation-simpleNavigationContainer-16015042 .toyCo_ProcessNavigation-navigationArrow-16215042 i{color:var(--cp-toyco-step-arrow-c,#adadb0);font-size:20px;font-weight:600;position:absolute;top:50%;transform:translateY(-50%)}.toyCo_ProcessNavigation-simpleNavigationContainer-16015042 .toyCo_ProcessNavigation-navigationArrow-16215042:focus-visible{outline:var(--cp-accessibility-outline);outline-offset:2px}.toyCo_ProcessNavigation-simpleNavigationContainer-16015042 .toyCo_ProcessNavigation-navigationArrow-16215042:is(.lexus *){align-items:center;display:flex}.toyCo_ProcessNavigation-simpleNavigationContainer-16015042 .toyCo_ProcessNavigation-navigationArrow-16215042:is(.dxp-lexus *) .icon-arrow-left:before{font-weight:700}@media (min-width:768px){.toyCo_ProcessNavigation-simpleNavigationContainer-16015042:not(.toyCo_ProcessNavigation-desktopNavOverflowing-16315042){display:none}}.toyCo_ProcessNavigation-navigationContainer-16415042{display:none}@media (min-width:768px){.toyCo_ProcessNavigation-navigationContainer-16415042{justify-content:var(--spaceAroundTabs);overflow-x:auto;overflow-y:hidden;width:100%}.toyCo_ProcessNavigation-navigationContainer-16415042:not(.toyCo_ProcessNavigation-desktopNavOverflowing-16315042){display:inline-flex}}.toyCo_ProcessNavigation-stepContainer-16515042{align-items:center;display:flex}.toyCo_ProcessNavigation-stepContainer-16515042:first-child{padding-left:15px}.toyCo_ProcessNavigation-stepContainer-16515042:focus-visible{outline:var(--cp-accessibility-outline);outline-offset:-1px}.toyCo_ProcessNavigation-stepContainer-16515042:focus-visible+.toyCo_ProcessNavigation-badge-16615042{--toyCo-navigation-item-height:26px;z-index:-1}.toyCo_ProcessNavigation-badge-16615042{align-items:center;background-color:var(--cp-grey-light,#eff0f0);border-radius:100%;display:flex;justify-content:center;margin-right:var(--cp-toyco-badge-mr,10px);max-height:var(--toyCo-navigation-item-height);max-width:var(--toyCo-navigation-item-height);min-height:var(--toyCo-navigation-item-height);min-width:var(--toyCo-navigation-item-height);position:relative}.toyCo_ProcessNavigation-badgeText-16715042{color:var(--badgeTextColor);left:50%;padding-bottom:2px;position:absolute;top:50%;transform:translate(-50%,-50%)}.toyCo_ProcessNavigation-badgeText-16715042,.toyCo_ProcessNavigation-badgeText-16715042:is(cp-client *){font-family:T1 Body Font,Toyota Base,Lexus Base,Arial,Helvetica,sans-serif;font-size:var(--cp-toyco-step-nav-fs,14px);line-height:var(--toyCo-navigation-item-height)}.toyCo_ProcessNavigation-badgeStepNumber-16815042{background-color:inherit}.toyCo_ProcessNavigation-badgeStepNumber-16815042 .toyCo_ProcessNavigation-badgeText-16715042{color:var(--badgeSimpleNavTextColor);font-family:T1 Body Font,Toyota Base,Lexus Base,Arial,Helvetica,sans-serif;font-size:14px;white-space:nowrap}.toyCo_ProcessNavigation-highlightedBadge-16915042 .toyCo_ProcessNavigation-badgeText-16715042{color:#fff}.toyCo_ProcessNavigation-badgeDone-17015042:before{content:var(--tc-badge-done-c);font-family:dxp-icon;font-size:2rem}.toyCo_ProcessNavigation-stepTitle-16115042{--cp-h5-c:var(\n  \t--stepTitleColor\n  );color:var(--stepTitleColor);font-family:T1 Body Font,Toyota Base,Lexus Base,Arial,Helvetica,sans-serif;font-weight:400;padding-right:var(--cp-toyco-stepTitle-pr,15px);white-space:nowrap}.toyCo_ProcessNavigation-stepTitle-16115042,.toyCo_ProcessNavigation-stepTitle-16115042:is(cp-client *){font-size:14px}.toyCo_ProcessNavigation-stepTitle-16115042:is(cp-client *){margin-bottom:0}.toyCo_ProcessNavigation-stepTitle-16115042:is(.dxp-lexus *){margin-bottom:0}.toyCo_ProcessNavigation-highlightedStepTitle-17115042{--cp-h5-c:var(\n  \t--highlightedStepTitleColor\n  );color:var(--highlightedStepTitleColor)}.toyCo_ProcessNavigation-highlightedStepTitle-17115042,.toyCo_ProcessNavigation-highlightedStepTitle-17115042:is(cp-client *){font-family:T1 Body Font Bold,Toyota Semibold,Lexus Base,Arial,Helvetica,sans-serif}.toyCo_ProcessNavigation-highlightedStepTitle-17115042 .toyCo_ProcessNavigation-number-17215042{color:var(--activeStepTitleNumberColor)}.toyCo_ProcessNavigation-chevronStepContainer-17315042 .toyCo_ProcessNavigation-stepTitle-16115042{padding-right:0}.toyCo_ProcessNavigation-chevronStepContainer-17315042 .toyCo_ProcessNavigation-number-17215042{padding-right:15px}.toyCo_ProcessNavigation-chevronStepContainer-17315042 *+.icon-Chevron_Right-small{padding-left:20px;padding-right:20px}@media (min-width:768px){.toyCo_ProcessNavigation-chevronStepContainer-17315042 *+.icon-Chevron_Right-small:is(.dxp *){display:inline}}.toyCo_ProcessNavigation-chevronStepContainer-17315042 .icon-Chevron_Right-small{position:relative}.toyCo_ProcessNavigation-chevronStepContainer-17315042 .icon-Chevron_Right-small:before{font-size:22px;font-weight:700;left:50%;margin-top:var(--cp-toyco-step-chevron-right-mt,1px);position:absolute;top:50%;transform:translate(-50%,-50%)}.toyCo_ProcessNavigation-chevronStepContainer-17315042 .icon-Chevron_Right-small:is(.dxp *):before{font-size:15px}.toyCo_ProcessNavigation-chevronStepContainer-17315042:last-child .icon-Chevron_Right-small{display:none}.toyCo_ProcessNavigation-desktopNavOverflowing-16315042 .toyCo_ProcessNavigation-stepContainer-16515042{min-width:0;padding-left:10px}.toyCo_ProcessNavigation-desktopNavOverflowing-16315042 .toyCo_ProcessNavigation-stepTitle-16115042{overflow:hidden;padding-right:10px;text-overflow:ellipsis;white-space:nowrap}.toyCo_ProcessNavigation-disabledNavigationItem-17415042{opacity:.35}.toyCo_ProcessNavigation-clickable-17515042:hover{cursor:pointer}.toyCo_ProcessNavigation-clickable-17515042:hover .toyCo_ProcessNavigation-stepTitle-16115042{text-decoration:var(--cp-toyco-step-title-td,underline)}.toyCo_ProcessNavigation-innerConstraint-17615042{margin:auto;width:var(--innerWidth)}.toyCo_ProcessNavigation-lexus-17715042 .toyCo_ProcessNavigation-text-17815042{font-family:Nobel Book,Lexus Base,Helvetica,Arial,sans-serif;font-size:var(--cp-toyco-step-nav-fs,12px);font-weight:700;letter-spacing:1px;opacity:.7;text-transform:var(--cp-toyco-step-text-tt,uppercase)}.toyCo_ProcessNavigation-lexus-17715042 .toyCo_ProcessNavigation-badgeText-16715042{letter-spacing:0;margin-top:1px}.toyCo_ProcessNavigation-lexus-17715042 .toyCo_ProcessNavigation-badge-16615042.toyCo_ProcessNavigation-stepNumber-17915042 .toyCo_ProcessNavigation-badgeText-16715042{font-family:Nobel,Lexus Regular,Helvetica,Arial,sans-serif;margin-top:0}.toyCo_ProcessNavigation-lexus-17715042 .isHighlightedTitle{opacity:1;padding-bottom:0}.toyCo_ProcessNavigation-lexus-17715042 .isHighlighted h5{color:#fff;opacity:1}";
var styles$e = {"processNavigationWrapper":"toyCo_ProcessNavigation-processNavigationWrapper-15815042","isInitialNavOverflowChecked":"toyCo_ProcessNavigation-isInitialNavOverflowChecked-15915042","simpleNavigationContainer":"toyCo_ProcessNavigation-simpleNavigationContainer-16015042","stepTitle":"toyCo_ProcessNavigation-stepTitle-16115042","navigationArrow":"toyCo_ProcessNavigation-navigationArrow-16215042","desktopNavOverflowing":"toyCo_ProcessNavigation-desktopNavOverflowing-16315042","navigationContainer":"toyCo_ProcessNavigation-navigationContainer-16415042","stepContainer":"toyCo_ProcessNavigation-stepContainer-16515042","badge":"toyCo_ProcessNavigation-badge-16615042","badgeText":"toyCo_ProcessNavigation-badgeText-16715042","badgeStepNumber":"toyCo_ProcessNavigation-badgeStepNumber-16815042","highlightedBadge":"toyCo_ProcessNavigation-highlightedBadge-16915042","badgeDone":"toyCo_ProcessNavigation-badgeDone-17015042","highlightedStepTitle":"toyCo_ProcessNavigation-highlightedStepTitle-17115042","number":"toyCo_ProcessNavigation-number-17215042","chevronStepContainer":"toyCo_ProcessNavigation-chevronStepContainer-17315042","disabledNavigationItem":"toyCo_ProcessNavigation-disabledNavigationItem-17415042","clickable":"toyCo_ProcessNavigation-clickable-17515042","innerConstraint":"toyCo_ProcessNavigation-innerConstraint-17615042","lexus":"toyCo_ProcessNavigation-lexus-17715042","text":"toyCo_ProcessNavigation-text-17815042","stepNumber":"toyCo_ProcessNavigation-stepNumber-17915042"};
styleInject(css_248z$e);

var timeoutOverflowCheck;
/**
 * @function isNavOverflowingCheck
 * @description Returns true if the navigation width is bigger than its parent OR if the breakpoint is mobile so that
 * if we ever transition to desktop breakpoint the navigation is hidden the time of the calculation for a smooth
 * transition/no ugly flick.
 */
var isNavOverflowingCheck = function isNavOverflowingCheck(refDesktopNav, refNavContainer) {
  var navWidthBiggerThanContainer = _.get(refDesktopNav, "current.scrollWidth", 0) > _.get(refNavContainer, "current.scrollWidth", 0);
  return isMobileBreakpoint() || navWidthBiggerThanContainer;
};
var onDidMountChecks = function onDidMountChecks(didMount, setIsNavOverflowing, setIsInitialNavOverflowChecked, refDesktopNav, refNavContainer) {
  if (didMount) {
    setIsNavOverflowing(isNavOverflowingCheck(refDesktopNav, refNavContainer));
    setIsInitialNavOverflowChecked(true);
  }
};
var onDidResizeChecks = function onDidResizeChecks(didResize, setIsNavOverflowing, setDidResize, refDesktopNav, refNavContainer, setIsInitialNavOverflowChecked) {
  if (didResize) {
    setIsNavOverflowing(isNavOverflowingCheck(refDesktopNav, refNavContainer));
    setDidResize(false);
    setIsInitialNavOverflowChecked(true);
  }
};
var onWindowResize = function onWindowResize(setDidResize, setIsNavOverflowing, setIsInitialNavOverflowChecked) {
  return function () {
    clearTimeout(timeoutOverflowCheck);
    var resetValuesForNextOverflowCheck = function resetValuesForNextOverflowCheck() {
      setIsInitialNavOverflowChecked(false);
      setIsNavOverflowing(false);
      setDidResize(true);
    };
    timeoutOverflowCheck = setTimeout(resetValuesForNextOverflowCheck, 250);
  };
};
var onWindowResizeChecks = function onWindowResizeChecks(setDidResize, setIsNavOverflowing, setIsInitialNavOverflowChecked) {
  var windowResizeHandler = onWindowResize(setDidResize, setIsNavOverflowing, setIsInitialNavOverflowChecked);
  window.addEventListener("resize", windowResizeHandler);
  return function () {
    return window.removeEventListener("resize", windowResizeHandler);
  };
};

var ProcessNavigationUiSimple = function ProcessNavigationUiSimple(_ref) {
  var navigation = _ref.navigation,
    _ref$tabs = _ref.tabs,
    tabs = _ref$tabs === void 0 ? [] : _ref$tabs,
    textKind = _ref.textKind,
    navigationContainerOverflowClassName = _ref.navigationContainerOverflowClassName,
    canGoBack = _ref.canGoBack,
    canGoForward = _ref.canGoForward,
    shouldUseArrowNavigation = _ref.shouldUseArrowNavigation;
  var currentTabIndex = navigation.currentTabIndex,
    totalAmountOfTabs = navigation.totalAmountOfTabs,
    goToPreviousTab = navigation.goToPreviousTab,
    goToNextTab = navigation.goToNextTab;
  var leftIconClassDxpT1 = shouldUseArrowNavigation ? "icon-Arrow_Left-small" : "icon-Chevron_Left-small";
  var rightIconClassDxpT1 = shouldUseArrowNavigation ? "icon-Arrow_Right-small" : "icon-Chevron_Right-small";
  return /*#__PURE__*/React__default.createElement("div", {
    className: classNames(navigationContainerOverflowClassName, styles$e.simpleNavigationContainer)
  }, /*#__PURE__*/React__default.createElement("div", null, canGoBack && ( /*#__PURE__*/React__default.createElement("div", {
    tabIndex: 0,
    "data-test-id": "go-to-previous-tab",
    onClick: goToPreviousTab,
    onKeyDown: function onKeyDown(e) {
      if (e.key === "Enter") {
        e.preventDefault();
        goToPreviousTab();
      }
    },
    className: styles$e.navigationArrow
  }, /*#__PURE__*/React__default.createElement("i", {
    className: "dxp-icon ".concat(leftIconClassDxpT1)
  })))), /*#__PURE__*/React__default.createElement("div", {
    className: styles$e.stepContainer
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "".concat(styles$e.badge, " ").concat(styles$e.badgeStepNumber)
  }, /*#__PURE__*/React__default.createElement(Text, {
    testId: "stepnavsimple-badge",
    kind: textKind || TEXT_KINDS_ALL.HEADER_5,
    className: "".concat(styles$e.badgeText, " isHighlightedTitle ").concat(styles$e.text)
  }, currentTabIndex + 1, " / ", totalAmountOfTabs)), /*#__PURE__*/React__default.createElement(Text, {
    testId: "stepnavsimple-title",
    "data-test-id": "".concat(_.get(tabs[currentTabIndex], "tabProps.id"), "-step"),
    kind: textKind || TEXT_KINDS_ALL.HEADER_5,
    className: "".concat(styles$e.stepTitle, " isHighlightedTitle ").concat(styles$e.text)
  }, _.get(tabs[currentTabIndex], "tabProps.labels.navigationTitle"))), /*#__PURE__*/React__default.createElement("div", null, canGoForward && ( /*#__PURE__*/React__default.createElement("div", {
    tabIndex: 0,
    "data-test-id": "go-to-next-tab",
    onClick: goToNextTab,
    onKeyDown: function onKeyDown(e) {
      if (e.key === "Enter") {
        e.preventDefault();
        goToNextTab();
      }
    },
    className: styles$e.navigationArrow
  }, /*#__PURE__*/React__default.createElement("i", {
    className: "dxp-icon ".concat(rightIconClassDxpT1)
  })))));
};

var ProcessNavigationUi = function ProcessNavigationUi(_ref) {
  var className = _ref.className,
    navigation = _ref.navigation,
    _ref$tabs = _ref.tabs,
    tabs = _ref$tabs === void 0 ? [] : _ref$tabs,
    styleOptions = _ref.styleOptions,
    options = _ref.options;
  var refDesktopNav = useRef(null);
  var refNavContainer = useRef(null);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isNavOverflowing = _useState2[0],
    setIsNavOverflowing = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isInitialNavOverflowChecked = _useState4[0],
    setIsInitialNavOverflowChecked = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    didMount = _useState6[0],
    setDidMount = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    didResize = _useState8[0],
    setDidResize = _useState8[1];
  useEffect(function () {
    return setDidMount(true);
  }, []);
  useEffect(function () {
    return onDidMountChecks(didMount, setIsNavOverflowing, setIsInitialNavOverflowChecked, refDesktopNav, refNavContainer);
  }, [didMount, setIsNavOverflowing, setIsInitialNavOverflowChecked]);
  useEffect(function () {
    return onWindowResizeChecks(setDidResize, setIsNavOverflowing, setIsInitialNavOverflowChecked);
  }, [setDidResize, setIsNavOverflowing, setIsInitialNavOverflowChecked]);
  useEffect(function () {
    return onDidResizeChecks(didResize, setIsNavOverflowing, setDidResize, refDesktopNav, refNavContainer, setIsInitialNavOverflowChecked);
  }, [didResize, setIsNavOverflowing, setDidResize, setIsInitialNavOverflowChecked]);
  var goToSpecificTab = navigation.goToSpecificTab,
    currentTabIndex = navigation.currentTabIndex,
    isGoToPreviousSpecificStepAllowed = navigation.isGoToPreviousSpecificStepAllowed,
    isGoToNextSpecificStepAllowed = navigation.isGoToNextSpecificStepAllowed;
  var canGoBack = isGoToPreviousSpecificStepAllowed && currentTabIndex > 0;
  var canGoForward = Boolean(isGoToNextSpecificStepAllowed && tabs.length && currentTabIndex < tabs.length - 1);
  var navigationContainerOverflowClassName = isNavOverflowing ? styles$e.desktopNavOverflowing : "";
  var _ref2 = styleOptions || {},
    innerConstraintWidth = _ref2.innerConstraintWidth,
    _ref2$shouldSpreadTab = _ref2.shouldSpreadTabsAcrossWidth,
    shouldSpreadTabsAcrossWidth = _ref2$shouldSpreadTab === void 0 ? true : _ref2$shouldSpreadTab,
    navigationBg = _ref2.navigationBg,
    highlightedStepTitleColor = _ref2.highlightedStepTitleColor,
    activeStepTitleNumberColor = _ref2.activeStepTitleNumberColor,
    stepTitleColor = _ref2.stepTitleColor,
    badgeSimpleNavTextColor = _ref2.badgeSimpleNavTextColor,
    simpleNavStepTitleColor = _ref2.simpleNavStepTitleColor,
    shouldUseArrowNavigation = _ref2.shouldUseArrowNavigation,
    _ref2$shouldCenterTab = _ref2.shouldCenterTabs,
    shouldCenterTabs = _ref2$shouldCenterTab === void 0 ? false : _ref2$shouldCenterTab;
  var _ref3 = options || {},
    shouldDisplayStepWithTwoDigits = _ref3.shouldDisplayStepWithTwoDigits,
    _ref3$shouldAddBadge = _ref3.shouldAddBadge,
    shouldAddBadge = _ref3$shouldAddBadge === void 0 ? true : _ref3$shouldAddBadge,
    shouldAddStepNumberInStepTitle = _ref3.shouldAddStepNumberInStepTitle,
    shouldAddNextStepChevron = _ref3.shouldAddNextStepChevron,
    supportCpDxpTypography = _ref3.supportCpDxpTypography;
  var applyStyleOptions = styleOptions ? Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
    '--innerWidth': innerConstraintWidth,
    '--spaceAroundTabs': shouldSpreadTabsAcrossWidth ? "space-around" : shouldCenterTabs ? "center" : "normal"
  }, (navigationBg === null || navigationBg === void 0 ? void 0 : navigationBg.length) ? {
    '--navigationBg': navigationBg
  } : {}), (highlightedStepTitleColor === null || highlightedStepTitleColor === void 0 ? void 0 : highlightedStepTitleColor.length) ? {
    '--highlightedStepTitleColor': highlightedStepTitleColor
  } : {}), (activeStepTitleNumberColor === null || activeStepTitleNumberColor === void 0 ? void 0 : activeStepTitleNumberColor.length) ? {
    '--activeStepTitleNumberColor': activeStepTitleNumberColor
  } : {}), (stepTitleColor === null || stepTitleColor === void 0 ? void 0 : stepTitleColor.length) ? {
    '--stepTitleColor': stepTitleColor
  } : {}), (badgeSimpleNavTextColor === null || badgeSimpleNavTextColor === void 0 ? void 0 : badgeSimpleNavTextColor.length) ? {
    '--badgeSimpleNavTextColor': badgeSimpleNavTextColor
  } : {}), (simpleNavStepTitleColor === null || simpleNavStepTitleColor === void 0 ? void 0 : simpleNavStepTitleColor.length) ? {
    '--simpleNavStepTitleColor': simpleNavStepTitleColor
  } : {}) : {};
  var applyInnerConstraintClassName = innerConstraintWidth ? styles$e.innerConstraint : null;
  return /*#__PURE__*/React__default.createElement("div", Object.assign({
    role: "tablist"
  }, {
    className: classNames(className, styles$e.processNavigationWrapper, _defineProperty({}, styles$e.isInitialNavOverflowChecked, isInitialNavOverflowChecked), isLexusBrand() && styles$e.lexus),
    style: applyStyleOptions,
    ref: refNavContainer
  }), /*#__PURE__*/React__default.createElement(ProcessNavigationUiSimple, Object.assign({}, {
    navigation: navigation,
    tabs: tabs,
    navigationContainerOverflowClassName: navigationContainerOverflowClassName,
    canGoBack: canGoBack,
    canGoForward: canGoForward,
    shouldUseArrowNavigation: shouldUseArrowNavigation,
    textKind: styleOptions.textKind
  })), /*#__PURE__*/React__default.createElement("div", Object.assign({}, {
    className: classNames(navigationContainerOverflowClassName, styles$e.navigationContainer, applyInnerConstraintClassName),
    ref: refDesktopNav
  }), tabs.map(function (tab, index) {
    var _a, _b, _c, _d;
    var isDone = index < currentTabIndex;
    var isCurrentStep = index === currentTabIndex;
    var key = (_a = tab === null || tab === void 0 ? void 0 : tab.tabProps) === null || _a === void 0 ? void 0 : _a.id;
    var isHiddenInNavigation = (_b = tab === null || tab === void 0 ? void 0 : tab.tabProps) === null || _b === void 0 ? void 0 : _b.isHiddenInNavigation;
    var tabTitle = (_d = (_c = tab === null || tab === void 0 ? void 0 : tab.tabProps) === null || _c === void 0 ? void 0 : _c.labels) === null || _d === void 0 ? void 0 : _d.navigationTitle;
    var tabNumber = "".concat(index + 1);
    var twoDigitTabNumber = (tabNumber === null || tabNumber === void 0 ? void 0 : tabNumber.length) > 1 ? tabNumber : "0".concat(tabNumber);
    var displayedTabNumber = shouldDisplayStepWithTwoDigits ? twoDigitTabNumber : tabNumber;
    var isBeforeCurrentStep = index < currentTabIndex;
    var isAfterCurrentStep = index > currentTabIndex;
    var isItemClickAllowed = isGoToPreviousSpecificStepAllowed && isBeforeCurrentStep || isGoToNextSpecificStepAllowed && isAfterCurrentStep;
    var textOptions = {
      supportCpDxpTypography: supportCpDxpTypography
    };
    var textKindValue = isCurrentStep ? styleOptions.textKind || TEXT_KINDS_ALL.HEADER_5 : TEXT_KINDS_ALL.SPAN;
    var badgeComponentParameters = isDone ? {
      kind: textKindValue,
      className: "".concat(styles$e.badge, " ").concat(styles$e.badgeDone),
      isContentRequired: false,
      options: textOptions
    } : {
      kind: textKindValue,
      className: classNames(styles$e.badge, _defineProperty({
        isHighlighted: isCurrentStep
      }, styles$e.highlightedBadge, isCurrentStep)),
      children: displayedTabNumber,
      options: textOptions
    };
    return !isHiddenInNavigation && ( /*#__PURE__*/React__default.createElement("div", {
      key: key,
      role: "button",
      tabIndex: isItemClickAllowed ? 0 : -1,
      "aria-disabled": !isItemClickAllowed,
      className: classNames(_defineProperty({}, styles$e.clickable, isItemClickAllowed), styles$e.stepContainer, _defineProperty({}, styles$e.disabledNavigationItem, isDone && !isItemClickAllowed), shouldAddNextStepChevron && styles$e.chevronStepContainer),
      onClick: function onClick() {
        goToSpecificTab(key, false, true);
      },
      onKeyDown: function onKeyDown(e) {
        if (e.key === "Enter") {
          e.preventDefault();
          goToSpecificTab(key, false, true);
        }
      },
      "data-test-id": "".concat(key, "-step")
    }, shouldAddBadge && ( /*#__PURE__*/React__default.createElement("div", {
      className: badgeComponentParameters.className
    }, /*#__PURE__*/React__default.createElement(Text, Object.assign({
      testId: "badge-".concat(key, "-step")
    }, Object.assign(Object.assign({}, badgeComponentParameters), {
      className: classNames(styles$e.badgeText, styles$e.text)
    }))))), /*#__PURE__*/React__default.createElement(Text, {
      testId: "header-".concat(key, "-step"),
      kind: textKindValue,
      className: classNames(styles$e.stepTitle, styles$e.text, _defineProperty({
        isHighlightedTitle: isCurrentStep
      }, styles$e.highlightedStepTitle, isCurrentStep)),
      options: textOptions
    }, shouldAddStepNumberInStepTitle ? ( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("span", {
      className: styles$e.number
    }, displayedTabNumber), tabTitle)) : tabTitle, shouldAddNextStepChevron ? ( /*#__PURE__*/React__default.createElement(Icon, {
      iconType: "DXPICON",
      className: "icon-Chevron_Right-small"
    })) : null)));
  })));
};

//TODO migrate

/**
 * @deprecated This component is a mess and will soone be removed: just use ProcessNavigationUi instead
 */
var ProcessNavigation = function ProcessNavigation(_ref) {
  var className = _ref.className,
    tabs = _ref.tabs,
    initialTabId = _ref.initialTabId,
    initialSharedState = _ref.initialSharedState,
    isNavigationDisplayed = _ref.isNavigationDisplayed,
    isGoToPreviousSpecificStepAllowed = _ref.isGoToPreviousSpecificStepAllowed,
    isGoToNextSpecificStepAllowed = _ref.isGoToNextSpecificStepAllowed,
    styleOptions = _ref.styleOptions,
    options = _ref.options;
  return /*#__PURE__*/React__default.createElement(NavigationArray, {
    className: className,
    tabs: tabs,
    initialTabId: initialTabId,
    initialSharedState: initialSharedState,
    isNavigationDisplayed: isNavigationDisplayed,
    isGoToPreviousSpecificStepAllowed: isGoToPreviousSpecificStepAllowed,
    isGoToNextSpecificStepAllowed: isGoToNextSpecificStepAllowed,
    styleOptions: styleOptions,
    options: options,
    NavigationUiComponent: ProcessNavigationUi
  });
};
ProcessNavigation.defaultProps = {
  initialSharedState: {},
  isNavigationDisplayed: true
};
ProcessNavigation.propTypes = {
  className: PropTypes.string,
  tabs: PropTypes.arrayOf(PropTypes.shape({
    tabProps: PropTypes.shape({
      id: PropTypes.string.isRequired,
      isNavigationHidden: PropTypes.bool,
      isNotDisplayedInNavigation: PropTypes.bool,
      isHiddenInNavigation: PropTypes.bool,
      labels: PropTypes.shape({
        navigationTitle: PropTypes.string
      }),
      reachableSteps: PropTypes.array,
      beforeNavigate: PropTypes.func
    }).isRequired,
    Component: PropTypes.func.isRequired
  })),
  initialSharedState: PropTypes.object,
  initialTabId: PropTypes.string,
  isNavigationDisplayed: PropTypes.bool,
  isGoToPreviousSpecificStepAllowed: PropTypes.bool,
  isGoToNextSpecificStepAllowed: PropTypes.bool,
  styleConfigurationOptions: PropTypes.object,
  styleOptions: PropTypes.object,
  options: PropTypes.object
};

var css_248z$d = ".toyCo_stepMobileFooter-stepMobileFooter-9015042{border-radius:12px 12px 0 0;padding:20px 10px}@media (min-width:1200px){.toyCo_stepMobileFooter-stepMobileFooter-9015042{display:none}}.toyCo_stepMobileFooter-stepMobileFooter-9015042:is(.lexus *){border-radius:0}.toyCo_stepMobileFooter-mainContent-9115042{align-items:center;display:flex;justify-content:space-between}.toyCo_stepMobileFooter-childrenContent-9215042{max-width:80%}.toyCo_stepMobileFooter-childrenContent-9215042 button{margin-right:0}.toyCo_stepMobileFooter-steps-9315042{margin-right:10px;max-width:20%}.toyCo_stepMobileFooter-stepsLabel-9415042{color:#6a6b70;font-family:T1 Body Font,Toyota Base,Lexus Base,Arial,Helvetica,sans-serif;font-size:12px;overflow:hidden;text-overflow:ellipsis}.toyCo_stepMobileFooter-stepsLabel-9415042:is(.lexus *){color:#101010;font-family:Nobel,Lexus Regular,Helvetica,Arial,sans-serif;font-size:12px;line-height:14px;text-transform:uppercase}.toyCo_stepMobileFooter-stepsLabel-9415042:is(.dxp-lexus *){color:#101010;font-family:Nobel,Lexus Regular,Helvetica,Arial,sans-serif}.toyCo_stepMobileFooter-stepsCounter-9515042{color:var(--cp-brand-signature-color,#f02);font-family:T1 Body Font,Toyota Base,Lexus Base,Arial,Helvetica,sans-serif;font-size:14px}.toyCo_stepMobileFooter-stepsCounter-9515042:is(.lexus *){color:#101010;font-family:Nobel Light,Lexus Base,Helvetica,Arial,sans-serif;font-size:14px}.toyCo_stepMobileFooter-stepsCounter-9515042:is(.dxp-lexus *){color:#101010;font-family:Nobel Light,Lexus Base,Helvetica,Arial,sans-serif}.toyCo_stepMobileFooter-stepsCounter-9515042:is(.dxp-toyota *){color:var(--cp-brand-signature-color,var(--cp-grey-dark))}";
var styles$d = {"stepMobileFooter":"toyCo_stepMobileFooter-stepMobileFooter-9015042","mainContent":"toyCo_stepMobileFooter-mainContent-9115042","childrenContent":"toyCo_stepMobileFooter-childrenContent-9215042","steps":"toyCo_stepMobileFooter-steps-9315042","stepsLabel":"toyCo_stepMobileFooter-stepsLabel-9415042","stepsCounter":"toyCo_stepMobileFooter-stepsCounter-9515042"};
styleInject(css_248z$d);

var StepMobileFooter = function StepMobileFooter(_ref) {
  var _ref$activeStepIndex = _ref.activeStepIndex,
    activeStepIndex = _ref$activeStepIndex === void 0 ? 0 : _ref$activeStepIndex,
    _ref$stepsLength = _ref.stepsLength,
    stepsLength = _ref$stepsLength === void 0 ? 1 : _ref$stepsLength,
    children = _ref.children,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    expandableContent = _ref.expandableContent,
    stepLabel = _ref.stepLabel;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isExpanded = _useState2[0],
    setIsExpanded = _useState2[1];
  var handleExpandableContent = function handleExpandableContent(value) {
    setIsExpanded(value);
    window.T1.channels.scrolling.publish({
      topic: _.get(window, "T1.constants.DISABLE_BODY_SCROLL", "scroll.body.disable"),
      data: {
        state: value
      }
    });
  };
  useEffect(function () {
    if (window.postal) {
      var closeTraySubscription = window.postal.subscribe({
        channel: "com.toyota.tme.t1.global",
        topic: "or.mobileNavigation.closeTray",
        callback: function callback() {
          if (isExpanded) {
            handleExpandableContent(!isExpanded);
          }
        }
      });
      return function () {
        window.postal.unsubscribe(closeTraySubscription);
      };
    }
    return undefined;
  }, [isExpanded]);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(StickyCollapsibleFooter, {
    expandableContent: expandableContent,
    className: classNames(styles$d.stepMobileFooter, className),
    options: {
      isDefaultTheme: false
    },
    onExpandedChange: function onExpandedChange(value) {
      return handleExpandableContent(value);
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: classNames("col-xs-12", styles$d.mainContent)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles$d.steps
  }, stepLabel ? ( /*#__PURE__*/React__default.createElement(Text, {
    kind: TEXT_KINDS_ALL.HEADER_5,
    className: styles$d.stepsLabel,
    testId: "StepMobileFooter-stepsLabel"
  }, stepLabel)) : null, /*#__PURE__*/React__default.createElement(Text, {
    testId: "StepMobileFooter-stepsCounter",
    kind: TEXT_KINDS_ALL.HEADER_5,
    className: styles$d.stepsCounter
  }, activeStepIndex + 1, " / ", stepsLength)), /*#__PURE__*/React__default.createElement("div", {
    className: styles$d.childrenContent
  }, children))))));
};

var lazyloadStyles = function lazyloadStyles() {
  try {
    window.requirees("".concat(window.dxp.settings.cpCommonUrl, "/cp-client/styles/libraries/ForkedReactDayPicker.css"));
  } catch (err) {
    logMessageOnDebugMode("Error loading date picker styles", "ERROR", {
      sendToDatadog: true,
      datadogParameters: {
        application: "cp-tme-toyota-common",
        type: "loadStylesError",
        subtype: "datepickerStylesLoadError"
      }
    });
  }
};
lazyloadStyles();

var css_248z$c = ".toyCo_Checkbox-checkbox-8215042.toyCo_Checkbox-disabled-8315042{cursor:not-allowed}";
var styles$c = {"checkbox":"toyCo_Checkbox-checkbox-8215042","disabled":"toyCo_Checkbox-disabled-8315042"};
styleInject(css_248z$c);

var css_248z$b = ".toyCo_Check-labelDisabled-10315042{pointer-events:none}";
var styles$b = {"labelDisabled":"toyCo_Check-labelDisabled-10315042"};
styleInject(css_248z$b);

var css_248z$a = ".toyCo_mandatorySign-mandatorySign-9615042{color:var(--cp-red,#f02);margin-left:var(--cp-mandatory-sign-ml,7px)}";
var styles$a = {"mandatorySign":"toyCo_mandatorySign-mandatorySign-9615042"};
styleInject(css_248z$a);

var MandatorySign = function MandatorySign(_ref) {
  var testId = _ref.testId,
    show = _ref.show;
  return show ? ( /*#__PURE__*/React__default.createElement("span", {
    className: "".concat(styles$a.mandatorySign, " cp-mandatory-sign"),
    "data-test-id": "".concat(testId, "-mandatory-sign")
  }, "*")) : null;
};

/** The Check component is just a composition one we use for checkbox/radio buttons which allows for DRYer code: no
 * need to use it for anything else than those two core components... */
var Check = function Check(_ref) {
  var checked = _ref.checked,
    className = _ref.className,
    disabled = _ref.disabled,
    id = _ref.id,
    isMandatory = _ref.isMandatory,
    label = _ref.label,
    labelClassName = _ref.labelClassName,
    name = _ref.name,
    onClick = _ref.onClick,
    onChange = _ref.onChange,
    testId = _ref.testId,
    type = _ref.type,
    value = _ref.value,
    tabIndex = _ref.tabIndex;
  var inputRef = useRef(null);
  return /*#__PURE__*/React__default.createElement("div", Object.assign({}, {
    className: className
  }), /*#__PURE__*/React__default.createElement("input", Object.assign({
    ref: inputRef
  }, {
    type: type,
    value: value,
    checked: checked,
    readOnly: true,
    disabled: disabled,
    id: id,
    name: name,
    onClick: onClick,
    onChange: onChange,
    'data-test-id': "".concat(testId, "-").concat(type),
    className: classNames("cp-".concat(type, " cp-check-input"), _defineProperty({}, "cp-check-input-disabled", disabled))
  })), label && ( /*#__PURE__*/React__default.createElement("label", Object.assign({
    role: type,
    "aria-checked": checked,
    "aria-disabled": disabled,
    tabIndex: tabIndex || disabled ? -1 : 0,
    onKeyDown: function onKeyDown(e) {
      var _a;
      if (!disabled && e.key === "Enter") {
        // Triggers the input's click, same as htmlFor
        (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.click();
      }
    }
  }, {
    className: classNames("check cp-check-label cp-".concat(type, "-label"), _defineProperty(_defineProperty(_defineProperty({}, styles$b.labelDisabled, disabled), "cp-check-label-disabled", disabled), "cp-".concat(type, "-label-disabled"), disabled), "".concat(labelClassName)),
    htmlFor: id,
    'data-test-id': "".concat(testId, "-").concat(type, "-label").concat(isMandatory ? "-is-mandatory" : "")
  }), label, /*#__PURE__*/React__default.createElement(MandatorySign, {
    show: isMandatory
  }))));
};

var idCounter$1 = 0;
var Checkbox = function Checkbox(_ref) {
  var checked = _ref.checked,
    isMandatory = _ref.isMandatory,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    label = _ref.label,
    value = _ref.value,
    id = _ref.id,
    name = _ref.name,
    _ref$labelClassName = _ref.labelClassName,
    labelClassName = _ref$labelClassName === void 0 ? "" : _ref$labelClassName,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? _.noop : _ref$onClick,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? "" : _ref$children,
    testId = _ref.testId,
    tabIndex = _ref.tabIndex;
  var checkBoxParentClass = disabled ? "".concat(styles$c.disabled) : "";
  var classNames$1 = classNames("form-group", styles$c.checkbox, checkBoxParentClass, className);
  var checkBoxId = useMemo(function () {
    return id || "checkbox-".concat(++idCounter$1);
  }, [id]);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Check, Object.assign({}, {
    className: classNames$1,
    value: value,
    checked: checked,
    disabled: disabled,
    id: checkBoxId,
    name: name,
    onClick: onClick,
    testId: testId,
    label: label,
    labelClassName: labelClassName,
    isMandatory: isMandatory,
    type: "checkbox",
    tabIndex: tabIndex
  })), children);
};

var css_248z$9 = ".toyCo_InputLabel-labelContainer-9715042{align-items:flex-start;display:flex;margin-top:var(--label-wrapper-mt,10px);max-width:calc(100% - 40px);width:var(--label-wrapper-width,100%)}.toyCo_InputLabel-formLabel-9815042{display:block;font-weight:400;margin-bottom:8px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.toyCo_InputLabel-formLabel-9815042:not(.dxp-lexus *,.cp-label-inside-field-wrapper *){color:#282830;font-size:16px;line-height:24px}";
var styles$9 = {"labelContainer":"toyCo_InputLabel-labelContainer-9715042","formLabel":"toyCo_InputLabel-formLabel-9815042"};
styleInject(css_248z$9);

var InputLabel = function InputLabel(_ref) {
  var _ref$label = _ref.label,
    label = _ref$label === void 0 ? TRIDION_LABEL_MISSING : _ref$label,
    _ref$isRequired = _ref.isRequired,
    isRequired = _ref$isRequired === void 0 ? false : _ref$isRequired,
    _ref$popover = _ref.popover,
    popover = _ref$popover === void 0 ? null : _ref$popover,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? "".concat(TRIDION_LABEL_MISSING, "-id") : _ref$id,
    labelClassName = _ref.labelClassName,
    className = _ref.className;
  return /*#__PURE__*/React__default.createElement("div", {
    className: classNames(styles$9.labelContainer, className)
  }, /*#__PURE__*/React__default.createElement("label", {
    className: classNames(styles$9.formLabel, labelClassName, "cp-form-label"),
    htmlFor: id
  }, label), /*#__PURE__*/React__default.createElement(MandatorySign, {
    testId: id,
    show: isRequired
  }), popover);
};

var css_248z$8 = ".toyCo_Input-errorMessageContainer-7115042{align-items:center;color:var(--cp-error-color,var(--cp-red));display:flex;gap:1rem;justify-content:space-between;padding-right:30px;position:relative}.toyCo_Input-errorMessageContainer-7115042 .toyCo_Input-errorMessageParagraph-7215042{margin:0}.toyCo_Input-errorMessageContainer-7115042:not(.dxp-lexus *){font-family:T1 Body Font,Toyota Base,Lexus Base,Arial,Helvetica,sans-serif;font-size:15px;line-height:24px}.toyCo_Input-errorMessageContainer-7115042 .toyCo_Input-errorMessageContainerIcon-7315042:before{font-family:dxp-icon;font-size:16px}.toyCo_Input-errorMessageContainer-7115042:is(.dxp *){padding-right:0}.toyCo_Input-errorMessageContainer-7115042:is(.dxp-lexus *){padding-right:0}.toyCo_Input-iconPosition-7415042{height:16px;position:absolute;right:25px;top:55px;width:16px}.toyCo_Input-iconPosition-7415042:is(.dxp-lexus *){display:none}.toyCo_Input-iconPosition-7415042:is(.dxp-toyota *){display:none}.toyCo_Input-red-7515042{color:var(--cp-error-color,var(--cp-red,#f02))}.toyCo_Input-green-7615042{color:#4caf50}.form input.toyCo_Input-disabled-7715042:hover{background-color:#eff0f0}.toyCo_Input-hidePlaceholder-7815042::placeholder{color:transparent}.toyCo_Input-inputWrapperWithCustomIcon-7915042{position:relative}.toyCo_Input-inputWrapperWithCustomIcon-7915042 .toyCo_Input-customIconWrapper-8015042{align-items:center;display:flex;position:absolute;right:1.6rem;top:1.6rem}";
var styles$8 = {"errorMessageContainer":"toyCo_Input-errorMessageContainer-7115042","errorMessageParagraph":"toyCo_Input-errorMessageParagraph-7215042","errorMessageContainerIcon":"toyCo_Input-errorMessageContainerIcon-7315042","iconPosition":"toyCo_Input-iconPosition-7415042","red":"toyCo_Input-red-7515042","green":"toyCo_Input-green-7615042","disabled":"toyCo_Input-disabled-7715042","hidePlaceholder":"toyCo_Input-hidePlaceholder-7815042","inputWrapperWithCustomIcon":"toyCo_Input-inputWrapperWithCustomIcon-7915042","customIconWrapper":"toyCo_Input-customIconWrapper-8015042"};
styleInject(css_248z$8);

var InputErrorMessage = function InputErrorMessage(_ref) {
  var errorMessage = _ref.errorMessage,
    testId = _ref.testId,
    _ref$showErrorIcon = _ref.showErrorIcon,
    showErrorIcon = _ref$showErrorIcon === void 0 ? true : _ref$showErrorIcon;
  return /*#__PURE__*/React__default.createElement("div", {
    className: classNames(styles$8.errorMessageContainer, "cp-fadeIn cp-input-error-msg-container"),
    "data-test-id": testId
  }, /*#__PURE__*/React__default.createElement("p", {
    "data-test-id": "".concat(testId, "-paragraph"),
    className: "".concat(styles$8.errorMessageParagraph, " cp-input-error-msg")
  }, errorMessage), isDeployedInDxp() && showErrorIcon ? ( /*#__PURE__*/React__default.createElement(Icon, {
    iconType: "DXPICON",
    className: classNames("icon-Error-small", [styles$8.errorMessageContainerIcon])
  })) : null);
};

var useIsDeployedInCpClient = function useIsDeployedInCpClient() {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    didMount = _useState2[0],
    setDidMount = _useState2[1];
  useEffect(function () {
    return setDidMount(true);
  }, []);
  return useMemo(function () {
    return Boolean(didMount && document.getElementsByTagName("cp-client").length);
  }, [didMount]);
};

var css_248z$7 = ".toyCo_Dropdown-dropdownToggle-8415042{align-items:center;display:flex;justify-content:space-between}.toyCo_Dropdown-dropdownErrorBorder-8515042{border:1px solid var(--cp-error-color)!important}.toyCo_Dropdown-dropdownErrorMessage-8615042{margin-bottom:16px;margin-top:-16px}.toyCo_Dropdown-dropdownFocus-8715042:focus-visible{outline:var(--cp-accessibility-outline)}";
var styles$7 = {"dropdownToggle":"toyCo_Dropdown-dropdownToggle-8415042","dropdownErrorBorder":"toyCo_Dropdown-dropdownErrorBorder-8515042","dropdownErrorMessage":"toyCo_Dropdown-dropdownErrorMessage-8615042","dropdownFocus":"toyCo_Dropdown-dropdownFocus-8715042"};
styleInject(css_248z$7);

/** the Dropdown component can have two roles: propose some options as standard dropdowns do OR show a child component
 * when opened(like a datepicker for instance). When dropdownOptions are not provided the component will try and
 * render the children instead. */
var Dropdown = function Dropdown(_ref) {
  var isOpen = _ref.isOpen,
    _ref$setIsOpen = _ref.setIsOpen,
    setIsOpen = _ref$setIsOpen === void 0 ? function () {
      return null;
    } : _ref$setIsOpen,
    isDisabled = _ref.isDisabled,
    _ref$dropdownOptions = _ref.dropdownOptions,
    dropdownOptions = _ref$dropdownOptions === void 0 ? [] : _ref$dropdownOptions,
    children = _ref.children,
    _ref$onOptionClick = _ref.onOptionClick,
    onOptionClick = _ref$onOptionClick === void 0 ? function () {
      return null;
    } : _ref$onOptionClick,
    selectedOption = _ref.selectedOption,
    className = _ref.className,
    _ref$anchorClick = _ref.anchorClick,
    anchorClick = _ref$anchorClick === void 0 ? function (event) {
      return event === null || event === void 0 ? void 0 : event.preventDefault();
    } : _ref$anchorClick,
    placeholderLabel = _ref.placeholderLabel,
    label = _ref.label,
    isRequired = _ref.isRequired,
    id = _ref.id,
    popover = _ref.popover,
    testId = _ref.testId,
    errorMessage = _ref.errorMessage,
    shouldShowErrorMessage = _ref.shouldShowErrorMessage,
    labelInsideField = _ref.labelInsideField,
    customizeOptions = _ref.customizeOptions,
    showErrorIcon = _ref.showErrorIcon,
    focusOnTab = _ref.focusOnTab,
    _ref$onEnterKeyPress = _ref.onEnterKeyPress,
    onEnterKeyPress = _ref$onEnterKeyPress === void 0 ? function () {
      return;
    } : _ref$onEnterKeyPress;
  var refDropdown = useRef(null);
  var isDeployedInCpClient = useIsDeployedInCpClient();
  var showLabelInsideField = labelInsideField !== null && labelInsideField !== void 0 ? labelInsideField : isDeployedInCpClient;
  var iconOpenedClassName = (customizeOptions === null || customizeOptions === void 0 ? void 0 : customizeOptions.openedIconClassName) || "icon-Chevron_Up-small";
  var iconClosedClassName = (customizeOptions === null || customizeOptions === void 0 ? void 0 : customizeOptions.closedIconClassName) || "icon-Chevron_Down-small";
  var inputLabel = label ? ( /*#__PURE__*/React__default.createElement(InputLabel, Object.assign({}, {
    label: label,
    isRequired: isRequired,
    popover: popover,
    id: id,
    className: showLabelInsideField ? "cp-label-inside-field-wrapper" : undefined
  }))) : null;
  useEffect(function () {
    return onIsOpenChange(isOpen, refDropdown, setIsOpen);
  }, [isOpen, setIsOpen]);
  var defaultOption = showLabelInsideField ? dropdownOptions.find(function (option) {
    return option.defaultOption;
  }) : dropdownOptions.find(function (option) {
    return option.defaultOption;
  }) || {
    label: placeholderLabel
  };
  var selectedLabel = _.get(selectedOption, "label") || (defaultOption === null || defaultOption === void 0 ? void 0 : defaultOption.label);
  var wrapperClassNames = classNames(className, {
    'open cp-dropdown-opened': isOpen
  }, "dropdown cp-dropdown", showLabelInsideField ? "cp-field-with-label-inside cp-field-main-container" : null, showLabelInsideField && selectedLabel ? "cp-field-has-value" : null);
  var onClickHandler = function onClickHandler(event) {
    event.preventDefault();
    !isDisabled && setIsOpen(!isOpen);
  };
  var handleKeyDownOnDropdown = function handleKeyDownOnDropdown(event) {
    if (focusOnTab && event.key === "Enter") {
      onClickHandler(event);
    }
  };
  var handleKeyDownOnOption = function handleKeyDownOnOption(event, option) {
    if (focusOnTab && event.key === "Enter") {
      onEnterKeyPress(event, option);
    }
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, !showLabelInsideField ? inputLabel : null, /*#__PURE__*/React__default.createElement("div", Object.assign({}, {
    className: wrapperClassNames,
    ref: refDropdown,
    'data-test-id': testId
  }), /*#__PURE__*/React__default.createElement("a", {
    "data-test-id": "".concat(testId, "-toggle"),
    onClick: onClickHandler,
    className: classNames("dropdown-toggle cp-dropdown-toggle ".concat(styles$7.dropdownFocus), {
      disabled: isDisabled
    }, shouldShowErrorMessage && styles$7.dropdownErrorBorder),
    tabIndex: focusOnTab ? 0 : -1,
    onKeyDown: handleKeyDownOnDropdown,
    "aria-label": "".concat(label, " ").concat(selectedLabel || "", " ").concat(isOpen ? "expanded" : "collapsed"),
    role: "button"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles$7.dropdownToggle
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "selected-item"
  }, selectedLabel), /*#__PURE__*/React__default.createElement(Icon, Object.assign({}, {
    className: "".concat(isOpen ? iconOpenedClassName : iconClosedClassName),
    iconType: "DXPICON"
  })))), showLabelInsideField ? inputLabel : null, /*#__PURE__*/React__default.createElement("ul", {
    "data-test-id": "".concat(testId, "-options"),
    className: "dropdown-menu cp-dropdown-menu cp-fadeIn cp-scrollbar"
  }, _.isEmpty(dropdownOptions) ? children : dropdownOptions.map(function (dropdownOption, index) {
    return /*#__PURE__*/React__default.createElement("li", Object.assign({
      "data-test-id": "".concat(testId, "-option").concat(index),
      key: index
    }, {
      hidden: dropdownOption.hidden,
      onClick: function onClick(event) {
        return onOptionClick(event, dropdownOption);
      },
      onKeyDown: function onKeyDown(event) {
        return handleKeyDownOnOption(event, dropdownOption);
      }
    }, {
      tabIndex: 0
    }), /*#__PURE__*/React__default.createElement("a", {
      href: "#",
      onClick: anchorClick,
      tabIndex: -1
    }, dropdownOption.label));
  }))), shouldShowErrorMessage ? ( /*#__PURE__*/React__default.createElement("div", {
    className: styles$7.dropdownErrorMessage
  }, /*#__PURE__*/React__default.createElement(InputErrorMessage, {
    testId: "".concat(testId, "-inputErrorMessage"),
    errorMessage: errorMessage,
    showErrorIcon: showErrorIcon
  }))) : null);
};

var InputWrapper = function InputWrapper(_ref) {
  var label = _ref.label,
    labelPopover = _ref.labelPopover,
    labelWrapperClassName = _ref.labelWrapperClassName,
    labelClassName = _ref.labelClassName,
    isRequired = _ref.isRequired,
    showValidIcon = _ref.showValidIcon,
    isValid = _ref.isValid,
    showErrorIcon = _ref.showErrorIcon,
    showErrorMessage = _ref.showErrorMessage,
    errorMessage = _ref.errorMessage,
    errorTestId = _ref.errorTestId,
    id = _ref.id,
    className = _ref.className,
    value = _ref.value,
    testId = _ref.testId,
    children = _ref.children,
    labelInsideField = _ref.labelInsideField,
    customIcon = _ref.customIcon;
  var isDeployedInCpClient = useIsDeployedInCpClient();
  var showLabelInsideField = labelInsideField !== null && labelInsideField !== void 0 ? labelInsideField : isDeployedInCpClient;
  var inputLabel = label ? ( /*#__PURE__*/React__default.createElement(InputLabel, Object.assign({}, {
    label: label,
    isRequired: isRequired,
    popover: labelPopover,
    id: id,
    className: showLabelInsideField ? classNames("cp-label-inside-field-wrapper", labelWrapperClassName) : labelWrapperClassName,
    labelClassName: labelClassName
  }))) : null;
  return /*#__PURE__*/React__default.createElement("div", {
    className: classNames("input-container cp-field-main-container", {
      'input-invalid cp-field-main-wrapper-error': showErrorMessage
    }, className),
    "data-test-id": testId
  }, !showLabelInsideField ? inputLabel : null, /*#__PURE__*/React__default.createElement("div", {
    className: classNames("cp-field-wrapper", {
      'cp-field-with-label-inside': showLabelInsideField,
      'cp-field-has-value': value && !!"".concat(value).length
    })
  }, customIcon ? ( /*#__PURE__*/React__default.createElement("div", {
    className: styles$8.inputWrapperWithCustomIcon
  }, children, /*#__PURE__*/React__default.createElement("span", {
    className: styles$8.customIconWrapper
  }, customIcon))) : ( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, children)), showLabelInsideField ? inputLabel : null, showErrorIcon && showErrorMessage && ( /*#__PURE__*/React__default.createElement(Icon, Object.assign({}, {
    className: classNames("icon-Error-small", styles$8.iconPosition, styles$8.red),
    iconType: "DXPICON"
  }))), showValidIcon && isValid && ( /*#__PURE__*/React__default.createElement(Icon, Object.assign({}, {
    className: classNames("icon-Check-small", styles$8.iconPosition, styles$8.green),
    iconType: "DXPICON"
  })))), showErrorMessage && ( /*#__PURE__*/React__default.createElement(InputErrorMessage, Object.assign({}, {
    errorMessage: errorMessage,
    showErrorIcon: showErrorIcon,
    testId: errorTestId
  }))));
};

var INPUT_TYPES;
(function (INPUT_TYPES) {
  INPUT_TYPES["TEXT"] = "text";
  INPUT_TYPES["NUMBER"] = "number";
  INPUT_TYPES["TEXTAREA"] = "textArea";
  INPUT_TYPES["EMAIL"] = "email";
  INPUT_TYPES["PASSWORD"] = "password";
})(INPUT_TYPES || (INPUT_TYPES = {}));
var preventPasting = function preventPasting(e) {
  return e.preventDefault();
};
var Input = /*#__PURE__*/React__default.forwardRef(function (_a, ref) {
  var id = _a.id,
    name = _a.name,
    type = _a.type,
    list = _a.list,
    label = _a.label,
    placeholder = _a.placeholder,
    value = _a.value,
    errorMessage = _a.errorMessage,
    isValid = _a.isValid,
    onFocus = _a.onFocus,
    onChange = _a.onChange,
    onBlur = _a.onBlur,
    onKeyPress = _a.onKeyPress,
    onKeyDown = _a.onKeyDown,
    onPaste = _a.onPaste,
    min = _a.min,
    max = _a.max,
    isRequired = _a.isRequired,
    className = _a.className,
    labelClassName = _a.labelClassName,
    disabled = _a.disabled,
    autoComplete = _a.autoComplete,
    testId = _a.testId,
    popover = _a.popover,
    errorTestId = _a.errorTestId,
    preventPaste = _a.preventPaste,
    labelInsideField = _a.labelInsideField,
    customIcon = _a.customIcon,
    tabIndex = _a.tabIndex,
    options = __rest(_a, ["id", "name", "type", "list", "label", "placeholder", "value", "errorMessage", "isValid", "onFocus", "onChange", "onBlur", "onKeyPress", "onKeyDown", "onPaste", "min", "max", "isRequired", "className", "labelClassName", "disabled", "autoComplete", "testId", "popover", "errorTestId", "preventPaste", "labelInsideField", "customIcon", "tabIndex"]);
  var shouldShowErrorMessage = options.shouldShowErrorMessage,
    maxLength = options.maxLength,
    minLength = options.minLength,
    showValidIcon = options.showValidIcon,
    _options$showErrorIco = options.showErrorIcon,
    showErrorIcon = _options$showErrorIco === void 0 ? true : _options$showErrorIco;
  var isDeployedInCpClient = useIsDeployedInCpClient();
  var showLabelInsideField = labelInsideField !== null && labelInsideField !== void 0 ? labelInsideField : isDeployedInCpClient;
  var shouldHidePlaceholder = showLabelInsideField && label;
  var commonAttributes = {
    id: id,
    name: name,
    type: type !== null && type !== void 0 ? type : INPUT_TYPES.TEXT,
    placeholder: shouldHidePlaceholder ? undefined : placeholder,
    value: value,
    list: list,
    maxLength: maxLength,
    minLength: minLength,
    min: min,
    max: max,
    disabled: disabled,
    autoComplete: autoComplete,
    className: classNames("cp-field", _defineProperty(_defineProperty({
      'input-error cp-input-error': shouldShowErrorMessage
    }, styles$8.disabled, disabled), styles$8.hidePlaceholder, shouldHidePlaceholder)),
    'data-test-id': testId,
    'aria-label': label,
    ref: ref,
    tabIndex: tabIndex
  };
  var commonHandlers = {
    onPaste: preventPaste ? preventPasting : onPaste,
    onFocus: onFocus,
    onChange: onChange,
    onBlur: onBlur,
    onKeyPress: onKeyPress,
    onKeyDown: onKeyDown
  };
  var Component = type === INPUT_TYPES.TEXTAREA ? "textarea" : "input";
  return /*#__PURE__*/React__default.createElement(InputWrapper, Object.assign({
    testId: "".concat(testId, "-wrapper")
  }, {
    label: label,
    labelPopover: popover,
    labelClassName: labelClassName,
    isRequired: isRequired,
    showValidIcon: showValidIcon,
    isValid: isValid,
    showErrorIcon: showErrorIcon,
    showErrorMessage: shouldShowErrorMessage,
    errorMessage: errorMessage,
    errorTestId: errorTestId,
    id: id,
    className: className,
    value: value,
    customIcon: customIcon
  }), /*#__PURE__*/React__default.createElement(Component, Object.assign({}, commonAttributes, commonHandlers)));
});
Input.displayName = "Input";

var css_248z$6 = "cp-client .cp-label-inside-field-wrapper.toyCo_InputTel-inputTelLabelContainer-13115042{left:53px}";
var styles$6 = {"inputTelLabelContainer":"toyCo_InputTel-inputTelLabelContainer-13115042"};
styleInject(css_248z$6);

/** Estonia and Lituania validations from the plugin were incomplete so we've extended them until we migrate to a
 * more up to date phone input field plugin */
var extendedPhoneValidation = function extendedPhoneValidation(phoneNumberWithDial, country, isValid) {
  var countryPatterns = {
    //optionally starts with +372 and is followed by 6 to 8 digits
    ee: /^\+372\s*[1-9](?:\s*\d){5,7}$/,
    //optionally starts with +370 and is followed by 6 to 9 digits
    lt: /^\+370\s*[1-9](?:\s*\d){5,8}$/
  };
  var regexPattern = countryPatterns[country.iso2];
  if (!isValid && regexPattern) {
    isValid = regexPattern.test(phoneNumberWithDial);
  }
  return isValid;
};
var getExtendedPhoneNumberWithDial = function getExtendedPhoneNumberWithDial(phoneNumberWithDial, country, isValid) {
  var countryPrefix = {
    ee: "+372",
    lt: "+370"
  };
  var potentialExtendedPrefix = countryPrefix[country.iso2];
  var phoneNumberSupportsPrefix = Boolean(potentialExtendedPrefix);
  var phoneNumberAlreadyHasPrefix = phoneNumberWithDial.startsWith(potentialExtendedPrefix);
  if (isValid && phoneNumberSupportsPrefix && !phoneNumberAlreadyHasPrefix) {
    return "".concat(potentialExtendedPrefix, " ").concat(phoneNumberWithDial);
  }
  return phoneNumberWithDial;
};

var lazyloadReactTelInputStyles = function lazyloadReactTelInputStyles() {
  try {
    if (window === null || window === void 0 ? void 0 : window.requirees) {
      window.requirees("".concat(window.dxp.settings.cpCommonUrl, "/cp-client/styles/libraries/ForkedReactTelInput.css"));
    }
  } catch (err) {
    logMessageOnDebugMode("Error loading react-tel-input styles", "ERROR");
  }
};
lazyloadReactTelInputStyles();
var InputTel = function InputTel(_ref) {
  var label = _ref.label,
    popover = _ref.popover,
    labelClassName = _ref.labelClassName,
    isMandatory = _ref.isMandatory,
    showValidIcon = _ref.showValidIcon,
    isValid = _ref.isValid,
    shouldShowErrorMessage = _ref.shouldShowErrorMessage,
    _ref$errorMessage = _ref.errorMessage,
    errorMessage = _ref$errorMessage === void 0 ? "" : _ref$errorMessage,
    _ref$containerClassNa = _ref.containerClassName,
    containerClassName = _ref$containerClassNa === void 0 ? "intl-tel-input cp-intl-tel-input" : _ref$containerClassNa,
    _ref$inputClassName = _ref.inputClassName,
    inputClassName = _ref$inputClassName === void 0 ? "form-control" : _ref$inputClassName,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    _ref$fieldName = _ref.fieldName,
    fieldName = _ref$fieldName === void 0 ? "" : _ref$fieldName,
    _ref$fieldId = _ref.fieldId,
    fieldId = _ref$fieldId === void 0 ? "" : _ref$fieldId,
    defaultValue = _ref.defaultValue,
    value = _ref.value,
    disabled = _ref.disabled,
    preferredCountries = _ref.preferredCountries,
    autoPlaceholder = _ref.autoPlaceholder,
    formatOnInit = _ref.formatOnInit,
    separateDialCode = _ref.separateDialCode,
    onPhoneNumberChange = _ref.onPhoneNumberChange,
    _onPhoneNumberBlur = _ref.onPhoneNumberBlur,
    onPhoneNumberFocus = _ref.onPhoneNumberFocus,
    testId = _ref.testId,
    labelInsideField = _ref.labelInsideField;
  var isDeployedInCpClient = useIsDeployedInCpClient();
  var showLabelInsideField = labelInsideField !== null && labelInsideField !== void 0 ? labelInsideField : isDeployedInCpClient;
  useEffect(function () {
    var element = document.querySelector("input");
    if (element) {
      element.setAttribute("aria-label", "Phone number input");
    }
  }, []);
  return /*#__PURE__*/React__default.createElement(InputWrapper, Object.assign({}, {
    label: label,
    labelPopOver: popover,
    labelWrapperClassName: showLabelInsideField ? styles$6.inputTelLabelContainer : undefined,
    labelClassName: labelClassName,
    isRequired: isMandatory,
    showValidIcon: showValidIcon,
    isValid: isValid,
    showErrorIcon: shouldShowErrorMessage,
    showErrorMessage: shouldShowErrorMessage,
    errorMessage: errorMessage,
    errorTestId: "telephone-input-error",
    id: fieldId,
    className: className,
    value: value,
    testId: testId,
    labelInsideField: labelInsideField
  }), /*#__PURE__*/React__default.createElement(IntlTelInput, Object.assign({}, {
    defaultValue: defaultValue,
    containerClassName: containerClassName,
    inputClassName: classNames("cp-field", inputClassName),
    fieldName: fieldName,
    fieldId: fieldId,
    value: value,
    preferredCountries: preferredCountries,
    className: className,
    autoPlaceholder: autoPlaceholder,
    formatOnInit: formatOnInit,
    separateDialCode: separateDialCode,
    onPhoneNumberChange: onPhoneNumberChange,
    onPhoneNumberBlur: function onPhoneNumberBlur(isValid, _rawPhoneNumber, _country, phoneNumberWithDial) {
      var extendedIsValid = extendedPhoneValidation(phoneNumberWithDial, _country, isValid);
      var extendedPhoneNumberWithDial = getExtendedPhoneNumberWithDial(phoneNumberWithDial, _country, extendedIsValid);
      _onPhoneNumberBlur(extendedIsValid, _rawPhoneNumber, _country, extendedPhoneNumberWithDial);
    },
    onPhoneNumberFocus: onPhoneNumberFocus,
    disabled: disabled
  })));
};

var css_248z$5 = ".toyCo_RadioButton-radioButton-8815042.toyCo_RadioButton-disabled-8915042{cursor:not-allowed}";
var styles$5 = {"radioButton":"toyCo_RadioButton-radioButton-8815042","disabled":"toyCo_RadioButton-disabled-8915042"};
styleInject(css_248z$5);

var idCounter = 0;
var RadioButton = function RadioButton(_ref) {
  var checked = _ref.checked,
    isMandatory = _ref.isMandatory,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    label = _ref.label,
    value = _ref.value,
    id = _ref.id,
    name = _ref.name,
    _ref$labelClassName = _ref.labelClassName,
    labelClassName = _ref$labelClassName === void 0 ? "" : _ref$labelClassName,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? _.noop : _ref$onClick,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? _.noop : _ref$onChange,
    testId = _ref.testId;
  var radioButtonParentClass = disabled ? "".concat(styles$5.disabled) : "";
  var classNames$1 = classNames(styles$5.radioButton, radioButtonParentClass, className);
  var radioButtonId = useMemo(function () {
    return id || "radio-".concat(++idCounter);
  }, [id]);
  return /*#__PURE__*/React__default.createElement(Check, Object.assign({}, {
    className: classNames$1,
    value: value,
    checked: checked,
    disabled: disabled,
    id: radioButtonId,
    name: name,
    onClick: onClick,
    onChange: onChange,
    testId: testId,
    label: label,
    labelClassName: labelClassName,
    isMandatory: isMandatory,
    type: "radio"
  }));
};

var css_248z$4 = ".toyCo_FormProgressViewer-progressViewer-13215042{margin-bottom:15px;margin-top:15px}.toyCo_FormProgressViewer-error-13315042{color:var(--cp-red,#f02);display:block}.toyCo_FormProgressViewer-icon-13415042{margin-right:3px;transform:translateY(3px)}";
var styles$4 = {"progressViewer":"toyCo_FormProgressViewer-progressViewer-13215042","error":"toyCo_FormProgressViewer-error-13315042","icon":"toyCo_FormProgressViewer-icon-13415042"};
styleInject(css_248z$4);

var FormProgressViewer = function FormProgressViewer(_ref) {
  var status = _ref.status,
    showSuccessMessage = _ref.showSuccessMessage,
    showErrorMessage = _ref.showErrorMessage,
    showErrorIcon = _ref.showErrorIcon,
    errorTestId = _ref.errorTestId,
    successMessage = _ref.successMessage,
    failedMessage = _ref.failedMessage,
    children = _ref.children;
  return /*#__PURE__*/React__default.createElement("div", {
    className: styles$4.progressViewer
  }, status === "STARTED" ? ( /*#__PURE__*/React__default.createElement(Loader, null)) : ( /*#__PURE__*/React__default.createElement(React__default.Fragment, null, showSuccessMessage && status === "SUCCESS" && ( /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Icon, {
    className: "icon-Check-small ".concat(styles$4.icon),
    iconType: "DXPICON"
  }), /*#__PURE__*/React__default.createElement("span", null, successMessage))), showErrorMessage && status === "FAILED" && ( /*#__PURE__*/React__default.createElement("div", {
    className: styles$4.error,
    "data-test-id": errorTestId
  }, showErrorIcon && ( /*#__PURE__*/React__default.createElement(Icon, {
    className: "icon-Error-small ".concat(styles$4.icon),
    iconType: "DXPICON"
  })), /*#__PURE__*/React__default.createElement("span", null, failedMessage))), children)));
};

var css_248z$3 = ".toyCo_TextWithLink-commonTextStyles-9915042{display:inline}";
var styles$3 = {"commonTextStyles":"toyCo_TextWithLink-commonTextStyles-9915042"};
styleInject(css_248z$3);

var REGEX = /(.*){{(.*)}}(.*)/,
  EXPECTED_ARRAY_LENGTH = 4,
  GROUPS = {
    BEFORE_LINK: 1,
    LINK: 2,
    AFTER_LINK: 3
  };
var TextWithLink = function TextWithLink(_ref) {
  var labelWithPlaceholder = _ref.labelWithPlaceholder,
    translatedPlaceholder = _ref.translatedPlaceholder,
    placeholderProps = _ref.placeholderProps,
    textProps = _ref.textProps,
    labelMissingProps = _ref.labelMissingProps,
    children = _ref.children;
  var regexToSplitLabel = REGEX,
    labelSplitArray = regexToSplitLabel.exec(labelWithPlaceholder || "") || [];
  if (labelSplitArray.length === EXPECTED_ARRAY_LENGTH) {
    var beforePlaceholderLabel = labelSplitArray[GROUPS.BEFORE_LINK],
      afterPlaceholderLabel = labelSplitArray[GROUPS.AFTER_LINK];
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, (translatedPlaceholder || children) && ( /*#__PURE__*/React__default.createElement(Text, Object.assign({}, Object.assign(Object.assign({}, textProps), {
      className: classNames(_.get(textProps, "className"), styles$3.commonTextStyles)
    })), beforePlaceholderLabel, children ? children : ( /*#__PURE__*/React__default.createElement(Text, Object.assign({}, Object.assign(Object.assign({}, placeholderProps), {
      className: classNames(_.get(placeholderProps, "className"), styles$3.commonTextStyles)
    })), translatedPlaceholder)), afterPlaceholderLabel)));
  } else {
    return /*#__PURE__*/React__default.createElement(Text, Object.assign({}, labelMissingProps), TRIDION_LABEL_MISSING);
  }
};

var css_248z$2 = ".toyCo_ExternalLink-externalLinkIcon-8115042{margin-left:5px;vertical-align:text-bottom}";
var styles$2 = {"externalLinkIcon":"toyCo_ExternalLink-externalLinkIcon-8115042"};
styleInject(css_248z$2);

/**
 * @module url
 * @description helpers such as: getting URL query string parameters, building a url by concatenating routes/parameters
 * and other utilities that manipulates the current url or builds a new one...
 */
var TRAILING_SLASH = /\/$/;
var IS_HASH_OR_QUERY_STRING = /^[#/?]/;
function removeEmptyValuesFromArray(arr) {
  var resultArr = [];
  for (var iArg = 0; iArg < arr.length; iArg++) {
    if (arr[iArg]) {
      resultArr.push(arr[iArg]);
    }
  }
  return resultArr;
}
/**
 * @function concat
 * @description concatenates each parameter you pass to the function and gets rid of double slashes or non valid
 * values. E.G: if you do concat('http://www.test.test/', null, undefined, '/', '/mypage', 'something', '?test=1',
 * '#yes') the result will be 'http://www.test.test/mypage/something?test=1#yes'
 */
function concat() {
  var concatenatedUrl = "";
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  if (args.length) {
    var urlFragments = removeEmptyValuesFromArray(args[0] instanceof Array ? args[0] : args);
    var urlFragment;
    for (var iArg = 0; iArg < urlFragments.length; iArg++) {
      urlFragment = urlFragments[iArg];
      urlFragment = _typeof(urlFragment) === "string" ? urlFragment.trim() : "";
      if (iArg !== urlFragments.length - 1) {
        urlFragment = urlFragment.replace(TRAILING_SLASH, "");
      }
      concatenatedUrl += (iArg !== 0 && !IS_HASH_OR_QUERY_STRING.test(urlFragment) ? "/" : "") + urlFragment;
    }
  }
  return concatenatedUrl;
}
/**
 * @function getAuthorPath
 * @description If deployed in author prod, get current base path from location
 * e.g. https://aem-author-prod.toyota.eu/content/toyota/uk/en/apps/onlinecheckout?personalCode=9-gQPwi8E is current location it will return /content/toyota/uk/en/
 */
function getAuthorPath() {
  if (!isDeployedInAuthor()) {
    return null;
  }
  var currentPath = window.location.pathname;
  var language = window.T1.settings.language;
  var endPosition = currentPath.indexOf("/".concat(language, "/")) + 1 + language.length;
  return currentPath.substring(0, endPosition);
}
/**
 * @function processPathToAemAuthor
 * @description Process path with current aem author base path, e.g
 * Current path: https://aem-author-prod.toyota.eu/content/lexus/uk/en/apps/customerportal.html#/tiles/activeBasketCars
 * input: /
 * result: /content/lexus/uk/en/
 */
function processPathToAemAuthor(destinationPath) {
  if (!isDeployedInAuthor()) {
    return destinationPath;
  }
  var basePath = getAuthorPath();
  var aemPath = processAemPath(destinationPath);
  return "".concat(basePath).concat(aemPath);
}
function processAemPath(destinationPath) {
  var paths = destinationPath.split("#");
  var destinationArray = removeEmptyValuesFromArray(paths[0].split("/"));
  var hashtagPath = paths[1];
  if (destinationArray.indexOf("apps") > -1) {
    var appRoot = destinationArray.slice(0, 2).join("/");
    return "/".concat(appRoot, ".html").concat(hashtagPath ? "#" + hashtagPath : "", "/").concat(destinationArray.slice(2, destinationArray.length - 1).join("/"));
  }
  return destinationPath;
}
/**
 * @function getQueryStringParam
 * @description get querystring parameter value from the url
 */
var getQueryStringParam = function getQueryStringParam(param) {
  var params = new URLSearchParams(window.location.search);
  return params.get(param);
};
/**
 * @description set a querystring parameter value in the current url without refreshing the page
 */
var setQueryStringParam = function setQueryStringParam(param, value) {
  var currentUrl = new URL(window.location.href);
  currentUrl.searchParams.set(param, value);
  history.pushState({}, "", currentUrl.toString());
};
/**
 * @function getValueFromHash
 * @description same as getQueryStringParam but gets the value from a hash parameter and decodes it if encoded
 */
var getValueFromHash = function getValueFromHash(input) {
  var pattern = "[/]".concat(input, "=([^/]*)");
  var params = new RegExp(pattern).exec(window.location.hash);
  return window.decodeURI((params === null || params === void 0 ? void 0 : params[1]) || "");
};
var isValidUrl = function isValidUrl(str) {
  try {
    return !!new URL(str);
  } catch (e) {
    return false;
  }
};

var _url = /*#__PURE__*/Object.freeze({
  __proto__: null,
  concat: concat,
  getAuthorPath: getAuthorPath,
  processPathToAemAuthor: processPathToAemAuthor,
  getQueryStringParam: getQueryStringParam,
  setQueryStringParam: setQueryStringParam,
  getValueFromHash: getValueFromHash,
  isValidUrl: isValidUrl
});

var ExternalLink = function ExternalLink(_ref) {
  var url = _ref.url,
    label = _ref.label,
    _ref$accessibilityLab = _ref.accessibilityLabel,
    accessibilityLabel = _ref$accessibilityLab === void 0 ? "" : _ref$accessibilityLab,
    dataTestId = _ref.dataTestId,
    className = _ref.className;
  var linkLabel = label || url;
  var getAriaLabelValue = function getAriaLabelValue() {
    var isLabelUrl = isValidUrl(linkLabel);
    // removing protocol because url with protocol is not readable by screen reader
    var readableUrl = isLabelUrl ? url.replace(/(^\w+:|^)\/\//, "") : linkLabel;
    return "".concat(readableUrl, " ").concat(accessibilityLabel);
  };
  var externalLinkIconClassName = "dxp-icon icon-External_Link-small";
  var ariaLabelValue = getAriaLabelValue();
  return /*#__PURE__*/React__default.createElement("a", {
    href: url,
    "data-test-id": dataTestId,
    target: "_blank",
    rel: "noreferrer",
    className: classNames(className),
    "aria-label": ariaLabelValue
  }, linkLabel, /*#__PURE__*/React__default.createElement("i", {
    className: classNames(externalLinkIconClassName, styles$2.externalLinkIcon)
  }));
};

var css_248z$1 = ".toyCo_MyTappLinks-url-15215042{display:block;margin-bottom:var(--cp-xxs-space)}.toyCo_MyTappLinks-storeImage-15315042{width:var(--cp-toyCo-mytapplink-url-w,180px)}.toyCo_MyTappLinks-cardIcon-15415042{color:var(--cp-grey-light-hover);left:50%;position:absolute;top:50%;transform:translate(-50%,-50%)}.toyCo_MyTappLinks-qr-15515042{display:none}@media (min-width:768px){.toyCo_MyTappLinks-qr-15515042{display:block;height:140px;margin-right:25px}}.toyCo_MyTappLinks-stores-15615042{display:inline-flex;flex-direction:row}@media (min-width:768px){.toyCo_MyTappLinks-stores-15615042{display:inline-flex;flex-direction:column;height:120px;justify-content:space-around}}.toyCo_MyTappLinks-wrapperAppLinks-15715042{margin-top:var(--cp-sm-space)}";
var styles$1 = {"url":"toyCo_MyTappLinks-url-15215042","storeImage":"toyCo_MyTappLinks-storeImage-15315042","cardIcon":"toyCo_MyTappLinks-cardIcon-15415042","qr":"toyCo_MyTappLinks-qr-15515042","stores":"toyCo_MyTappLinks-stores-15615042","wrapperAppLinks":"toyCo_MyTappLinks-wrapperAppLinks-15715042"};
styleInject(css_248z$1);

var FALLBACK_NEW_APPLE = ONE_APP_CONSTANTS.FALLBACK_NEW_APPLE,
  FALLBACK_NEW_PLAY = ONE_APP_CONSTANTS.FALLBACK_NEW_PLAY,
  FALLBACK_LEXUS_NEW_APPLE = ONE_APP_CONSTANTS.FALLBACK_LEXUS_NEW_APPLE,
  FALLBACK_LEXUS_NEW_PLAY = ONE_APP_CONSTANTS.FALLBACK_LEXUS_NEW_PLAY;
var getRedirectionUrl = function getRedirectionUrl(_ref) {
  var appleStoreUrl = _ref.appleStoreUrl,
    playStoreUrl = _ref.playStoreUrl;
  var encodedAppleStoreUrl = encodeURIComponent(appleStoreUrl);
  var encodedPlayStoreUrl = encodeURIComponent(playStoreUrl);
  return "".concat(window.dxp.settings.cpCommonUrl, "/cp-client/html/cp_frontend_services/device_based_redirection.html") + "?appleUrl=".concat(encodedAppleStoreUrl, "&androidUrl=").concat(encodedPlayStoreUrl);
};
var getCurrentBrand = function getCurrentBrand() {
  return _.get(window.dxp, "settings.brand");
};
var getStoreUrls = function getStoreUrls(_ref2) {
  var playStoreNewUrl = _ref2.playStoreNewUrl,
    appleStoreNewUrl = _ref2.appleStoreNewUrl;
  var newPlayStoreUrl = playStoreNewUrl || FALLBACK_NEW_PLAY;
  var newAppleStoreUrl = appleStoreNewUrl || FALLBACK_NEW_APPLE;
  if (getCurrentBrand() && getCurrentBrand().toUpperCase() === BRAND.LEXUS) {
    newPlayStoreUrl = playStoreNewUrl || FALLBACK_LEXUS_NEW_PLAY;
    newAppleStoreUrl = appleStoreNewUrl || FALLBACK_LEXUS_NEW_APPLE;
  }
  return {
    playStoreUrl: newPlayStoreUrl,
    appleStoreUrl: newAppleStoreUrl
  };
};

var MyTappImageCta = function MyTappImageCta(_a) {
  var storeUrl = _a.storeUrl,
    imageUrl = _a.imageUrl,
    fallBackImageUrl = _a.fallBackImageUrl,
    type = _a.type,
    onClick = _a.onClick,
    props = __rest(_a, ["storeUrl", "imageUrl", "fallBackImageUrl", "type", "onClick"]);
  return /*#__PURE__*/React__default.createElement("a", Object.assign({
    className: styles$1.url,
    href: storeUrl,
    target: "_blank",
    rel: "noopener noreferrer",
    "data-test-id": "mt-t-app-cta-".concat(type),
    onClick: onClick
  }, props), /*#__PURE__*/React__default.createElement(Image$1, {
    className: styles$1.storeImage,
    alt: "MyTapp image cta",
    imageUrl: imageUrl,
    fallBackImageUrl: fallBackImageUrl
  }));
};

var MyTappLinks = function MyTappLinks(_ref) {
  var labels = _ref.labels,
    setAnalytics = _ref.setAnalytics,
    _ref$wrapperClassname = _ref.wrapperClassname,
    wrapperClassname = _ref$wrapperClassname === void 0 ? "" : _ref$wrapperClassname,
    _ref$storesClassname = _ref.storesClassname,
    storesClassname = _ref$storesClassname === void 0 ? "" : _ref$storesClassname,
    _ref$qrCodeClassName = _ref.qrCodeClassName,
    qrCodeClassName = _ref$qrCodeClassName === void 0 ? "" : _ref$qrCodeClassName;
  var _a, _b, _c, _d;
  var _getStoreUrls = getStoreUrls({
      playStoreNewUrl: labels.playStoreUrl,
      appleStoreNewUrl: labels.appleStoreUrl
    }),
    appleStoreUrl = _getStoreUrls.appleStoreUrl,
    playStoreUrl = _getStoreUrls.playStoreUrl;
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
    className: "cp-d-inline-flex ".concat(styles$1.wrapperAppLinks, " ").concat(wrapperClassname)
  }, /*#__PURE__*/React__default.createElement(QRCodeSVG, {
    className: qrCodeClassName ? "".concat(qrCodeClassName) : "".concat(styles$1.qr),
    size: 140,
    value: getRedirectionUrl({
      appleStoreUrl: appleStoreUrl,
      playStoreUrl: playStoreUrl
    })
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "".concat(styles$1.stores, " ").concat(storesClassname)
  }, /*#__PURE__*/React__default.createElement(MyTappImageCta, {
    fallBackImageUrl: "https://t1-cms-1.images.toyota-europe.com/toyotaone/euen/gplay_tcm-11-1802012.png",
    imageUrl: concat((_b = (_a = window === null || window === void 0 ? void 0 : window.T1) === null || _a === void 0 ? void 0 : _a.settings) === null || _b === void 0 ? void 0 : _b.cpCommonUrl, ASSETS.MY_T_APP_ANDROID),
    storeUrl: playStoreUrl,
    type: "play",
    onClick: function onClick() {
      return setAnalytics("android");
    },
    "aria-label": "Link to Google Play"
  }), /*#__PURE__*/React__default.createElement(MyTappImageCta, {
    fallBackImageUrl: "https://t1-cms-3.images.toyota-europe.com/toyotaone/euen/appstore_tcm-11-1802013.png",
    imageUrl: concat((_d = (_c = window === null || window === void 0 ? void 0 : window.T1) === null || _c === void 0 ? void 0 : _c.settings) === null || _d === void 0 ? void 0 : _d.cpCommonUrl, ASSETS.MY_T_APP_APPLE),
    storeUrl: appleStoreUrl,
    type: "apple",
    onClick: function onClick() {
      return setAnalytics("ios");
    },
    "aria-label": "Link to App Store"
  }))));
};

var css_248z = ".toyCo_MyTappOpenerCTA-qrSmall-10415042{height:150px;width:150px}.toyCo_MyTappOpenerCTA-qrMedium-10515042{height:250px;width:250px}.toyCo_MyTappOpenerCTA-qrLarge-10615042{height:400px;width:400px}.toyCo_MyTappOpenerCTA-materialBoxContent-10715042{display:flex;flex-direction:column;padding-left:15%;padding-right:15%;text-align:center;width:100%}.toyCo_MyTappOpenerCTA-qrCodeWrapper-10815042{display:flex;justify-content:center;width:100%}.toyCo_MyTappOpenerCTA-applicationCtaWrapper-10915042{display:flex;justify-content:center}.toyCo_MyTappOpenerCTA-materialBox-11015042{display:flex;justify-content:center;margin-top:20px;width:100%}@media (min-width:768px){.toyCo_MyTappOpenerCTA-materialBox-11015042{margin-top:0;width:70vw}}@media (min-width:992px){.toyCo_MyTappOpenerCTA-materialBox-11015042{margin-top:0;width:55vw}}@media (min-width:1440px){.toyCo_MyTappOpenerCTA-materialBox-11015042{margin-top:0;width:37vw}}.toyCo_MyTappOpenerCTA-title-11115042{margin-bottom:0;margin-top:10px}.toyCo_MyTappOpenerCTA-description-11215042{margin-bottom:35px}.toyCo_MyTappOpenerCTA-disclaimer-11315042{font-size:12px;margin-bottom:10px;margin-top:35px}.toyCo_MyTappOpenerCTA-materialBoxWrapper-11415042.active{height:100vh;margin:0;max-height:100%}@media (min-width:768px){.toyCo_MyTappOpenerCTA-materialBoxWrapper-11415042.active{height:auto}}.toyCo_MyTappOpenerCTA-materialBoxWrapper-11415042.active .material-box-content{justify-content:center}.toyCo_MyTappOpenerCTA-hiddenContainer-11515042{display:none!important;visibility:hidden}";
var styles = {"qrSmall":"toyCo_MyTappOpenerCTA-qrSmall-10415042","qrMedium":"toyCo_MyTappOpenerCTA-qrMedium-10515042","qrLarge":"toyCo_MyTappOpenerCTA-qrLarge-10615042","materialBoxContent":"toyCo_MyTappOpenerCTA-materialBoxContent-10715042","qrCodeWrapper":"toyCo_MyTappOpenerCTA-qrCodeWrapper-10815042","applicationCtaWrapper":"toyCo_MyTappOpenerCTA-applicationCtaWrapper-10915042","materialBox":"toyCo_MyTappOpenerCTA-materialBox-11015042","title":"toyCo_MyTappOpenerCTA-title-11115042","description":"toyCo_MyTappOpenerCTA-description-11215042","disclaimer":"toyCo_MyTappOpenerCTA-disclaimer-11315042","materialBoxWrapper":"toyCo_MyTappOpenerCTA-materialBoxWrapper-11415042","hiddenContainer":"toyCo_MyTappOpenerCTA-hiddenContainer-11515042"};
styleInject(css_248z);

var useIsMobile = function useIsMobile() {
  var _useState = useState(window.innerWidth <= 1100),
    _useState2 = _slicedToArray(_useState, 2),
    isMobile = _useState2[0],
    setIsMobile = _useState2[1];
  useEffect(function () {
    var handleResize = function handleResize() {
      return setIsMobile(window.innerWidth <= 1100);
    };
    window.addEventListener("resize", handleResize);
    return function () {
      return window.removeEventListener("resize", handleResize);
    };
  }, []);
  return isMobile;
};
var useOS = function useOS() {
  var _useState3 = useState("Unknown"),
    _useState4 = _slicedToArray(_useState3, 2),
    os = _useState4[0],
    setOS = _useState4[1];
  useEffect(function () {
    var userAgent = navigator.userAgent;
    if (/iPad|iPhone|iPod/.test(userAgent)) {
      setOS("iOS");
    } else if (/android/i.test(userAgent)) {
      setOS("Android");
    } else {
      setOS("Unknown");
    }
  }, []);
  return os;
};
var MyTappOpenerCTA = function MyTappOpenerCTA(_ref) {
  var labels = _ref.labels,
    _ref$qrCodeSize = _ref.qrCodeSize,
    qrCodeSize = _ref$qrCodeSize === void 0 ? 150 : _ref$qrCodeSize,
    setAnalytics = _ref.setAnalytics,
    _ref$ctaKind = _ref.ctaKind,
    ctaKind = _ref$ctaKind === void 0 ? "PRIMARY" : _ref$ctaKind;
  var _a, _b, _c, _d;
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    openMaterialBox = _useState6[0],
    setOpenMaterialBox = _useState6[1];
  var isMobile = useIsMobile();
  var oS = useOS();
  var _getStoreUrls = getStoreUrls({
      playStoreNewUrl: labels.playStoreUrl,
      appleStoreNewUrl: labels.appleStoreUrl
    }),
    appleStoreUrl = _getStoreUrls.appleStoreUrl,
    playStoreUrl = _getStoreUrls.playStoreUrl;
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Button, Object.assign({}, {
    kind: ctaKind,
    label: labels === null || labels === void 0 ? void 0 : labels.cta,
    testId: "cta-popup-mobile-application-v2",
    onClick: function onClick() {
      return setOpenMaterialBox(true);
    }
  }, {
    "aria-label": labels === null || labels === void 0 ? void 0 : labels.cta
  })), /*#__PURE__*/React__default.createElement("div", {
    className: styles.hiddenContainer
  }, /*#__PURE__*/React__default.createElement(MaterialBox, {
    id: "popupMobileApplicationV2",
    dataTestId: "popup-mobile-application-v2",
    show: openMaterialBox,
    onClose: function onClose() {
      return setOpenMaterialBox(false);
    },
    className: styles.materialBox,
    extraT1MaterialboxConfiguration: {
      styleClass: "".concat(styles.materialBoxWrapper)
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles.materialBoxContent
  }, /*#__PURE__*/React__default.createElement("p", null, labels === null || labels === void 0 ? void 0 : labels.appName), /*#__PURE__*/React__default.createElement("h1", {
    className: "".concat(styles.title, " cp-h3")
  }, labels === null || labels === void 0 ? void 0 : labels.title), /*#__PURE__*/React__default.createElement("p", {
    className: styles.description
  }, labels === null || labels === void 0 ? void 0 : labels.description), isMobile ? ( /*#__PURE__*/React__default.createElement("div", {
    className: styles.applicationCtaWrapper
  }, oS === "iOS" ? ( /*#__PURE__*/React__default.createElement(MyTappImageCta, {
    fallBackImageUrl: "https://t1-cms-3.images.toyota-europe.com/toyotaone/euen/appstore_tcm-11-1802013.png",
    imageUrl: concat((_b = (_a = window === null || window === void 0 ? void 0 : window.T1) === null || _a === void 0 ? void 0 : _a.settings) === null || _b === void 0 ? void 0 : _b.cpCommonUrl, ASSETS.MY_T_APP_APPLE),
    storeUrl: appleStoreUrl,
    type: "apple",
    onClick: function onClick() {
      return setAnalytics && setAnalytics("ios");
    }
  })) : ( /*#__PURE__*/React__default.createElement(MyTappImageCta, {
    fallBackImageUrl: "https://t1-cms-1.images.toyota-europe.com/toyotaone/euen/gplay_tcm-11-1802012.png",
    imageUrl: concat((_d = (_c = window === null || window === void 0 ? void 0 : window.T1) === null || _c === void 0 ? void 0 : _c.settings) === null || _d === void 0 ? void 0 : _d.cpCommonUrl, ASSETS.MY_T_APP_ANDROID),
    storeUrl: playStoreUrl,
    type: "play",
    onClick: function onClick() {
      return setAnalytics && setAnalytics("android");
    }
  })))) : ( /*#__PURE__*/React__default.createElement("div", {
    className: styles.qrCodeWrapper
  }, /*#__PURE__*/React__default.createElement(QRCodeSVG, {
    size: qrCodeSize,
    value: getRedirectionUrl({
      appleStoreUrl: appleStoreUrl,
      playStoreUrl: playStoreUrl
    })
  }))), /*#__PURE__*/React__default.createElement("p", {
    className: styles.disclaimer
  }, labels === null || labels === void 0 ? void 0 : labels.disclaimer)))));
};

/* eslint-disable no-restricted-syntax */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/**
 * @function monitorLoadingTime
 * @description Monitors the time between console.time and console.timeEnd if cpDebug is set to true(which is the
 * case once we add ?cp-debug=true in the URL)
 */
var monitorLoadingTime = function monitorLoadingTime(identifier) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var state = "idle";
  // @ts-ignore
  if (window.cpDebug && window["cpDebug".concat(identifier)] !== true) {
    if (options.shouldEnd) {
      state = "ended";
      console.log("%ccp-benchmark%c ".concat(identifier, " %celapsed time:"), "background-color: black; color: white; padding: 5px;font-size: 15px;", "color: red; font-size: 14px;", "color: blue; font-size: 14px;");
      console.timeEnd(identifier);
      if (options.runOnce) {
        // @ts-ignore
        window["cpDebug".concat(identifier)] = true;
      }
    } else {
      console.time(identifier);
      state = "started";
    }
  }
  return state;
};

/**
 * @module endpoint
 * @description Helpers to get endpoints that are often used by CP apps(aggregator, cp-client, los, ...)
 */
var replaceToRelativeProtocol = /^\s*(https?:)?\/\//;
var getDefaultAggregatorBaseUrl = function getDefaultAggregatorBaseUrl() {
  return _.get(window, "T1.settings.cpB2cAggrHost") && "https://".concat(_.get(window, "T1.settings.cpB2cAggrHost")) || isProduction() && contract.service.host.fallback.aggregatorProd || contract.service.host.fallback.aggregatorPrev;
};
/**
 * @function getToyotaClientBucketUrl
 * @description returns the client bucket URL(uses fallbacks depending on the value of the site setting)
 */
var getToyotaClientBucketUrl = function getToyotaClientBucketUrl() {
  return _.get(window, "T1.settings.clientBucket") || isProduction() && contract.service.host.fallback.clientBucketProd || contract.service.host.fallback.clientBucketPrev;
};
var getDefaultGatewayP0BaseUrl = function getDefaultGatewayP0BaseUrl() {
  return _.get(window, "T1.settings.c1SupraBaseUrl") || isProduction() && contract.service.host.fallback.gatewayP0ToyotaProd || contract.service.host.fallback.gatewayP0ToyotaPrev;
};
var getToyotaSSOBaseUrl = function getToyotaSSOBaseUrl() {
  return _.get(window, "T1.settings.ssoServiceUrl") || isProduction() && contract.service.host.fallback.ssoProd || contract.service.host.fallback.ssoPrev;
};
var getLexusSSOBaseUrl = function getLexusSSOBaseUrl() {
  return _.get(window, "L1.settings.ssoServiceUrl", "").replace(/\/\s*$/, "") || isProduction() && contract.service.host.fallback.ssoProd || contract.service.host.fallback.ssoPrev;
};
/**
 * @function getAggregatorBaseUrl
 * @description returns the aggregator base url whether the environment is L1 or DXP/T1
 * @returns {*}
 */
var getAggregatorBaseUrl = function getAggregatorBaseUrl() {
  return getDefaultAggregatorBaseUrl();
};
/**
 * @function getGatewayP0BaseUrl
 * @description returns the gatewayP0 base url whether the environment is L1 or DXP/T1
 * @returns {*}
 */
var getGatewayP0BaseUrl = function getGatewayP0BaseUrl() {
  return getDefaultGatewayP0BaseUrl();
};
/**
 * @function getLosBaseUrl
 * @description returns the LOS base url whether the environment is toyota or lexus
 * @returns {*}
 */
var getLosBaseUrl = function getLosBaseUrl() {
  var losHost = _.get(window, "".concat(isLexusBrand() ? "L1" : "T1", ".settings.losHost"));
  return losHost && "https://".concat(losHost.replace(replaceToRelativeProtocol, "")) || isProduction() && contract.service.host.fallback.losProd || contract.service.host.fallback.losPrev;
};
/**
 * @function getSSOBaseUrl
 * @description returns the sso base url whether the environment is toyota or lexus
 * @returns {*}
 */
var getSSOBaseUrl = function getSSOBaseUrl() {
  return isLexusBrand() ? getLexusSSOBaseUrl() : getToyotaSSOBaseUrl();
};

/**
 * @function isBzModel
 * @description returns true if the modelName is a BZ model
 */
function isBzModel(modelName) {
  var bzModels = [MODELS.BZ_4X.NAME];
  var _modelName = _typeof(modelName) === "string" && modelName.toLowerCase() || "";
  return !!bzModels.find(function (model) {
    return _modelName.includes(model);
  });
}
/**
 * @function cleanModelName
 * @description returns the model name where "toyota" or "lexus" is removed in-case-sensitively (ex: Toyota CH-R -> CH-R)
 */
function cleanModelName(value) {
  if (!value) {
    return "";
  }
  return value.replace(/toyota|lexus/gi, "").trim().replace(/\s+/g, " ");
}

/**
 * @module dealerfinder
 */
var injection = contract.event.publish.injection;
/**
 * @function injectDealerFinder
 * @description injects the dealerfinder V1 with a postal event supported on all envs(T1, dxp, L1)
 */
var injectDealerFinder = function injectDealerFinder(targetReference, preferredDealerId, extraOptions) {
  window.postal.publish(Object.assign(Object.assign({}, injection), {
    data: Object.assign(Object.assign({
      url: isDeployedInDxp() ? "/scripts/injection/dealerfinder.js" : concat(getToyotaClientBucketUrl(), "/scripts/injection/dealerfinder.js"),
      target: targetReference
    }, !!preferredDealerId && {
      preselect: {
        preferredDealer: true,
        dealerId: preferredDealerId
      }
    }), extraOptions)
  }));
};
/**
 * @function getOnlineRetailingDealerServices
 * @description get online retailing dealer services and adds some model specific services to it if necessary(eg: bzHub
 * for bz models)
 */
var getOnlineRetailingDealerServices = function getOnlineRetailingDealerServices(modelName) {
  var services = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _.get(window, "T1.settings.orCheckoutFilterByServices");
  var bzFilterServices = _.get(window, "T1.settings.orCheckoutFilterByBZ");
  if (!isBzModel(modelName) || !bzFilterServices) {
    return services;
  }
  return services && services.length ? services + ",".concat(bzFilterServices) : bzFilterServices;
};

/**
 * @module navigation
 * @description helpers related to the navigations of the site(getHeight, etc...) check useDxpNavigationChange for other
 * related navigation utility
 */
var dxpNavigationVisibility = contract.event.publish.dxpNavigationVisibility;
/**
 * @function getDxpNavHeight
 * @description get the dxp navigation height(pixel value) by requesting it to dxp with a postal event(the same source
 * of data is used when breakpoint changes and navigation shows/hide: main reason why we aren't using jquery or a
 * dom query to get the height)
 */
var getDxpNavHeight = function getDxpNavHeight() {
  var initialHeight;
  var subscription = window.postal.subscribe({
    topic: dxpNavigationVisibility.topic,
    channel: dxpNavigationVisibility.channel,
    callback: function callback(data) {
      initialHeight = data === null || data === void 0 ? void 0 : data.visibleHeaderHeight;
    }
  });
  window.postal.publish({
    topic: dxpNavigationVisibility.requestTopic,
    channel: dxpNavigationVisibility.channel
  });
  subscription.unsubscribe();
  return initialHeight;
};

/**
 * @module imagePath / CCIS
 */
/**
 * @function getCCISImageSrc
 * @description returns a CCIS image URL based on the params you pass to the function(config code, modelId, ...)
 */
function getCCISImageSrc(ccisParameters) {
  var _ref = ccisParameters || {},
    ConfigurationCode = _ref.ConfigurationCode,
    modelId = _ref.modelId,
    modelName = _ref.modelName,
    submodelId = _ref.submodelId,
    submodelName = _ref.submodelName,
    gradeId = _ref.gradeId,
    gradeName = _ref.gradeName,
    _ref$scaleMode = _ref.scaleMode,
    scaleMode = _ref$scaleMode === void 0 ? 1 : _ref$scaleMode,
    _ref$padding = _ref.padding,
    padding = _ref$padding === void 0 ? "0,0" : _ref$padding,
    _ref$colorCode = _ref.colorCode,
    colorCode = _ref$colorCode === void 0 ? "212" : _ref$colorCode,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? "340" : _ref$height,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? "770" : _ref$width,
    _ref$angle = _ref.angle,
    angle = _ref$angle === void 0 ? "04" : _ref$angle,
    _ref$view = _ref.view,
    view = _ref$view === void 0 ? "exterior" : _ref$view,
    _ref$extension = _ref.extension,
    extension = _ref$extension === void 0 ? ".png" : _ref$extension;
  var ccisBaseServer = _.get(window, "T1.settings.CCISServer");
  var ccisBaseHost = _.get(window, "T1.settings.CCISHost");
  var model = modelId || modelName;
  var submodel = submodelId || submodelName;
  var grade = gradeId || gradeName;
  if (ConfigurationCode) {
    return "".concat(ccisBaseServer, "/configuration/").concat(ConfigurationCode, "/width/").concat(width, "/height/").concat(height, "/").concat(view, "-").concat(angle).concat(extension);
  }
  if (model && submodel) {
    return "".concat(ccisBaseHost, "/").concat(model, "/").concat(submodel, "/").concat(grade ? "".concat(grade, "/") : "", "width/").concat(width, "/height/").concat(height, "/scale-mode/").concat(scaleMode, "/padding/").concat(padding, "/").concat(view, "-").concat(angle, "_").concat(colorCode).concat(extension);
  }
  return undefined;
}

/**
 * @function getWrappedLabel
 * @description Wraps a label with some opening and closing strings/characters
 * @param label {string}
 * @param {Object[]} options
 * @param {string} options[].openCharacter - opening character
 * @param {string} options[].closeCharacter - closing character
 */
var getWrappedLabel = function getWrappedLabel(label, options) {
  return "".concat((options === null || options === void 0 ? void 0 : options.openCharacter) || "").concat(label).concat((options === null || options === void 0 ? void 0 : options.closeCharacter) || "");
};
/**
 * @function wrapFallbackLabel
 * @description Wraps a label with the fallback format(eg: input: 'label' => output: '[label]'), the opening and closing
 * might change in the future(only reason why this function is being created)
 * @param label {string} - The label
 */
var wrapFallbackLabel = function wrapFallbackLabel(label) {
  return getWrappedLabel(label, {
    openCharacter: "[",
    closeCharacter: "]"
  });
};
/**
 * @function wrapFallbackLabelsRecursively
 * @description recursively adds brackets(or whatever wrapFallbackLabel uses to wrap labels), so if the object is
 * { mock: { mock: 'mock' } } it will become { mock: { mock: '[mock]' } }
 * @param item - Object containing labels and/or nested labels OR label itself
 */
/* eslint-disable @typescript-eslint/no-explicit-any */
var wrapFallbackLabelsRecursively = function wrapFallbackLabelsRecursively(item) {
  if (_.isPlainObject(item)) {
    return _.mapValues(item, wrapFallbackLabelsRecursively);
  } else {
    if (_typeof(item) === "boolean") {
      return item;
    } else {
      return wrapFallbackLabel(item);
    }
  }
};
/**
 * @function replacePlaceholders
 * @description replaces each placeholder specified in the placeHolders object parameter key by its value. E.G:
 * replacePlaceholders('This {{model}} is {{color}}', { model: 'yaris', color: 'blue' }, /{{\w+}}/g) will result in
 * 'This yaris is blue'. Note that by default the pattern is {{key}} so the "pattern" parameter is optional but could
 * potentially handle other types of placeholders.
 * @param label
 * @param placeHolders
 * @param pattern
 * @returns {string}
 */
var replacePlaceholders = function replacePlaceholders(label, placeHolders, pattern) {
  var regex = pattern || /{{\w+}}/g;
  return _.replace(label, regex, function (key) {
    return placeHolders[key] || key;
  });
};
/**
 * @function getCPLabels
 * @description retrieves AEM labels either from aggregator either from session storage if those were already
 * retrieved within the last 5 minutes
 * Useful to lazy load labels from SSO, this will avoid the dashboard child application from having a short delay
 * when fetching its labels and it won't impact SSO as the lazy load approach does it in the background
 * Also useful for CP applications that are hardly linked to each other, lazy loading them at front from one application
 * to another
 * @param path
 * @param storageKey
 * @param hostname
 * @kind SSO, Dashboard, Checkout, Online Reservation
 */
var getCPLabels = function getCPLabels(path, storageKey, hostname) {
  try {
    var sessionStorageLabels = JSON.parse(window.sessionStorage.getItem(storageKey) || "{}");
    if (_.isEmpty(sessionStorageLabels) || new Date(sessionStorageLabels.expirationDate) < new Date()) {
      return fetchLabels(path, storageKey, hostname);
    }
    return Promise.resolve(sessionStorageLabels);
  } catch (err) {
    return Promise.resolve(undefined);
  }
};
var fetchLabels = function fetchLabels(path, storageKey, hostname) {
  var url = concat(hostname || getAggregatorBaseUrl(), path);
  return window.fetch(url, {
    method: "GET",
    headers: new HeaderBuilder().addBrand().addLocale().build()
  }).then(function (response) {
    if (response.ok) {
      return response.json().then(function (labels) {
        window.sessionStorage.setItem(storageKey, JSON.stringify(Object.assign(Object.assign({}, labels), {
          expirationDate: new Date(Date.now() + STORAGE_LABELS.TTL_MILLISECONDS)
        })));
        return labels;
      });
    } else {
      logMessageOnDebugMode("Error while fetching the labels", "ERROR");
      return Promise.resolve(undefined);
    }
  })["catch"](function () {
    return Promise.resolve(undefined);
  });
};

/**
 * @function SetUpLeaveWarningBrowserPopup
 * @description useEffect that popups up a before unload browser message to indicate the user is about to leaver the
 * page
 * @param isEnabled
 * @param label
 */
var SetUpLeaveWarningBrowserPopup = function SetUpLeaveWarningBrowserPopup(isEnabled, label) {
  useEffect(function () {
    if (isEnabled) {
      var handleBeforeUnload = function handleBeforeUnload(event) {
        event.preventDefault();
        event.returnValue = "";
      };
      var handlePopstate = function handlePopstate() {
        var answer = window.confirm(label || "Are you sure?");
        if (answer) {
          window.history.back();
          window.removeEventListener("beforeunload", handleBeforeUnload);
          window.removeEventListener("popstate", handlePopstate);
        } else {
          window.history.pushState(null, "", window.location.pathname);
        }
      };
      window.addEventListener("beforeunload", handleBeforeUnload);
      window.addEventListener("popstate", handlePopstate);
      return function () {
        window.removeEventListener("beforeunload", handleBeforeUnload);
        window.removeEventListener("popstate", handlePopstate);
      };
    }
  }, [isEnabled, label]);
};

/**
 * @module leadDate
 * @description shortcuts for manipulating the lead data object with possible fallbacks and checks
 */
var CCSAVE_BASE = "ccsave";
var CONFIG = "".concat(CCSAVE_BASE, ".config");
var FULLCONFIG = "".concat(CCSAVE_BASE, ".fullconfig");
var PERSONAL_PARAMETERS = "".concat(CONFIG, ".Personal.Parameters");
var MAKOLAB = CHECKOUT_CONSTANTS.FINANCE_PROVIDER.MAKOLAB,
  _CHECKOUT_CONSTANTS$F = CHECKOUT_CONSTANTS.FINANCE_STATUS,
  PRE_APPROVED = _CHECKOUT_CONSTANTS$F.PRE_APPROVED,
  REFERRED = _CHECKOUT_CONSTANTS$F.REFERRED,
  LEASING = CHECKOUT_CONSTANTS.PAYMENT_METHOD.LEASING;
function getRetailerId(lead) {
  var publishingRetailerId = _.get(lead, "".concat(FULLCONFIG, ".publishingRetailer.retailerReference"), null);
  return isUsedCar(lead) && publishingRetailerId ? publishingRetailerId : _.get(lead, "".concat(CONFIG, ".RetailerID"));
}
function isTmefEnabled(lead) {
  return _.get(lead, "".concat(PERSONAL_PARAMETERS, ".TmefEnabled"));
}
function getCalculatedPrice(lead) {
  return _.get(lead, "".concat(FULLCONFIG, "[calculated-price]"));
}
function isUsedCar(lead) {
  return !!_.get(lead, "".concat(FULLCONFIG, ".UsedCarID"));
}
function getFinanceOption(lead) {
  return _.get(lead, "purchaseMethod", _.get(lead, "".concat(PERSONAL_PARAMETERS, ".FinanceOption")));
}
function getModel(lead) {
  return isUsedCar(lead) ? _.get(lead, "".concat(FULLCONFIG, ".productVersion.model.description")) : _.get(lead, "".concat(FULLCONFIG, ".car.model"));
}
function getModelCode(lead) {
  return _.get(lead, "".concat(FULLCONFIG, ".car.modelCode"));
}
function isLeasingOrder(lead) {
  var financeProductType = _.get(lead, "finance.productType.value") || "";
  return financeProductType.toLowerCase() === LEASING.toLowerCase();
}
var getLeadToyotaCode = function getLeadToyotaCode(lead) {
  return _.get(lead, "".concat(FULLCONFIG, ".code"));
};
var getLeadPersonalCode = function getLeadPersonalCode(lead) {
  return _.get(lead, "".concat(CONFIG, ".Personal.Code")) || _.get(lead, "".concat(FULLCONFIG, ".code"));
};
var getLeadBuildUrl = function getLeadBuildUrl(lead) {
  return _.get(lead, "".concat(FULLCONFIG, ".personal.url")) || _.get(lead, "".concat(FULLCONFIG, ".url"));
};
var isActiveBasketOrder = function isActiveBasketOrder(order) {
  var displayPreApprovedCars = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var orderId = _.get(order, "status.orderId");
  var financeProvider = _.get(order, "order.financeProvider", MAKOLAB);
  var financeStatus = _.get(order, "status.financeInitialStatus");
  var financeStatusPreApprovedOrReferred = financeStatus === PRE_APPROVED || financeStatus === REFERRED;
  var isFinanceProviderNotMakolab = financeProvider.toLowerCase() !== MAKOLAB;
  return !orderId || displayPreApprovedCars && isFinanceProviderNotMakolab && financeStatusPreApprovedOrReferred;
};
var getUsedCarProducts = function getUsedCarProducts(lead) {
  var packs = mapUsedCarPacks(lead);
  return {
    packs: packs,
    accessories: [],
    services: []
  };
};
/* eslint-disable max-lines-per-function */
var mapUsedCarPacks = function mapUsedCarPacks(lead) {
  var packsData = _.get(lead, "ccsave.fullconfig.extra-packs", []);
  var calculatedPrices = _.get(lead, "ccsave.fullconfig.calculated-price.Prices", []);
  if (packsData && packsData.length > 0) {
    return packsData.map(function (pack) {
      var priceData = _.get(pack, "prices[0]", {});
      var packId = _.get(pack, "localModelId", "");
      var today = new Date();
      var fromDate = new Date(priceData.fromDate);
      var toDate = new Date(priceData.toDate);
      if (today < fromDate || today > toDate || !priceData.price) {
        return;
      }
      var packPrices = calculatedPrices.find(function (price) {
        return price.ID === packId;
      });
      var packPriceInclVat = _.get(packPrices, "Values[0].Amount");
      return {
        id: packId,
        name: _.get(pack, "translations[0].localisedPbMarketingName", "Unknown Pack"),
        price: parseFloat(packPriceInclVat)
      };
    });
  }
  return [];
};

var CAR_TYPE_QUERY_STRING_PARAM = CHECKOUT_CONSTANTS.CAR_TYPE_QUERY_STRING_PARAM,
  CAR_TYPES = CHECKOUT_CONSTANTS.CAR_TYPES,
  _CHECKOUT_CONSTANTS$C = CHECKOUT_CONSTANTS.CAR_TYPES,
  NEW_CARS$1 = _CHECKOUT_CONSTANTS$C.NEW_CARS,
  USED_CARS$1 = _CHECKOUT_CONSTANTS$C.USED_CARS,
  STOCK_CARS = _CHECKOUT_CONSTANTS$C.STOCK_CARS,
  USED_ORDERED_CARS = _CHECKOUT_CONSTANTS$C.USED_ORDERED_CARS,
  STOCK_ORDERED_CARS = _CHECKOUT_CONSTANTS$C.STOCK_ORDERED_CARS;
/**
 * @function getCarTypeParam
 * @description gets the car type parameter from QS
 */
function getCarTypeParam() {
  if (isServerMode()) {
    return;
  }
  return new URLSearchParams(window && window.location.search).get(CAR_TYPE_QUERY_STRING_PARAM) || "";
}
/**
 * @function getCarType
 * @description determines the car type based on some QS param and uses new car as default
 */
function getCarType() {
  var carType = _.find(CAR_TYPES, function (type) {
    return _.toUpper(type).trim() === _.toUpper(getCarTypeParam()).trim();
  });
  return carType || NEW_CARS$1;
}
/**
 * @function isUsedCars
 * @description determines if the car is a used car based on some QS params OR a provided lead object
 */
function isUsedCars(lead) {
  return stringToBool(_.get(lead, "isUsedCar", false)) || getCarType() === USED_CARS$1 || _.get(lead, "typeOfOrder") === USED_ORDERED_CARS;
}
/**
 * @function isStockCars
 * @description determines if the car is a used car based on some QS params OR a provided lead object
 */
function isStockCars(lead) {
  return stringToBool(_.get(lead, "isStockCar", false)) || getCarType() === STOCK_CARS || _.get(lead, "typeOfOrder") === STOCK_ORDERED_CARS;
}
/**
 * @function isUsedOrStockCars
 * @description determines if the car is a used/stock car based on some QS params OR a provided lead object
 */
function isUsedOrStockCars(lead) {
  return isUsedCars(lead) || isStockCars(lead);
}
/**
 * @function isStockCarInHub
 * @description determines if the car is a stock car in hub based on the cartype QS and the lead data
 * (no dealer attached if in hub)
 */
function isStockCarInHub(lead) {
  return isStockCars() && !getRetailerId(lead);
}
/**
 * @function isNewCars
 * @description determines if the car is a new car by checking if it's neither a used nor stock car
 */
function isNewCars(lead) {
  return !isUsedOrStockCars(lead);
}

/**
 * @module checkout
 * @description checkout specific helper functions for reservation fees: used by checkout but also by
 * BE services and the dashboard
 */
var PAYMENT_METHOD$2 = CHECKOUT_CONSTANTS.PAYMENT_METHOD,
  RESERVATION_FEE_KEY = CHECKOUT_CONSTANTS.RESERVATION_FEE_KEY,
  _CHECKOUT_CONSTANTS$P$1 = CHECKOUT_CONSTANTS.PURCHASE_TYPE,
  BUY = _CHECKOUT_CONSTANTS$P$1.BUY,
  RESERVE = _CHECKOUT_CONSTANTS$P$1.RESERVE,
  ONLINE_RETAIL = _CHECKOUT_CONSTANTS$P$1.ONLINE_RETAIL;
/**
 * @function getReservationFee
 * @description getting the reservation fee value depending on the lead payload and some other options
 */
function getReservationFee(lead) {
  var reservationFees = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var isMonthlyReservation = arguments.length > 2 ? arguments[2] : undefined;
  var isReserveToBuyJourney = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var model = getModel(lead);
  var modelCode = getModelCode(lead);
  var financeOption = getFinanceOption(lead);
  if (isUsedCars(lead)) {
    return getReservationFeeValueUsedOrStockCars(lead);
  } else if (isStockCars(lead)) {
    return isTmefEnabled(lead) ? getReservationFeeValueUsedOrStockCars(lead) : false;
  } else {
    return getReservationFeeValueNewCars(lead, reservationFees, model, financeOption, Boolean(isMonthlyReservation), isReserveToBuyJourney, modelCode);
  }
}
/**
 *
 * @function getDefaultPurchaseType
 * @description returns the default Purchase type based on the vehicle type
 *
 */
var getDefaultPurchaseType = function getDefaultPurchaseType(lead, isMonthlyFinance) {
  return isUsedOrStockCars(lead) || !isMonthlyFinance ? RESERVE : BUY;
};
/**
 * @function getPurchaseType
 * @description Check the purchase type based on an attribute passed from the config or from the url query Params as fallback
 */
var getPurchaseType = function getPurchaseType(lead, checkoutParams) {
  var financeOption = getFinanceOption(lead),
    isMonthlyFinance = financeOption === PAYMENT_METHOD$2.MONTHLY;
  var purchaseType = _.get(lead, "purchaseType") || _.get(lead, "ccsave.config.Personal.Parameters.PurchaseType") || _.get(checkoutParams, "type", "");
  switch (purchaseType && purchaseType.toLowerCase()) {
    case BUY:
      return ONLINE_RETAIL;
    case RESERVE:
      return RESERVE;
    default:
      return getDefaultPurchaseType(lead, isMonthlyFinance);
  }
};
/**
 * @function isMonthlyReservation
 * @description Checking if a monthly flow is suppose to be reservation or not, reservation means no
 * finance application will be done during the purchase flow
 */
function isMonthlyReservation(lead, checkoutParams) {
  var financeOption = getFinanceOption(lead),
    isMonthlyFinance = financeOption === PAYMENT_METHOD$2.MONTHLY;
  var isMonthlyReservation = _.get(lead, "monthlyReservation") || _.get(lead, "order.isMonthlyReservation", false);
  return isMonthlyFinance && getPurchaseType(lead, checkoutParams) === RESERVE || !isUsedOrStockCars(lead) && isMonthlyReservation;
}
function getReservationFeeFromExtraCosts(prices) {
  var extraCosts = _.get(prices, "ExtraCosts", []),
    reservationFeeObj = extraCosts.find(function (cost) {
      return cost.Key === RESERVATION_FEE_KEY;
    });
  return _.get(reservationFeeObj, "Values[0].Amount");
}
function getReservationFeeFromAdditionalInfo(prices) {
  var additionalInfo = _.get(prices, "AdditionalInfo", []),
    reservationFeeObj = additionalInfo.find(function (info) {
      return info.Key === RESERVATION_FEE_KEY;
    });
  return _.get(reservationFeeObj, "Value");
}
function getReservationFeeValueUsedOrStockCars(lead) {
  var prices = getCalculatedPrice(lead);
  return getReservationFeeFromExtraCosts(prices) || getReservationFeeFromAdditionalInfo(prices);
}
function getFinanceOptionValue(isMonthlyReservation, lead, financeOption) {
  var financeOptionValue = isMonthlyReservation ? PAYMENT_METHOD$2.CASH : isLeasingOrder(lead) ? PAYMENT_METHOD$2.LEASING : financeOption;
  return financeOptionValue && financeOptionValue.toLowerCase();
}
/** This is used by isValidNewCarReservationFee */
var newCarReservationFeeHasMatchingModel = function newCarReservationFeeHasMatchingModel(reservationFeeRule, modelCode, model) {
  return _.isEmpty(reservationFeeRule.models) || reservationFeeRule.models.some(function (reservationFeeModel) {
    return modelCode && reservationFeeModel && reservationFeeModel.toLowerCase() === modelCode.toLowerCase() || model && reservationFeeModel && reservationFeeModel.toLowerCase() === model.toLowerCase();
  });
};
/** This is used by getReservationFeeValueNewCars */
var isValidNewCarReservationFee = function isValidNewCarReservationFee(lead, model, financeOption, isMonthlyReservation, isReserveToBuyJourney, modelCode) {
  return function (reservationFeeRule) {
    var hasMatchingFinanceOption = _.isEmpty(reservationFeeRule.financeOptions) || reservationFeeRule.financeOptions.map(function (financeOption) {
      return financeOption && financeOption.toLowerCase();
    }).includes(getFinanceOptionValue(isMonthlyReservation, lead, financeOption));
    var isApplicableToJourney = isReserveToBuyJourney && reservationFeeRule.applyReserveToBuy || !isReserveToBuyJourney;
    return newCarReservationFeeHasMatchingModel(reservationFeeRule, modelCode, model) && hasMatchingFinanceOption && isApplicableToJourney;
  };
};
function getReservationFeeValueNewCars(lead, reservationFees, model, financeOption, isMonthlyReservation, isReserveToBuyJourney, modelCode) {
  var foundReservationFee = reservationFees.find(isValidNewCarReservationFee(lead, model, financeOption, isMonthlyReservation, isReserveToBuyJourney, modelCode));
  return _.get(foundReservationFee, "amount", 0);
}

var PAYMENT_METHOD$1 = CHECKOUT_CONSTANTS.PAYMENT_METHOD,
  SERVICES = CHECKOUT_CONSTANTS.SERVICES;
function getPacksAndServicesFromServiceData(serviceData) {
  var _a, _b, _c, _d, _e, _f;
  var packIds = (_b = (_a = serviceData === null || serviceData === void 0 ? void 0 : serviceData.ccsave) === null || _a === void 0 ? void 0 : _a.config) === null || _b === void 0 ? void 0 : _b.Packs;
  var options = (_f = (_e = (_d = (_c = serviceData === null || serviceData === void 0 ? void 0 : serviceData.ccsave) === null || _c === void 0 ? void 0 : _c.fullconfig) === null || _d === void 0 ? void 0 : _d.car) === null || _e === void 0 ? void 0 : _e.equipment) === null || _f === void 0 ? void 0 : _f.packs;
  if (packIds && options) {
    return options.filter(function (item) {
      return packIds.find(function (pack) {
        return pack === _.get(item, "id");
      });
    });
  }
  return null;
}
function filterPacksOrServices(serviceData, filterOnServices) {
  var packs = getPacksAndServicesFromServiceData(serviceData);
  return packs && packs.filter(function (item) {
    var matchingServices = SERVICES.find(function (service) {
      return item.internalCode && item.internalCode.toUpperCase().includes(service);
    });
    return filterOnServices ? matchingServices : !matchingServices;
  });
}
function getSelectedServices(serviceData) {
  var carServices = _.get(serviceData, "ccsave.fullconfig.car.equipment.services", []),
    serviceProducts = _.get(serviceData, "ccsave.config.ServiceProducts", []);
  return carServices.filter(function (carService) {
    return serviceProducts.some(function (serviceProduct) {
      return serviceProduct === carService.id;
    });
  });
}
function getServicesFromServiceData(serviceData) {
  var services = [];
  var filteredServicesFromPacks = filterPacksOrServices(serviceData, true);
  var equipmentServices = getSelectedServices(serviceData);
  filteredServicesFromPacks && filteredServicesFromPacks.length && services.push.apply(services, _toConsumableArray(filteredServicesFromPacks));
  equipmentServices && equipmentServices.length && services.push.apply(services, _toConsumableArray(equipmentServices));
  return services.length ? services : null;
}
function getOrderExpiryDate(lead, labels, isMonthlyReservation) {
  var financeOption = _.get(lead, "ccsave.config.Personal.Parameters.FinanceOption");
  var nbrExpiryDays = _.get(lead, "order.nbrExpiryDays");
  var isTranslatedContent = !!_.get(labels, "completeOrder.successTextExpiryDate") && !!nbrExpiryDays;
  if ((isMonthlyReservation || financeOption === "cash") && isTranslatedContent) {
    var orderDate = _.get(lead, "status.orderDate");
    var tempDate = new Date(orderDate);
    tempDate.setDate(tempDate.getDate() + nbrExpiryDays);
    var formattedDate = tempDate.toLocaleDateString("en-GB").replace(/\//g, "-");
    return _.get(labels, "completeOrder.successTextExpiryDate", "").replace("{validDate}", formattedDate);
  }
  return null;
}
function getConfirmationText(lead, financeOption, labels, checkoutParams, orderDate) {
  var confirmationText = (financeOption === PAYMENT_METHOD$1.MONTHLY && !isMonthlyReservation(lead, checkoutParams) && _.get(labels, "completeOrder.monthly.successText") || _.get(labels, "completeOrder.successText", TRIDION_LABEL_MISSING)).replace("{orderNumber}", _.get(lead, "status.orderId")).replace("{name}", _.get(lead, "order.customerProfile.firstName")).replace("{dealerName}", _.get(lead, "order.selectedDealer.name")).replace("{orderDate}", orderDate);
  var expiryTextForReservation = getOrderExpiryDate(lead, labels, !isMonthlyReservation(lead, checkoutParams));
  return expiryTextForReservation ? confirmationText.concat(expiryTextForReservation) : confirmationText;
}
function buildDeliveryTextForModelSection(deliveryWeekLabel, deliveryOneWeekLabel, minAmoutOfWeeks) {
  if (minAmoutOfWeeks) {
    if (minAmoutOfWeeks === 1 && deliveryOneWeekLabel) {
      return deliveryOneWeekLabel.replace("{deliveryTime}", minAmoutOfWeeks.toString());
    }
    if (minAmoutOfWeeks > 1 && deliveryWeekLabel) {
      return deliveryWeekLabel.replace("{deliveryTime}", minAmoutOfWeeks.toString());
    }
  }
  return "";
}

var PAYMENT_METHOD = CHECKOUT_CONSTANTS.PAYMENT_METHOD;
function getMonthlyBuyLabels(labels, financeOption, isMonthlyReservation) {
  var isMonthlyFinance = financeOption === PAYMENT_METHOD.MONTHLY;
  var isMonthlyBuy = !isMonthlyReservation && isMonthlyFinance;
  var monthlyLabels = financeOption && _.get(labels, financeOption);
  return isMonthlyBuy && !_.isEmpty(monthlyLabels) && monthlyLabels;
}
function mergeStepLabels(guestStepsLabels, stepsLabels) {
  return [guestStepsLabels].concat(_toConsumableArray(stepsLabels));
}
function mergeTruthyValues() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  var arg1 = args[0],
    arg2 = args[1],
    restArgs = args.slice(2);
  var mergedLabels = _.merge(arg1, _.omitBy(arg2, _.isEmpty));
  return restArgs.length > 0 ? mergeTruthyValues.apply(void 0, [mergedLabels].concat(_toConsumableArray(restArgs))) : mergedLabels;
}
function getMergedGuestWithItemsLabels(labels, allowGuestUserFlow, stepsLabels) {
  var guestLabels = _.get(labels, "guest", {});
  var guestStepsLabels = {
    title: _.get(guestLabels, "title"),
    description: _.get(guestLabels, "description"),
    icon: "icon-svg icon-account",
    button: _.get(guestLabels, "register")
  };
  return allowGuestUserFlow && !getUserToken() && mergeStepLabels(guestStepsLabels, stepsLabels);
}
var replaceIconsByCpOnes = function replaceIconsByCpOnes(activeSteps) {
  return _.map(activeSteps, function (step) {
    switch (step.icon) {
      case "icon-account":
        step.icon = "dxp-icon icon-Profile-medium";
        break;
      case "icon-mail":
        step.icon = "dxp-icon icon-Newsletter_Email-medium";
        break;
      case "icon-category":
        step.icon = "dxp-icon icon-Reserve-medium";
        break;
      case "icon-file":
        step.icon = "dxp-icon icon-Balance-medium";
        break;
      case "icon-fleet":
        step.icon = "dxp-icon icon-Accelerations-medium";
        break;
      case "icon-dealer":
        step.icon = "dxp-icon icon-Profile-medium";
        break;
      case "icon-online":
        step.icon = "dxp-icon icon-Website-medium";
        break;
      case "icon-popular":
        step.icon = "dxp-icon icon-Customer_Loyalty-medium";
        break;
    }
    return step;
  });
};
function getCheckoutNextSteps(selectedVehicle, steps, financeOption, isMonthlyReservation, allowGuestUserFlow, shouldReplaecT1Icons) {
  var isMonthlyBuy = financeOption === "monthly" && !isMonthlyReservation;
  var usedCarNextStepsLabels = _.get(steps, "usedCars", []);
  var nextStepsLabels = isUsedCars(selectedVehicle) && !_.isEmpty(usedCarNextStepsLabels) ? usedCarNextStepsLabels : _.get(steps, "items", []);
  var montlhyBuyLabels = getMonthlyBuyLabels(steps, financeOption, isMonthlyReservation);
  var activeSteps = getMergedGuestWithItemsLabels(steps, allowGuestUserFlow, nextStepsLabels) || isMonthlyBuy && mergeTruthyValues({}, _.get(steps, "items", []), montlhyBuyLabels) || nextStepsLabels;
  shouldReplaecT1Icons && replaceIconsByCpOnes(activeSteps);
  return activeSteps;
}

/**
 * @function isLightColor
 * @description returns true if the color passed is light, false if the color passed is dark,
 * handy to determine whether text on a background color should be white or black
 * @param color - can be an array [45, 45, 45] a hexadecimal string '#282830' or an rgb string 'rgb(190,190,190)'
 * @param threshold - threshold to determine if the color is light or not(127.5 by default)
 */
// eslint-disable-next-line max-lines-per-function
var isLightColor = function isLightColor(color) {
  var threshold = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 127.5;
  var result;
  var colorAsArray = color;
  var colorAsString = color;
  if (Array.isArray(color)) {
    result = {
      r: _.nth(colorAsArray, 0) || 0,
      g: _.nth(colorAsArray, 1) || 0,
      b: _.nth(colorAsArray, 2) || 0
    };
  } else if (colorAsString.match(/^rgba?/)) {
    result = rgbaToRgb(color);
  } else if (colorAsString.match(/^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i)) {
    result = hexToRgb(color);
  } else {
    color = +("0x" + colorAsString.slice(1)
    // @ts-ignore
    .replace(colorAsString.length < 5 && /./g, "$&$&"));
    result = {
      r: color >> 16,
      g: color >> 8 & 255,
      b: color & 255
    };
  }
  var hsp = Math.sqrt(0.299 * (result.r * result.r) + 0.587 * (result.g * result.g) + 0.114 * (result.b * result.b));
  return hsp > threshold;
};
var rgbaToRgb = function rgbaToRgb(color) {
  var result = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/);
  return {
    r: _.nth(result, 1) || 0,
    g: _.nth(result, 2) || 0,
    b: _.nth(result, 3) || 0
  };
};
var hexToRgb = function hexToRgb(color) {
  return {
    r: parseInt(color.slice(1, 3), 16),
    g: parseInt(color.slice(3, 5), 16),
    b: parseInt(color.slice(5, 7), 16)
  };
};

/**
 * @function isEdgeBrowser
 * @description determines whether or not the browser is Edge
 */
var isEdgeBrowser = function isEdgeBrowser() {
  var agent = _.get(window, "navigator.userAgent", "").toLowerCase();
  var isEdgeInAgentData = _.get(window, "navigator.userAgentData.brands", []).some(function (item) {
    return _.get(item, "brand") === "Microsoft Edge";
  });
  return /edg(e)?/.test(agent) || isEdgeInAgentData;
};

/**
 * @function formatAddress
 * @description formats the address of a dealer
 * @param addressLine1 - first part of the dealer address
 * @param addressLine2 - second part of the address
 * @param city - dealer city
 * @param postcode - dealer postal code
 */
var formatAddress = function formatAddress(addressLine1, addressLine2, city, postcode) {
  var addressItems = _.filter([addressLine1, addressLine2, city, postcode], function (item) {
    return !!item;
  });
  return _.join(addressItems, ", ");
};

/**
 * @module page_redirection
 */
/**
 * @function handleRedirection
 * @description handles the redirection to Toyota's home page If the current page was navigated from any Toyota pages;
 * otherwise, return to the origin.
 * @returns {void}
 */
var handleRedirection = function handleRedirection() {
  var hostName = window.location.hostname;
  var isLinkedFromToyotaPages = document.referrer.includes(hostName);
  if (isLinkedFromToyotaPages) {
    window.history.back();
  } else {
    window.location.href = encodeURI(window.location.origin);
  }
};

/**
 * @module taxation
 */
var _CHECKOUT_CONSTANTS$P = CHECKOUT_CONSTANTS.PAYMENT_METHOD,
  CASH = _CHECKOUT_CONSTANTS$P.CASH,
  MONTHLY = _CHECKOUT_CONSTANTS$P.MONTHLY;
/**
 * @function shouldDisplayTaxation
 * @description validate if the car taxation data should be displayed
 */
var shouldDisplayTaxation = function shouldDisplayTaxation(settings, financeOption, isMonthlyReservation, taxationBasketContent, taxationBasket) {
  if (!(taxationBasketContent === null || taxationBasketContent === void 0 ? void 0 : taxationBasketContent.length) || _.isEmpty(taxationBasket)) {
    return false;
  }
  switch (financeOption) {
    case MONTHLY:
      return !stringToBool(_.get(settings, isMonthlyReservation ? "hideOnReservationMonthly" : "hideOnBuyMonthly", false));
    case CASH:
      return !stringToBool(_.get(settings, "hideOnReservationCash", false));
    default:
      return false;
  }
};
/**
 * @function normalizeExtraCosts
 * @description filtering extra costs from ExtraCosts and AdditionalInfo fields from used cars to be displayed on checkout and dashboard
 */
var normalizeExtraCosts = function normalizeExtraCosts(calculatedPrice) {
  var extraCosts = _.get(calculatedPrice, "ExtraCosts"),
    additionaInfo = _.get(calculatedPrice, "AdditionalInfo");
  if (Array.isArray(extraCosts)) {
    return extraCosts.map(function (extraCost) {
      return {
        Key: _.get(extraCost, "Key"),
        Value: _.get(extraCost, "Values.0.Amount")
      };
    });
  }
  return additionaInfo;
};

/**
 * @module price
 * @description helpers related to prices: for formatting prices check dataFormattingHelper
 */
/**
 * @function shouldDisplayPriceElement
 * @description validate if the car price should be displayed based on its valid value or nmsc setting
 * @param showIfZero configuration set by nmsc
 * @param price
 */
function shouldDisplayPriceElement(showIfZero, price) {
  var priceIsZero = Number(price) === 0 && price !== null;
  if (Boolean(showIfZero) && priceIsZero) {
    return true;
  } else if (price && !priceIsZero) {
    return true;
  } else {
    return false;
  }
}

/**
 * @module image
 */
/**
 * @function isImageCached
 * @description (deprecated: doesn't work well in modern browsers where memory and disk cache work differently... use
 * img onload to check this: only memory caching is handled here...)
 * returns true|false if an image is already cached by the browser. Useful when you want to animate an
 * image when it loads and not if it is already loaded/cached.
 */
var isImageCached = function isImageCached(src) {
  var img = new Image();
  img.src = src;
  var complete = img.complete;
  img.src = "";
  return complete;
};

/**
 * @function formatPriceValue
 * @description returns the price value together with the currency based on the country
 */
function formatPriceValue(price, cultureName) {
  var globalize = getGlobalizeInstance();
  if (globalize.cultures && isValidPriceParam(price)) {
    var cultureIdentifier = cultureName || getCultureIdentifier();
    return globalize.format(price, "c", cultureIdentifier);
  }
  return null;
}
/**
 * @function isFormattedPrice
 * @description returns true/false
 */
function isFormattedPrice(price) {
  var globalize = getGlobalizeInstance();
  var cultures = _.get(globalize, "cultures");
  var cultureData = _.get(cultures, getCultureIdentifier(), globalize.cultures["default"]);
  var currencySymbol = _.get(cultureData, "numberFormat.currency.symbol");
  var trimmedCurrencySymbol = currencySymbol.replace(".", "");
  return _typeof(price) === "string" && price.includes(trimmedCurrencySymbol);
}
var getGlobalizeInstance = function getGlobalizeInstance() {
  return window.globalize || window.Globalize;
}; // Lexus has Globalize in camel case
/**
 * @function getCalculatedSecondaryPrice
 * @description returns the secondary price value together with the currency based on the country. If you want the
 * calculated value to be raw then pass isRaw =  true; as parameter after price
 * @param price
 * @param isRaw
 * @returns {string|null|number}
 */
function getCalculatedSecondaryPrice(price) {
  var isRaw = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var globalize = getGlobalizeInstance();
  var secondaryCulture = _.get(globalize, "cultures.secondary");
  var currencyMultiplier = _.get(window, "dxp.settings.flexibility.currencyMultiplier");
  if (secondaryCulture && currencyMultiplier && isValidPriceParam(price)) {
    var calculatedPrice = price * currencyMultiplier;
    var cultureName = _.get(secondaryCulture, "name");
    return isRaw ? calculatedPrice : formatPriceValue(calculatedPrice, cultureName);
  }
  return null;
}
/**
 * @function isValidPriceParam
 * @description returns true if the price is valid
 */
function isValidPriceParam(price) {
  return _typeof(price) === "number" && !isNaN(price);
}
/**
 * @function formatInsuranceData
 * @description returns the insurance data with the required format by the Front end
 */
function formatInsuranceData() {
  var insuranceData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var insuranceLabels = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var isUsedCar = arguments.length > 2 ? arguments[2] : undefined;
  var toReturn = {};
  insuranceLabels && insuranceLabels.forEach(function (insuranceItem) {
    var key = insuranceItem.key,
      format = insuranceItem.format;
    var value = isUsedCar ? format === "Price" ? formatPriceValue(insuranceData[key]) : insuranceData[key] : format === "Price" ? _.get(insuranceData[key], "formatted") : _.get(insuranceData[key], "value") || insuranceData[key];
    Object.assign(toReturn, _defineProperty({}, key, value));
  });
  return toReturn;
}
/**
 * @function getCombinedDualCurrencyPrices
 * @description returns the price with second price formatted if there is second price else it returns only the price
 * @param price
 * @return {string|null}
 */
function getCombinedDualCurrencyPrices(price) {
  var firstPrice = formatPriceValue(price);
  var secondPrice = getCalculatedSecondaryPrice(price, false);
  if (secondPrice) {
    return "".concat(firstPrice, " - ").concat(secondPrice);
  }
  return firstPrice;
}
var formatDealerAddress = function formatDealerAddress(dealerDetails) {
  var _a, _b;
  var name = (dealerDetails === null || dealerDetails === void 0 ? void 0 : dealerDetails.name) || "";
  var address = ((_a = dealerDetails === null || dealerDetails === void 0 ? void 0 : dealerDetails.address) === null || _a === void 0 ? void 0 : _a.address) || "";
  var address1 = ((_b = dealerDetails === null || dealerDetails === void 0 ? void 0 : dealerDetails.address) === null || _b === void 0 ? void 0 : _b.address1) || "";
  if (name && address) {
    return "".concat(name, ", ").concat(address, " ").concat(address1);
  }
  return "";
};
var formatDealerCity = function formatDealerCity(dealerDetails) {
  var _a, _b;
  var city = ((_a = dealerDetails === null || dealerDetails === void 0 ? void 0 : dealerDetails.address) === null || _a === void 0 ? void 0 : _a.city) || "";
  var zip = ((_b = dealerDetails === null || dealerDetails === void 0 ? void 0 : dealerDetails.address) === null || _b === void 0 ? void 0 : _b.zip) || "";
  if (city && zip) {
    return "".concat(city.toUpperCase(), ", ").concat(zip);
  } else if (city) {
    return city.toUpperCase();
  } else if (zip) {
    return zip;
  }
  return "";
};

/**
 * @function getCssVarValue
 * @description gets the css variable value from the root or any dom element you pass to the element parameter
 */
/* istanbul ignore next */
var getCssVarValue = function getCssVarValue(name, element) {
  return window.getComputedStyle(element || document.documentElement).getPropertyValue(name);
};

var ECOLABELCONSTANTS = {
  PATHS: {
    LEAD: {
      USED_CARS: {
        RATING: "ccsave.fullconfig.productVersion.emission.efficiencyClass.code",
        BASE: "ccsave.fullconfig.productVersion.emission.co2Emission",
        UNIT: "unit.description",
        VALUE: "value"
      },
      NEW_CARS: {
        RATING: "ccsave.fullconfig.energy.value",
        BASE: "ccsave.fullconfig.energy.specs",
        UNIT: "unit",
        VALUE: "value",
        CODE: "CO2COMBINEDWLTP"
      }
    }
  },
  VALID_RATINGS: ["A", "B", "C", "D", "E", "F", "G"]
};

/**
 * @module EcoLabel
 */
var _ECOLABELCONSTANTS$PA = ECOLABELCONSTANTS.PATHS.LEAD,
  USED_CARS = _ECOLABELCONSTANTS$PA.USED_CARS,
  NEW_CARS = _ECOLABELCONSTANTS$PA.NEW_CARS,
  VALID_RATINGS = ECOLABELCONSTANTS.VALID_RATINGS;
/**
 * @typedef EcoLabel
 * @property {string} letter - Letter ranging from A-G
 * @property {string} label - Actual emission value e.g. 100 g/km
 *
 * @function getEcoLabelValuesFromLead
 * @description Normalize lead data structure for ecolabels. Provides the necessary values for DxpEcoLabel component
 */
var getEcoLabelValuesFromLead = function getEcoLabelValuesFromLead(lead) {
  var isUsedCarLead = isUsedCar(lead);
  var basePath = isUsedCarLead ? USED_CARS.BASE : NEW_CARS.BASE;
  var unitPath = isUsedCarLead ? USED_CARS.UNIT : NEW_CARS.UNIT;
  var valuePath = isUsedCarLead ? USED_CARS.VALUE : NEW_CARS.VALUE;
  var ratingPath = isUsedCarLead ? USED_CARS.RATING : NEW_CARS.RATING;
  var specification = _.find(_.get(lead, basePath, []), function (item) {
    return isUsedCarLead || item.code === NEW_CARS.CODE ? item : null;
  });
  var co2EmissionValue = _.get(specification, valuePath, "");
  var co2EmissionUnit = _.get(specification, unitPath, "");
  return {
    letter: _.get(lead, ratingPath, undefined),
    label: "".concat(co2EmissionValue).concat(co2EmissionUnit)
  };
};
/**
 * @function hasValidEcoLabelRating
 * @description Check if eco label code is valid.
 * @returns {boolean}
 */
var hasValidEcoLabelRating = function hasValidEcoLabelRating(rating) {
  return _.includes(VALID_RATINGS, rating);
};

/**
 * @function formatDualCurrencyFinancePrice
 * @description returns the full dual currency price formatted
 * @param value
 * @param financeKey
 * @return {string|null}
 */
function formatDualCurrencyFinancePrice(value, formatted) {
  var shouldShowSecondary = isFormattedPrice(formatted);
  return shouldShowSecondary ? getCombinedDualCurrencyPrices(value) : formatted;
}

/* eslint-enable @typescript-eslint/no-explicit-any */
var getWrapFallbackLabels = function getWrapFallbackLabels(fallbackLabels) {
  return _.isPlainObject(fallbackLabels) ? wrapFallbackLabelsRecursively(fallbackLabels) : {};
};
var getFallbackLabels = function getFallbackLabels(fallbackLabels, wrappedFallbackLabels, options) {
  var shouldUseFallbackLabels = (options === null || options === void 0 ? void 0 : options.useFallbacks) !== false;
  var shouldUseWrappedFallbackLabels = (options === null || options === void 0 ? void 0 : options.useWrappedFallbacks) !== false;
  var processedFallbackLabels = shouldUseWrappedFallbackLabels ? wrappedFallbackLabels : fallbackLabels;
  return shouldUseFallbackLabels ? processedFallbackLabels : {};
};

/**
 * @module hooks__labels
 */
/* eslint-enable @typescript-eslint/no-explicit-any */
/**
 * @function createUseLabelsFromStore
 * @description Creates a useLabels hook(const useLabels = createUseLabelsHook();) that you can then use as a hook. The
 * useLabels hook when executed will combine labels from your store and a fallback label object you provide to
 * the function. By default the labels will be processed and wrapped(in brackets). You can then pass an option to your
 * useLabels hook to disable fallback labels if necessary(e.g: useLabels({ useFallbacks: false }, store)) and also
 * disable the wrapping applied to the fallbacks(e.g: useLabels({ useWrappedFallbacks: false })). A wise choice when
 * accessing labels that are deeply nested is to use lodash _.get or optional chaining.
 */
var createUseLabelsHookFromStore = function createUseLabelsHookFromStore(fallbackLabels, path) {
  var wrappedFallbackLabels = getWrapFallbackLabels(fallbackLabels);
  return function (options, store) {
    var labelsFromStore = _.get(store, path);
    return _.merge(getFallbackLabels(fallbackLabels, wrappedFallbackLabels, options), labelsFromStore);
  };
};

/**
 * @module hooks__labelsRedux
 */
/**
 * @function createUseLabelsHook
 * @description Creates a useLabels hook(const useLabels = createUseLabelsHook();) that you can then use as a hook. The
 * useLabels hook when executed will combine labels from your REDUX store and a fallback label object you provide to
 * the function. By default, the labels will be processed and wrapped(in brackets). You can then pass an option to your
 * useLabels hook to disable fallback labels if necessary(e.g: useLabels({ useFallbacks: false })) and also disable
 * the wrapping applied to the fallbacks(e.g: useLabels({ useWrappedFallbacks: false })). A wise choice when accessing
 * labels that are deeply nested is to use lodash _.get or optional chaining.
 * @param fallbackLabels {object} -
 */
var createUseLabelsHook = function createUseLabelsHook(fallbackLabels, path) {
  var wrappedFallbackLabels = getWrapFallbackLabels(fallbackLabels);
  return function (options) {
    var labelsFromStore = useSelector(function (state) {
      return _.get(state, path);
    });
    return _.merge(getFallbackLabels(fallbackLabels, wrappedFallbackLabels, options), labelsFromStore);
  };
};

/* eslint-disable max-lines-per-function */
/**
 * @function useIsElementOnScreen
 * @description returns an object with the isElementOnScreen flag indicating if the element is in the viewport... If the
 * feature isn't supported by the browser, the result property shouldGracefullyDegrade will be set to true. There is also
 * a count exposed by the hook indicating whether or not the element already appeared on screen in the past:
 * 'onScreenCount'
 */
var useIsElementOnScreen = function useIsElementOnScreen(ref) {
  var rootMargin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "0px";
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isElementOnScreen = _useState2[0],
    setIsElementOnScreen = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    onScreenCount = _useState4[0],
    setOnScreenCount = _useState4[1];
  var shouldGracefullyDegrade = !window.IntersectionObserver;
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  useEffect(function () {
    if (!shouldGracefullyDegrade) {
      var domElement = ref === null || ref === void 0 ? void 0 : ref.current;
      /* istanbul ignore next */
      var observer = new window.IntersectionObserver(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 1),
          entry = _ref2[0];
        var isIntersecting = !!(entry === null || entry === void 0 ? void 0 : entry.isIntersecting);
        if (isElementOnScreen !== isIntersecting) {
          setIsElementOnScreen(isIntersecting);
          isIntersecting && setOnScreenCount(onScreenCount + 1);
        }
      }, {
        rootMargin: rootMargin
      });
      if (domElement) {
        observer.observe(domElement);
      }
      return function () {
        return domElement ? observer.unobserve(domElement) : null;
      };
    }
  }, [ref, rootMargin, onScreenCount, isElementOnScreen, shouldGracefullyDegrade]);
  return {
    isElementOnScreen: isElementOnScreen,
    shouldGracefullyDegrade: shouldGracefullyDegrade,
    onScreenCount: onScreenCount
  };
};
/* eslint-enable max-lines-per-function */

var visibilityChangeCallback = function visibilityChangeCallback(data, isHiddenState, setIsHidden, heightState, setHeight, setHeightWhenVisible) {
  var isNavNowHidden = Boolean(data === null || data === void 0 ? void 0 : data.isNavHidden);
  if (isHiddenState !== isNavNowHidden || heightState !== (data === null || data === void 0 ? void 0 : data.visibleHeaderHeight)) {
    setIsHidden(isNavNowHidden);
    setHeight(data === null || data === void 0 ? void 0 : data.visibleHeaderHeight);
    if (!isNavNowHidden) {
      setHeightWhenVisible(data === null || data === void 0 ? void 0 : data.visibleHeaderHeight);
    }
  }
};
/**
 * @function useDxpNavigationChange
 * @description returns data related to the dxp navigation inside an object: { isHidden, height }.
 * Useful when you have to know whether or not the navigation is hidden/visible. The height of the navigation is also
 * exposed and adapts each time the navigation collapses or the breakpoint changes.
 */
/* istanbul ignore next */
var useDxpNavigationChange = function useDxpNavigationChange() {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isHidden = _useState2[0],
    setIsHidden = _useState2[1];
  var _useState3 = useState(function () {
      return getDxpNavHeight();
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    height = _useState4[0],
    setHeight = _useState4[1];
  var _useState5 = useState(function () {
      return getDxpNavHeight();
    }),
    _useState6 = _slicedToArray(_useState5, 2),
    heightWhenVisible = _useState6[0],
    setHeightWhenVisible = _useState6[1];
  useEffect(function () {
    var subscription = window.postal.subscribe({
      channel: contract.event.publish.dxpNavigationVisibility.channel,
      topic: contract.event.publish.dxpNavigationVisibility.topic,
      callback: function callback(data) {
        return visibilityChangeCallback(data, isHidden, setIsHidden, height, setHeight, setHeightWhenVisible);
      }
    });
    return function () {
      subscription.unsubscribe();
    };
  }, [isHidden, setIsHidden, height]);
  return {
    isHidden: isHidden,
    height: height,
    heightWhenVisible: heightWhenVisible
  };
};

// leave serverCompatibilityDeps at the very top so that it's self executed
var COMMON_CONSTANTS = _COMMON_CONSTANTS;
var url = _url;
var dynatrace = _dynatrace;

export { Accordion, BUTTON_KINDS, BackgroundImage, Button, CAROUSEL_CONSTANTS, CHECKOUT_CONSTANTS, COMMON_CONSTANTS, Card, Carousel, Checkbox, Collapsible, CollapsibleBase, CollapsibleContainer, CommunicationPreferences, ControlledCarousel, CpClient, DealerFinder, Dropdown, EcoEmissionLabels, ExternalLink, FormProgressViewer, GoBack, HeaderBuilder, ICON_KINDS, INPUT_TYPES, Icon, Image$1 as Image, ImageResponsive, Input, InputErrorMessage, InputLabel, InputTel, InputWrapper, Loader, MandatorySign, MaterialBox, MyTappImageCta, MyTappLinks, MyTappOpenerCTA, Navigation, NavigationArray, NextSteps, OverflowableRow, POPOVER_ICON_KINDS, POPOVER_KINDS, Popover, ProcessNavigation, ProcessNavigationUi, ProgressCarousel, RadioButton, ReadMore, ReadMoreText, ScrollToAnchor, SectionErrorBoundary, SetUpLeaveWarningBrowserPopup, ShowMoreDropdown, ShowMoreDropdownItem, StepMobileFooter, StepsProgressBar, StickyCollapsibleFooter, T1Legacy, TEXT_KINDS, TEXT_KINDS_ALL, TabsMenu, Text, TextWithLink, ToggleSwitch, UsabillaWidget, areStringsEqualCaseInsensitive, buildDeliveryTextForModelSection, camelCaseToUpperUnderscore, cleanModelName, convertLineHeightToNumber, createUseLabelsHook, createUseLabelsHookFromStore, dynatrace, extendedPhoneValidation, filterPacksOrServices, formatAddress, formatDealerAddress, formatDealerCity, formatDualCurrencyFinancePrice, formatInsuranceData, formatPriceValue, getAggregatorBaseUrl, getBrand, getBreakpointInfo, getCCISImageSrc, getCPLabels, getCalculatedPrice, getCalculatedSecondaryPrice, getCarType, getCheckoutNextSteps, getCombinedDualCurrencyPrices, getConfirmationText, getCssVarValue, getCultureIdentifier, getDxpNavHeight, getEcoLabelValuesFromLead, getElementPositionOnDocument, getExtendedPhoneNumberWithDial, getFinanceOption, getFixedElementsHeightSum, getGatewayP0BaseUrl, getLeadBuildUrl, getLeadPersonalCode, getLeadToyotaCode, getLosBaseUrl, getModel, getOnlineRetailingDealerServices, getPreferredDealerFromStorage, getReservationFee, getRetailerId, getSSOBaseUrl, getServicesFromServiceData, getTypographyStyles, getUsedCarProducts, getUserCountryCode, getUserEmail, getUserLanguageCode, getUserMdmId, getUserToken, getUserTokenExpiration, getUserUUID, getValueFromHash, getViewPortBottomPosition, getWrappedLabel, goToTopOfMaterialBox, handleRedirection, hasValidEcoLabelRating, injectDealerFinder, isActiveBasketOrder, isAllianceBrand, isBzModel, isDeployedInAuthor, isDeployedInAuthorProd, isDeployedInDxp, isDeployedInL1, isDeployedInLexus, isDeployedInT1, isDxpLexus, isDxpToyota, isEdgeBrowser, isFormattedPrice, isImageCached, isLeasingOrder, isLexusBrand, isLightColor, isLocalHost, isLoggedIn, isMobileBreakpoint, isMonthlyReservation, isNewCars, isProduction, isStockCarInHub, isStockCars, isTmefEnabled, isToyotaBrand, isUsedCars, isUsedOrStockCars, isUserTokenExpired, logMessageOnDebugMode, monitorLoadingTime, normalizeExtraCosts, replaceOpeningPlaceholder, replacePlaceholders, replacePlaceholdersByAnchorTag, scrollToElement, setQueryStringParam, shouldDisplayPriceElement, shouldDisplayTaxation, statusCodeToServerErrorMessage, stringToBool, url, useBreakpointChange, useDxpNavigationChange, useIsElementOnScreen, usePreviousValue, useViewportChange, wrapFallbackLabel, wrapFallbackLabelsRecursively };
//# sourceMappingURL=index.esm.js.map
